// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/cjs.js!./design-tokens.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("images/ui-icons_777777_256x240.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("images/ui-icons_444444_256x240.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/gif;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("images/ui-icons_ffffff_256x240.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("images/ui-icons_cc0000_256x240.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("images/ui-icons_777620_256x240.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("images/ui-icons_555555_256x240.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kTtIw1AUhv+mFUUqDmYQcchQnSyILxylikWwUNoKrTqY3PQFTRqSFBdHwbXg4GOx6uDirKuDqyAIPkBcXZwUXaTEc5NCixgvHO7Hf+//c+65gNCoMM0KjQOabpupeEzK5lal7leEIVJNIyQzy0ikFzPwXV/3CPD9Lsqz/O/9ufrUvMWAgEQ8xwzTJt4gntm0Dc77xCIrySrxOfGYSQ0SP3Jd8fiNc9FlgWeKZiY1TywSS8UOVjqYlUyNeIo4omo65QtZj1XOW5y1So21+uQvDOf1lTTXqYYRxxISSEKCghrKqMBGlHadFAspOo/5+Idcf5JcCrnKYORYQBUaZNcP/ge/Z2sVJie8pHAM6HpxnI8RoHsXaNYd5/vYcZonQPAZuNLb/moDmP0kvd7WIkdA/zZwcd3WlD3gcgcYfDJkU3alIJVQKADvZ/RNOWDgFuhd8+bWOsfpA5ChWS3fAAeHwGiRstd93t3TObd/77Tm9wOOiHKymlTPuAAAAAZiS0dEAM4AowCKeTVkwgAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB+cMFAw5A0OJiTcAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAB20lEQVRYw+2WvU4bURCFv7m2NpUlaiSngcLF2hLOG0BHYb9ACoqkg44+ovcjWIKCF7ALOvIGBuKlSBGaIFEjucoK30kRW4p8Z9e7xJKR4ml35tzZM2d+YGP/u0kZ5zjRuqR0BQ5RdlTYBhDlCeFB4UojBvdNeVxpAns3uj31nCl8Kgjarzi+3Lbl6Z8TaN1oRz2XQK0kuxNxfBy3ZZjn5PI+Nkd6rJ7BKx4HqKln0Bzp8asYmP35YCVCc3SzmJCsmr94vmf8+cRBTyoMtyJ+ADyn7OqUjofTrJiqo2FpomolMPWcWUAifPURR99Cld8Bd3Gi5y7lQpX9xXLMMD8vZSBOtC6/+Gk9Pv4gB0Uob4302kgCfcf7xRYNRCgpXYtCH3FUtOYz30kRbGdQcmg49coMl/umPDroFcRe5ImdILDCsLTyrRgDO0hgPl7/trnay5gVY2G7dS+jUANK0KvPKbtlga0YC9sZo+khoG5Kp2wCZoyBHWoAroK2gtM40XqZtT2bikuxwwQic/7XXMpF4br+8a0VwXZWDwv0g2BlvzXS6zwm4kTrWVNQoG/NkrUvo7Wv48w5MG7LEOFkBVfnSd5V9LZPsjkTVUfDEmbeUVp1NJY9/ibO8o1t7Ddz5991OpoAtwAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kTtIw1AUhv+mFUUqDmYQcchQnSyILxylikWwUNoKrTqY3PQFTRqSFBdHwbXg4GOx6uDirKuDqyAIPkBcXZwUXaTEc5NCixgvHO7Hf+//c+65gNCoMM0KjQOabpupeEzK5lal7leEIVJNIyQzy0ikFzPwXV/3CPD9Lsqz/O/9ufrUvMWAgEQ8xwzTJt4gntm0Dc77xCIrySrxOfGYSQ0SP3Jd8fiNc9FlgWeKZiY1TywSS8UOVjqYlUyNeIo4omo65QtZj1XOW5y1So21+uQvDOf1lTTXqYYRxxISSEKCghrKqMBGlHadFAspOo/5+Idcf5JcCrnKYORYQBUaZNcP/ge/Z2sVJie8pHAM6HpxnI8RoHsXaNYd5/vYcZonQPAZuNLb/moDmP0kvd7WIkdA/zZwcd3WlD3gcgcYfDJkU3alIJVQKADvZ/RNOWDgFuhd8+bWOsfpA5ChWS3fAAeHwGiRstd93t3TObd/77Tm9wOOiHKymlTPuAAAAAZiS0dEAM4AowCKeTVkwgAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB+cMFAw4OOuZUVIAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAA5UlEQVRYw+2VLRKDMBCF3zYShcMhepMimKlhisBhcggOwSEwuIoyNcxUlJsg4nAoJJOKUtefTScdKvLpvOzLvp0N4HA4HCtDpoLhknvteCgISDT09n4J9Ro47/2mDOJ6+pmB6njaYdYVgPDFEQVBUmZpZ93AUvzKOiwo4prYcNu+vJzHrKvhknvWDLTjoXjT9meEi8aOAQKSL6Y7sWbgMe0mcDWbtfcAMwLqzSPgaZgR4GweAU/DMrD3mxKAMqivFo0dA0FcTxAk2eUFSe5KZg+hzNIOgqIPnVAmW/AvPiOHw+FYnRsr7lD5IAODJgAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kTtIw1AUhv+mFUUqDmYQcchQnSyILxylikWwUNoKrTqY3PQFTRqSFBdHwbXg4GOx6uDirKuDqyAIPkBcXZwUXaTEc5NCixgvHO7Hf+//c+65gNCoMM0KjQOabpupeEzK5lal7leEIVJNIyQzy0ikFzPwXV/3CPD9Lsqz/O/9ufrUvMWAgEQ8xwzTJt4gntm0Dc77xCIrySrxOfGYSQ0SP3Jd8fiNc9FlgWeKZiY1TywSS8UOVjqYlUyNeIo4omo65QtZj1XOW5y1So21+uQvDOf1lTTXqYYRxxISSEKCghrKqMBGlHadFAspOo/5+Idcf5JcCrnKYORYQBUaZNcP/ge/Z2sVJie8pHAM6HpxnI8RoHsXaNYd5/vYcZonQPAZuNLb/moDmP0kvd7WIkdA/zZwcd3WlD3gcgcYfDJkU3alIJVQKADvZ/RNOWDgFuhd8+bWOsfpA5ChWS3fAAeHwGiRstd93t3TObd/77Tm9wOOiHKymlTPuAAAAAZiS0dEAM4AowCKeTVkwgAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB+cMFAw5JOaDPFwAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAA0UlEQVRYw+3WSw7DIAwEUKbppVi1R+vR0lWORbdVgj9jsKpKeImwo3kiJKWsWvXjwnmh1bqX1h45T8Mbx/H8XrpdNm3bKy1uZzZ6+1IUOun7AlkKwkxI+6cqCOllgdkKyixofVMUlPS6wCwFYwas/iEFI70tMKrg6IVnTkjBkd4nEFVw9sA7j1JwpvcLsArEXjCqLgUiPSfgTUaeF7BnS1Ug0/MCVsLA24LI/dJVCKSPCUhJgzdmSOCiEEwfFzgnzvyPtBRarfvIjHvmt37VX9QHmaFdkiJXncIAAAAASUVORK5CYII=", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kTtIw1AUhv+mFUUqDmYQcchQnSyILxylikWwUNoKrTqY3PQFTRqSFBdHwbXg4GOx6uDirKuDqyAIPkBcXZwUXaTEc5NCixgvHO7Hf+//c+65gNCoMM0KjQOabpupeEzK5lal7leEIVJNIyQzy0ikFzPwXV/3CPD9Lsqz/O/9ufrUvMWAgEQ8xwzTJt4gntm0Dc77xCIrySrxOfGYSQ0SP3Jd8fiNc9FlgWeKZiY1TywSS8UOVjqYlUyNeIo4omo65QtZj1XOW5y1So21+uQvDOf1lTTXqYYRxxISSEKCghrKqMBGlHadFAspOo/5+Idcf5JcCrnKYORYQBUaZNcP/ge/Z2sVJie8pHAM6HpxnI8RoHsXaNYd5/vYcZonQPAZuNLb/moDmP0kvd7WIkdA/zZwcd3WlD3gcgcYfDJkU3alIJVQKADvZ/RNOWDgFuhd8+bWOsfpA5ChWS3fAAeHwGiRstd93t3TObd/77Tm9wOOiHKymlTPuAAAAAZiS0dEAM4AowCKeTVkwgAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB+cMFAw5HM6BhMIAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAPklEQVRYw2NgGAUjHTCiC/x5YfWflhaySBxDsZNpoENg1AGjDhh1wKgDRh0w6oBRB4w6YNQBow4YdcAoGAUAZVMEMGAOxt0AAAAASUVORK5CYII=", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kTtIw1AUhv+mFUUqDmYQcchQnSyILxylikWwUNoKrTqY3PQFTRqSFBdHwbXg4GOx6uDirKuDqyAIPkBcXZwUXaTEc5NCixgvHO7Hf+//c+65gNCoMM0KjQOabpupeEzK5lal7leEIVJNIyQzy0ikFzPwXV/3CPD9Lsqz/O/9ufrUvMWAgEQ8xwzTJt4gntm0Dc77xCIrySrxOfGYSQ0SP3Jd8fiNc9FlgWeKZiY1TywSS8UOVjqYlUyNeIo4omo65QtZj1XOW5y1So21+uQvDOf1lTTXqYYRxxISSEKCghrKqMBGlHadFAspOo/5+Idcf5JcCrnKYORYQBUaZNcP/ge/Z2sVJie8pHAM6HpxnI8RoHsXaNYd5/vYcZonQPAZuNLb/moDmP0kvd7WIkdA/zZwcd3WlD3gcgcYfDJkU3alIJVQKADvZ/RNOWDgFuhd8+bWOsfpA5ChWS3fAAeHwGiRstd93t3TObd/77Tm9wOOiHKymlTPuAAAAAZiS0dEAM4AowCKeTVkwgAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB+cMFAw5C01SAQUAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAABd0lEQVRYw+2WsWoCQRCGv1m5K0R8gAhpbHyXgJhCOLDLAwi+wT2I2AUEC0W4d0ljEzC9IhYe7qS5NHHPPfWOCHHqZf5/vllmBh7x30Muedzf06ql9BRegLYqTwAifAErgeQYsJjVWZdqoL+nZQ7EKryhGE9GK8rEhsRFjHgNRFu61vIONC6kuzOGwbTJ8tyjs9VEG4ZWmV8hDtCwyjzaMLyKQLSla5W5F7mfsTXCax4Jyeu5HPi4snJnOzSk4/oTzurMgbhEcYBGltNPoL+nJSmfN6N3tEIDnn9TOBGppfRKFwdQTC2l521BNmQqCVduV6XtCidv208gG6+VEHDkNvxxnBjIFks1m8+R20VgVWHBKz8BSCrc/YnXwDFggWArULfHgIXXwKzOWpRJ6frKpPAusCExsCtRf5flLHYPzOqsjWFQSisEawyDvOsodw5MmywNjG4yIVgDo3NX0X2fZD8kNKQjMC5EQ7ACYw3p+MTv4ix/xCO+AfaWiX0YOWcHAAAAAElFTkSuQmCC", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Common CSS Rules - Extracted from style.css, style.celestrak.css, and style.embed.css */


/* ========== CSS Custom Properties (Variables) ========== */

:root {
  --bottom-menu-top: 0px;
  --bottom-icon-height: 75px;
  --bottom-icon-width: 115px;
  --bottom-icon-img-size: 40px;
  --bottom-filter-width: 265px;
  --bottom-utility-width: 300px;
  --search-box-bottom: 0px;
  --nav-bar-height: 50px;

  --top-menu-height: calc(var(--nav-bar-height) + var(--classification-bar-height) + var(--time-slider-height));

  --classification-bar-height: 0px;

  --time-slider-height: 0px;

  /* Breakpoints (for JS access - CSS @media can't use custom properties) */
  --bp-mobile: 694px;
  /* mobile: max-width 694px */
  --bp-tablet: 1300px;
  /* tablet: 695px–1300px */
  /* desktop: min-width 1301px */
}


/* ========== HTML and Body Styles ========== */

body {
  overflow: hidden;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: var(--color-dark-text-accent);
}

input,
textarea {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}


/* ========== jQuery UI Components ========== */

#ui-datepicker-div {
  border: none;
  top: var(--top-menu-height);
  left: 0px;
  width: 100%;
  border-radius: 0px;
}

.ui-accordion .ui-accordion-content {
  padding: 1em 2.2em;
  border-top: 0;
  overflow: auto;
}

.ui-accordion .ui-accordion-header {
  display: block;
  cursor: pointer;
  position: relative;
  margin: 2px 0 0 0;
  padding: 0.5em 0.5em 0.5em 0.7em;
  font-size: 100%;
}

.ui-autocomplete {
  position: absolute;
  top: 0;
  left: 0;
  cursor: default;
}

.ui-button {
  border: 1px solid var(--colorTertiary);
  background: var(--colorTertiary);
  padding: 0.4em 1em;
  display: inline-block;
  position: relative;
  line-height: normal;
  margin-right: 0.1em;
  cursor: pointer;
  vertical-align: middle;
  text-align: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  overflow: visible;
}

.ui-button .ui-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.ui-button span {
  filter: brightness(5);
}

.ui-button,
.ui-button:link,
.ui-button:visited,
.ui-button:hover,
.ui-button:active {
  text-decoration: none;
}

.ui-button-icon-only {
  width: 2em;
  box-sizing: border-box;
  text-indent: -9999px;
  white-space: nowrap;
}

.ui-button-icon-only .ui-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -8px;
  margin-left: -8px;
}

.ui-button.ui-icon-notext .ui-icon {
  padding: 0;
  width: 2.1em;
  height: 2.1em;
  text-indent: -9999px;
  white-space: nowrap;
}

.ui-checkboxradio-disabled {
  pointer-events: none;
}

.ui-checkboxradio-label .ui-icon-background {
  box-shadow: inset 1px 1px 1px #ccc;
  border-radius: 0.12em;
  border: none;
}

.ui-checkboxradio-radio-label .ui-icon-background {
  width: 16px;
  height: 16px;
  border-radius: 1em;
  overflow: visible;
  border: none;
}

.ui-checkboxradio-radio-label.ui-checkboxradio-checked .ui-icon,
.ui-checkboxradio-radio-label.ui-checkboxradio-checked:hover .ui-icon {
  background-image: none;
  width: 8px;
  height: 8px;
  border-width: 4px;
  border-style: solid;
}

.ui-controlgroup {
  vertical-align: middle;
  display: inline-block;
}

.ui-controlgroup .ui-controlgroup-label {
  padding: 0.4em 1em;
}

.ui-controlgroup .ui-controlgroup-label span {
  font-size: 80%;
}

.ui-controlgroup-horizontal .ui-controlgroup-label+.ui-controlgroup-item {
  border-left: none;
}

.ui-controlgroup-horizontal .ui-controlgroup-label.ui-widget-content {
  border-right: none;
}

.ui-controlgroup-vertical .ui-controlgroup-item {
  box-sizing: border-box;
}

.ui-controlgroup-vertical .ui-controlgroup-label+.ui-controlgroup-item {
  border-top: none;
}

.ui-controlgroup-vertical .ui-controlgroup-label.ui-widget-content {
  border-bottom: none;
}

.ui-controlgroup-vertical .ui-spinner .ui-spinner-up {
  border-top-style: solid;
}

.ui-controlgroup-vertical .ui-spinner-input {
  width: 75%;
  width: calc(100% - 2.4em);
}

.ui-controlgroup-vertical>.ui-controlgroup-item {
  display: block;
  float: none;
  width: 100%;
  margin-top: 0;
  margin-bottom: 0;
  text-align: left;
}

.ui-controlgroup>.ui-controlgroup-item {
  float: left;
  margin-left: 0;
  margin-right: 0;
}

.ui-controlgroup>.ui-controlgroup-item:focus,
.ui-controlgroup>.ui-controlgroup-item.ui-visual-focus {
  z-index: 9999;
}

.ui-corner-all,
.ui-corner-bottom,
.ui-corner-left,
.ui-corner-bl {
  border-bottom-left-radius: 3px;
}

.ui-corner-all,
.ui-corner-bottom,
.ui-corner-right,
.ui-corner-br {
  border-bottom-right-radius: 3px;
}

.ui-corner-all,
.ui-corner-top,
.ui-corner-left,
.ui-corner-tl {
  border-top-left-radius: 3px;
}

.ui-corner-all,
.ui-corner-top,
.ui-corner-right,
.ui-corner-tr {
  border-top-right-radius: 3px;
}

.ui-datepicker {
  width: 17em;
  padding: 0.2em 0.2em 0;
  display: none;
}

.ui-datepicker .ui-datepicker-buttonpane {
  background-image: none;
  margin: 0.7em 0 0 0;
  padding: 0 0.2em;
  border-left: 0;
  border-right: 0;
  border-bottom: 0;
}

.ui-datepicker .ui-datepicker-buttonpane button {
  float: right;
  margin: 0.5em 0.2em 0.4em;
  cursor: pointer;
  width: auto;
  overflow: visible;
  padding: 1em;
}

.ui-datepicker .ui-datepicker-buttonpane button.ui-datepicker-current {
  float: left;
}

.ui-datepicker .ui-datepicker-buttonpane button.ui-datepicker-pause {
  float: none;
}

.ui-datepicker .ui-datepicker-header {
  position: relative;
  padding: 0.2em 0;
}

.ui-datepicker .ui-datepicker-next {
  right: 2px;
}

.ui-datepicker .ui-datepicker-next-hover {
  right: 1px;
}

.ui-datepicker .ui-datepicker-prev {
  left: 2px;
}

.ui-datepicker .ui-datepicker-prev span,
.ui-datepicker .ui-datepicker-next span {
  display: block;
  position: absolute;
  left: 50%;
  margin-left: -8px;
  top: 50%;
  margin-top: -8px;
}

.ui-datepicker .ui-datepicker-prev,
.ui-datepicker .ui-datepicker-next {
  position: absolute;
  top: 2px;
  width: 1.8em;
  height: 1.8em;
}

.ui-datepicker .ui-datepicker-prev-hover {
  left: 1px;
}

.ui-datepicker .ui-datepicker-prev-hover,
.ui-datepicker .ui-datepicker-next-hover {
  top: 1px;
}

.ui-datepicker .ui-datepicker-title {
  margin: 0 2.3em;
  line-height: 1.8em;
  text-align: center;
}

.ui-datepicker .ui-datepicker-title select {
  font-size: 1em;
  margin: 1px 0;
}

.ui-datepicker .ui-icon {
  display: block;
  text-indent: -99999px;
  overflow: hidden;
  background-repeat: no-repeat;
  left: 0.5em;
  top: 0.3em;
}

.ui-datepicker select.ui-datepicker-month,
.ui-datepicker select.ui-datepicker-year {
  width: 45%;
}

.ui-datepicker table {
  width: 100%;
  font-size: 0.9em;
  border-collapse: collapse;
  margin: 0 0 0.4em;
}

.ui-datepicker td {
  border: 1px solid rgba(0, 0, 0, 0);
  padding: 1px;
}

.ui-datepicker td a {
  padding: 15px 0.2em;
}

.ui-datepicker td span,
.ui-datepicker td a {
  display: block;
  padding: 0.2em;
  text-align: right;
  text-decoration: none;
}

.ui-datepicker th {
  padding: 0.7em 0.3em;
  text-align: center;
  font-weight: normal;
  border: 0;
}

.ui-datepicker-calendar {
  margin-bottom: 0px;
}

.ui-datepicker-calendar tbody tr {
  border: 0px !important;
}

.ui-datepicker-calendar tbody tr td a {
  display: flex;
  font-weight: bold;
  color: var(--color-primary);
  background: var(--color-dark-background);
  border: 1px solid rgba(0, 0, 0, 0);
  height: 45px;
  width: 45px;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
}

.ui-datepicker-calendar tbody tr td a:hover {
  border: 1px solid rgb(230, 230, 230) !important;
  background: rgba(230, 230, 230, 0.15) !important;
  color: var(--colorWhite) !important;
  border-radius: 3px;
}

.ui-datepicker-calendar thead tr {
  border: 0px !important;
}

.ui-datepicker-jday {
  text-align: end;
  width: 100%;
  font-size: smaller;
  font-weight: normal;
  color: var(--colorWhite);
}

.ui-datepicker-multi .ui-datepicker-buttonpane {
  clear: left;
}

.ui-datepicker-multi .ui-datepicker-group {
  float: left;
}

.ui-datepicker-multi .ui-datepicker-group table {
  width: 95%;
  margin: 0 auto 0.4em;
}

.ui-datepicker-multi .ui-datepicker-group-last .ui-datepicker-header,
.ui-datepicker-multi .ui-datepicker-group-middle .ui-datepicker-header {
  border-left-width: 0;
}

.ui-datepicker-multi-2 .ui-datepicker-group {
  width: 50%;
}

.ui-datepicker-multi-3 .ui-datepicker-group {
  width: 33.3%;
}

.ui-datepicker-multi-4 .ui-datepicker-group {
  width: 25%;
}

.ui-datepicker-row-break {
  clear: both;
  width: 100%;
  font-size: 0;
}

.ui-datepicker-rtl {
  direction: rtl;
}

.ui-datepicker-rtl .ui-datepicker-buttonpane {
  clear: right;
}

.ui-datepicker-rtl .ui-datepicker-buttonpane button {
  float: left;
}

.ui-datepicker-rtl .ui-datepicker-buttonpane button.ui-datepicker-current,
.ui-datepicker-rtl .ui-datepicker-group {
  float: right;
}

.ui-datepicker-rtl .ui-datepicker-group-last .ui-datepicker-header,
.ui-datepicker-rtl .ui-datepicker-group-middle .ui-datepicker-header {
  border-right-width: 0;
  border-left-width: 1px;
}

.ui-datepicker-rtl .ui-datepicker-next {
  left: 2px;
  right: auto;
}

.ui-datepicker-rtl .ui-datepicker-next:hover {
  left: 1px;
  right: auto;
}

.ui-datepicker-rtl .ui-datepicker-prev {
  right: 2px;
  left: auto;
}

.ui-datepicker-rtl .ui-datepicker-prev:hover {
  right: 1px;
  left: auto;
}

.ui-datepicker.ui-datepicker-multi {
  width: auto;
}

.ui-dialog {
  position: absolute;
  top: 0;
  left: 0;
  padding: 0.2em;
  outline: 0;
}

.ui-dialog .ui-dialog-buttonpane {
  text-align: left;
  border-width: 1px 0 0 0;
  background-image: none;
  margin-top: 0.5em;
  padding: 0.3em 1em 0.5em 0.4em;
}

.ui-dialog .ui-dialog-buttonpane .ui-dialog-buttonset {
  float: right;
}

.ui-dialog .ui-dialog-buttonpane button {
  margin: 0.5em 0.4em 0.5em 0;
  cursor: pointer;
}

.ui-dialog .ui-dialog-content {
  position: relative;
  border: 0;
  padding: 0.5em 1em;
  background: none;
  overflow: auto;
}

.ui-dialog .ui-dialog-title {
  float: left;
  margin: 0.1em 0;
  white-space: nowrap;
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ui-dialog .ui-dialog-titlebar {
  padding: 0.4em 1em;
  position: relative;
}

.ui-dialog .ui-dialog-titlebar-close {
  position: absolute;
  right: 0.3em;
  top: 50%;
  width: 20px;
  margin: -10px 0 0 0;
  padding: 1px;
  height: 20px;
}

.ui-dialog .ui-resizable-e {
  width: 2px;
  right: 0;
}

.ui-dialog .ui-resizable-n {
  height: 2px;
  top: 0;
}

.ui-dialog .ui-resizable-ne {
  right: 0;
  top: 0;
}

.ui-dialog .ui-resizable-nw {
  left: 0;
  top: 0;
}

.ui-dialog .ui-resizable-s {
  height: 2px;
  bottom: 0;
}

.ui-dialog .ui-resizable-se {
  right: 0;
  bottom: 0;
}

.ui-dialog .ui-resizable-se,
.ui-dialog .ui-resizable-sw,
.ui-dialog .ui-resizable-ne,
.ui-dialog .ui-resizable-nw {
  width: 7px;
  height: 7px;
}

.ui-dialog .ui-resizable-sw {
  left: 0;
  bottom: 0;
}

.ui-dialog .ui-resizable-w {
  width: 2px;
  left: 0;
}

.ui-draggable .ui-dialog-titlebar {
  cursor: move;
}

.ui-draggable-handle {
  -ms-touch-action: none;
  touch-action: none;
}

.ui-front {
  z-index: 100;
}

.ui-helper-clearfix:after {
  clear: both;
}

.ui-helper-clearfix:before,
.ui-helper-clearfix:after {
  content: '';
  display: table;
  border-collapse: collapse;
}

.ui-helper-hidden {
  display: none;
}

.ui-helper-hidden-accessible {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.ui-helper-reset {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  line-height: 1.3;
  text-decoration: none;
  font-size: 100%;
  list-style: none;
}

.ui-helper-zfix {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
  opacity: 0;
  filter: Alpha(Opacity=0);
}

.ui-icon {
  display: inline-block;
  vertical-align: middle;
  margin-top: -0.25em;
  position: relative;
  text-indent: -99999px;
  overflow: hidden;
  background-repeat: no-repeat;
  width: 16px;
  height: 16px;
}

.ui-icon,
.ui-widget-content .ui-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.ui-icon-alert {
  background-position: 0 -144px;
}

.ui-icon-arrow-1-e {
  background-position: -32px -32px;
}

.ui-icon-arrow-1-n {
  background-position: 0 -32px;
}

.ui-icon-arrow-1-ne {
  background-position: -16px -32px;
}

.ui-icon-arrow-1-nw {
  background-position: -112px -32px;
}

.ui-icon-arrow-1-s {
  background-position: -65px -32px;
}

.ui-icon-arrow-1-se {
  background-position: -48px -32px;
}

.ui-icon-arrow-1-sw {
  background-position: -80px -32px;
}

.ui-icon-arrow-1-w {
  background-position: -96px -32px;
}

.ui-icon-arrow-2-e-w {
  background-position: -160px -32px;
}

.ui-icon-arrow-2-n-s {
  background-position: -128px -32px;
}

.ui-icon-arrow-2-ne-sw {
  background-position: -144px -32px;
}

.ui-icon-arrow-2-se-nw {
  background-position: -176px -32px;
}

.ui-icon-arrow-4 {
  background-position: 0 -80px;
}

.ui-icon-arrow-4-diag {
  background-position: -16px -80px;
}

.ui-icon-arrowrefresh-1-e {
  background-position: -160px -64px;
}

.ui-icon-arrowrefresh-1-n {
  background-position: -144px -64px;
}

.ui-icon-arrowrefresh-1-s {
  background-position: -176px -64px;
}

.ui-icon-arrowrefresh-1-w {
  background-position: -128px -64px;
}

.ui-icon-arrowreturn-1-e {
  background-position: -96px -64px;
}

.ui-icon-arrowreturn-1-n {
  background-position: -80px -64px;
}

.ui-icon-arrowreturn-1-s {
  background-position: -112px -64px;
}

.ui-icon-arrowreturn-1-w {
  background-position: -64px -64px;
}

.ui-icon-arrowreturnthick-1-e {
  background-position: -32px -64px;
}

.ui-icon-arrowreturnthick-1-n {
  background-position: -16px -64px;
}

.ui-icon-arrowreturnthick-1-s {
  background-position: -48px -64px;
}

.ui-icon-arrowreturnthick-1-w {
  background-position: 0 -64px;
}

.ui-icon-arrowstop-1-e {
  background-position: -208px -32px;
}

.ui-icon-arrowstop-1-n {
  background-position: -192px -32px;
}

.ui-icon-arrowstop-1-s {
  background-position: -224px -32px;
}

.ui-icon-arrowstop-1-w {
  background-position: -240px -32px;
}

.ui-icon-arrowthick-1-e {
  background-position: -32px -48px;
}

.ui-icon-arrowthick-1-n {
  background-position: 1px -48px;
}

.ui-icon-arrowthick-1-ne {
  background-position: -16px -48px;
}

.ui-icon-arrowthick-1-nw {
  background-position: -112px -48px;
}

.ui-icon-arrowthick-1-s {
  background-position: -64px -48px;
}

.ui-icon-arrowthick-1-se {
  background-position: -48px -48px;
}

.ui-icon-arrowthick-1-sw {
  background-position: -80px -48px;
}

.ui-icon-arrowthick-1-w {
  background-position: -96px -48px;
}

.ui-icon-arrowthick-2-e-w {
  background-position: -160px -48px;
}

.ui-icon-arrowthick-2-n-s {
  background-position: -128px -48px;
}

.ui-icon-arrowthick-2-ne-sw {
  background-position: -144px -48px;
}

.ui-icon-arrowthick-2-se-nw {
  background-position: -176px -48px;
}

.ui-icon-arrowthickstop-1-e {
  background-position: -208px -48px;
}

.ui-icon-arrowthickstop-1-n {
  background-position: -192px -48px;
}

.ui-icon-arrowthickstop-1-s {
  background-position: -224px -48px;
}

.ui-icon-arrowthickstop-1-w {
  background-position: -240px -48px;
}

.ui-icon-background,
.ui-state-active .ui-icon-background {
  border: #003eff;
  background-color: #fff;
}

.ui-icon-battery-0 {
  background-position: -48px -176px;
}

.ui-icon-battery-1 {
  background-position: -64px -176px;
}

.ui-icon-battery-2 {
  background-position: -80px -176px;
}

.ui-icon-battery-3 {
  background-position: -96px -176px;
}

.ui-icon-blank {
  background-position: 16px 16px;
}

.ui-icon-bookmark {
  background-position: -224px -96px;
}

.ui-icon-bullet {
  background-position: -80px -144px;
}

.ui-icon-calculator {
  background-position: -112px -112px;
}

.ui-icon-calendar {
  background-position: -32px -112px;
}

.ui-icon-cancel {
  background-position: 0 -128px;
}

.ui-icon-caret-1-e {
  background-position: -32px 0;
}

.ui-icon-caret-1-n {
  background-position: 0 0;
}

.ui-icon-caret-1-ne {
  background-position: -16px 0;
}

.ui-icon-caret-1-nw {
  background-position: -112px 0;
}

.ui-icon-caret-1-s {
  background-position: -65px 0;
}

.ui-icon-caret-1-se {
  background-position: -48px 0;
}

.ui-icon-caret-1-sw {
  background-position: -80px 0;
}

.ui-icon-caret-1-w {
  background-position: -96px 0;
}

.ui-icon-caret-2-e-w {
  background-position: -144px 0;
}

.ui-icon-caret-2-n-s {
  background-position: -128px 0;
}

.ui-icon-cart {
  background-position: -48px -112px;
}

.ui-icon-check {
  background-position: -64px -144px;
}

.ui-icon-circle-arrow-e {
  background-position: -112px -192px;
}

.ui-icon-circle-arrow-n {
  background-position: -160px -192px;
}

.ui-icon-circle-arrow-s {
  background-position: -128px -192px;
}

.ui-icon-circle-arrow-w {
  background-position: -144px -192px;
}

.ui-icon-circle-check {
  background-position: -208px -192px;
}

.ui-icon-circle-close {
  background-position: -32px -192px;
}

.ui-icon-circle-minus {
  background-position: -16px -192px;
}

.ui-icon-circle-plus {
  background-position: 0 -192px;
}

.ui-icon-circle-triangle-n {
  background-position: -96px -192px;
}

.ui-icon-circle-triangle-s {
  background-position: -64px -192px;
}

.ui-icon-circle-zoomin {
  background-position: -176px -192px;
}

.ui-icon-circle-zoomout {
  background-position: -192px -192px;
}

.ui-icon-circlesmall-close {
  background-position: -32px -208px;
}

.ui-icon-circlesmall-minus {
  background-position: -16px -208px;
}

.ui-icon-circlesmall-plus {
  background-position: 0 -208px;
}

.ui-icon-clipboard {
  background-position: -160px -128px;
}

.ui-icon-clock {
  background-position: -80px -112px;
}

.ui-icon-close {
  background-position: -80px -128px;
}

.ui-icon-closethick {
  background-position: -96px -128px;
}

.ui-icon-comment {
  background-position: -128px -96px;
}

.ui-icon-contact {
  background-position: -192px -128px;
}

.ui-icon-copy {
  background-position: -176px -128px;
}

.ui-icon-disk {
  background-position: -96px -112px;
}

.ui-icon-document {
  background-position: -32px -96px;
}

.ui-icon-document-b {
  background-position: -48px -96px;
}

.ui-icon-eject {
  background-position: -112px -160px;
}

.ui-icon-extlink {
  background-position: -32px -80px;
}

.ui-icon-flag {
  background-position: -16px -112px;
}

.ui-icon-folder-collapsed {
  background-position: 0 -96px;
}

.ui-icon-folder-open {
  background-position: -16px -96px;
}

.ui-icon-gear {
  background-position: -192px -112px;
}

.ui-icon-grip-diagonal-se {
  background-position: -80px -224px;
}

.ui-icon-grip-dotted-horizontal {
  background-position: -16px -224px;
}

.ui-icon-grip-dotted-vertical {
  background-position: 0 -224px;
}

.ui-icon-grip-solid-horizontal {
  background-position: -48px -224px;
}

.ui-icon-grip-solid-vertical {
  background-position: -32px -224px;
}

.ui-icon-gripsmall-diagonal-se {
  background-position: -64px -224px;
}

.ui-icon-heart {
  background-position: -208px -112px;
}

.ui-icon-help {
  background-position: -48px -144px;
}

.ui-icon-home {
  background-position: 0 -112px;
}

.ui-icon-image {
  background-position: -208px -128px;
}

.ui-icon-info {
  background-position: -16px -144px;
}

.ui-icon-key {
  background-position: -112px -128px;
}

.ui-icon-lightbulb {
  background-position: -128px -128px;
}

.ui-icon-link {
  background-position: -240px -112px;
}

.ui-icon-locked {
  background-position: -192px -96px;
}

.ui-icon-mail-closed {
  background-position: -80px -96px;
}

.ui-icon-mail-open {
  background-position: -96px -96px;
}

.ui-icon-minus {
  background-position: -48px -128px;
}

.ui-icon-minusthick {
  background-position: -64px -128px;
}

.ui-icon-newwin {
  background-position: -48px -80px;
}

.ui-icon-note {
  background-position: -64px -96px;
}

.ui-icon-notice {
  background-position: -32px -144px;
}

.ui-icon-pause {
  background-position: -16px -160px;
}

.ui-icon-pencil {
  background-position: -64px -112px;
}

.ui-icon-person {
  background-position: -144px -96px;
}

.ui-icon-pin-s {
  background-position: -144px -144px;
}

.ui-icon-pin-w {
  background-position: -128px -144px;
}

.ui-icon-play {
  background-position: 0 -160px;
}

.ui-icon-plus {
  background-position: -16px -128px;
}

.ui-icon-plusthick {
  background-position: -32px -128px;
}

.ui-icon-power {
  background-position: 0 -176px;
}

.ui-icon-print {
  background-position: -160px -96px;
}

.ui-icon-radio-off {
  background-position: -112px -144px;
}

.ui-icon-radio-on {
  background-position: -96px -144px;
}

.ui-icon-refresh {
  background-position: -64px -80px;
}

.ui-icon-scissors {
  background-position: -144px -128px;
}

.ui-icon-script {
  background-position: -240px -128px;
}

.ui-icon-search {
  background-position: -160px -112px;
}

.ui-icon-seek-end {
  background-position: -64px -160px;
}

.ui-icon-seek-first {
  background-position: -80px -160px;
}

.ui-icon-seek-next {
  background-position: -32px -160px;
}

.ui-icon-seek-prev {
  background-position: -48px -160px;
}

.ui-icon-seek-start {
  background-position: -80px -160px;
}

.ui-icon-shuffle {
  background-position: -80px -80px;
}

.ui-icon-signal {
  background-position: -32px -176px;
}

.ui-icon-signal-diag {
  background-position: -16px -176px;
}

.ui-icon-squaresmall-close {
  background-position: -80px -208px;
}

.ui-icon-squaresmall-minus {
  background-position: -64px -208px;
}

.ui-icon-squaresmall-plus {
  background-position: -48px -208px;
}

.ui-icon-star {
  background-position: -224px -112px;
}

.ui-icon-stop {
  background-position: -96px -160px;
}

.ui-icon-suitcase {
  background-position: -112px -96px;
}

.ui-icon-tag {
  background-position: -240px -96px;
}

.ui-icon-transfer-e-w {
  background-position: -96px -80px;
}

.ui-icon-transferthick-e-w {
  background-position: -112px -80px;
}

.ui-icon-trash {
  background-position: -176px -96px;
}

.ui-icon-triangle-1-e {
  background-position: -32px -16px;
}

.ui-icon-triangle-1-n {
  background-position: 0 -16px;
}

.ui-icon-triangle-1-ne {
  background-position: -16px -16px;
}

.ui-icon-triangle-1-nw {
  background-position: -112px -16px;
}

.ui-icon-triangle-1-s {
  background-position: -65px -16px;
}

.ui-icon-triangle-1-se {
  background-position: -48px -16px;
}

.ui-icon-triangle-1-sw {
  background-position: -80px -16px;
}

.ui-icon-triangle-1-w {
  background-position: -96px -16px;
}

.ui-icon-triangle-2-e-w {
  background-position: -144px -16px;
}

.ui-icon-triangle-2-n-s {
  background-position: -128px -16px;
}

.ui-icon-unlocked {
  background-position: -208px -96px;
}

.ui-icon-video {
  background-position: -224px -128px;
}

.ui-icon-volume-off {
  background-position: -128px -160px;
}

.ui-icon-volume-on {
  background-position: -144px -160px;
}

.ui-icon-wrench {
  background-position: -176px -112px;
}

.ui-icon-zoomin {
  background-position: -128px -112px;
}

.ui-icon-zoomout {
  background-position: -144px -112px;
}

.ui-menu {
  list-style: none;
  padding: 0;
  margin: 0;
  display: block;
  outline: 0;
}

.ui-menu .ui-icon {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0.2em;
  margin: auto 0;
}

.ui-menu .ui-menu {
  position: absolute;
}

.ui-menu .ui-menu-divider {
  margin: 5px 0;
  height: 0;
  font-size: 0;
  line-height: 0;
  border-width: 1px 0 0 0;
}

.ui-menu .ui-menu-icon {
  left: auto;
  right: 0;
}

.ui-menu .ui-menu-item {
  margin: 0;
  cursor: pointer;
  list-style-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.ui-menu .ui-menu-item-wrapper {
  position: relative;
  padding: 3px 1em 3px 0.4em;
}

.ui-menu .ui-state-focus,
.ui-menu .ui-state-active {
  margin: -1px;
}

.ui-menu-icons {
  position: relative;
}

.ui-menu-icons .ui-menu-item-wrapper {
  padding-left: 2em;
}

.ui-priority-primary,
.ui-widget-content .ui-priority-primary,
.ui-widget-header .ui-priority-primary {
  font-weight: bold;
}

.ui-priority-secondary {
  font-weight: bold !important;
  opacity: 1 !important;
}

.ui-priority-secondary,
.ui-widget-content .ui-priority-secondary,
.ui-widget-header .ui-priority-secondary {
  opacity: 0.7;
  filter: Alpha(Opacity=70);
  font-weight: normal;
}

.ui-progressbar {
  height: 2em;
  text-align: left;
  overflow: hidden;
}

.ui-progressbar .ui-progressbar-overlay {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  height: 100%;
  filter: alpha(opacity=25);
  opacity: 0.25;
}

.ui-progressbar .ui-progressbar-value {
  margin: -1px;
  height: 100%;
}

.ui-progressbar-indeterminate .ui-progressbar-value {
  background-image: none;
}

.ui-resizable {
  position: relative;
}

.ui-resizable-disabled .ui-resizable-handle,
.ui-resizable-autohide .ui-resizable-handle {
  display: none;
}

.ui-resizable-e {
  cursor: e-resize;
  width: 7px;
  right: -5px;
  top: 0;
  height: 100%;
}

.ui-resizable-handle {
  position: absolute;
  font-size: 0.1px;
  display: block;
  -ms-touch-action: none;
  touch-action: none;
}

.ui-resizable-n {
  cursor: n-resize;
  height: 7px;
  width: 100%;
  top: -5px;
  left: 0;
}

.ui-resizable-ne {
  cursor: ne-resize;
  width: 9px;
  height: 9px;
  right: -5px;
  top: -5px;
}

.ui-resizable-nw {
  cursor: nw-resize;
  width: 9px;
  height: 9px;
  left: -5px;
  top: -5px;
}

.ui-resizable-s {
  cursor: s-resize;
  height: 7px;
  width: 100%;
  bottom: -5px;
  left: 0;
}

.ui-resizable-se {
  cursor: se-resize;
  width: 12px;
  height: 12px;
  right: 1px;
  bottom: 1px;
}

.ui-resizable-sw {
  cursor: sw-resize;
  width: 9px;
  height: 9px;
  left: -5px;
  bottom: -5px;
}

.ui-resizable-w {
  cursor: w-resize;
  width: 7px;
  left: -5px;
  top: 0;
  height: 100%;
}

.ui-selectable {
  -ms-touch-action: none;
  touch-action: none;
}

.ui-selectable-helper {
  position: absolute;
  z-index: 100;
  border: 1px dotted black;
}

.ui-selectmenu-button.ui-button {
  text-align: left;
  white-space: nowrap;
  width: 14em;
}

.ui-selectmenu-icon.ui-icon {
  float: right;
  margin-top: 0;
}

.ui-selectmenu-menu {
  padding: 0;
  margin: 0;
  position: absolute;
  top: 0;
  left: 0;
  display: none;
}

.ui-selectmenu-menu .ui-menu {
  overflow: auto;
  overflow-x: hidden;
  padding-bottom: 1px;
}

.ui-selectmenu-menu .ui-menu .ui-selectmenu-optgroup {
  font-size: 1em;
  font-weight: bold;
  line-height: 1.5;
  padding: 2px 0.4em;
  margin: 0.5em 0 0 0;
  height: auto;
  border: 0;
}

.ui-selectmenu-open {
  display: block;
}

.ui-selectmenu-text {
  display: block;
  margin-right: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ui-slider {
  position: relative;
  text-align: left;
  width: 160px;
  margin-bottom: 10px;
}

.ui-slider .ui-slider-handle {
  background-color: var(--color-dark-background);
  border: 2px solid var(--color-primary);
  width: 16px;

  height: 16px;
  border-radius: 50%;
  position: absolute;
  top: -5px;

  transform: translateX(-50%);

  cursor: pointer;
}

.ui-slider .ui-slider-range {
  background-color: #1a2433;

  border-radius: 10px;

  height: 8px;

  position: absolute;
  z-index: 1;
  font-size: 0.7em;
  display: block;
  border: 0;
  background-position: 0 0;
}

.ui-slider-handle {
  border-radius: 10px !important;
  background: var(--color-primary);
  border: 2px solid white;
}

.ui-slider-horizontal {
  height: 0px;
  border: 2px solid var(--color-primary) !important;
}

.ui-slider-horizontal .ui-slider-handle {
  top: -7px;
}

.ui-slider-horizontal .ui-slider-range {
  top: 0;
  height: 100%;
}

.ui-slider-horizontal .ui-slider-range-max {
  right: 0;
}

.ui-slider-horizontal .ui-slider-range-min {
  left: 0;
}

.ui-slider-vertical {
  width: 0.8em;
  height: 100px;
}

.ui-slider-vertical .ui-slider-handle {
  left: -0.3em;
  margin-left: 0;
  margin-bottom: -0.6em;
}

.ui-slider-vertical .ui-slider-range {
  left: 0;
  width: 100%;
}

.ui-slider-vertical .ui-slider-range-max {
  top: 0;
}

.ui-slider-vertical .ui-slider-range-min {
  bottom: 0;
}

.ui-slider.ui-state-disabled .ui-slider-handle,
.ui-slider.ui-state-disabled .ui-slider-range {
  filter: inherit;
}

.ui-sortable-handle {
  -ms-touch-action: none;
  touch-action: none;
}

.ui-spinner {
  position: relative;
  display: inline-block;
  overflow: hidden;
  padding: 0;
  vertical-align: middle;
}

.ui-spinner a.ui-spinner-button {
  border-top-style: none;
  border-bottom-style: none;
  border-right-style: none;
}

.ui-spinner-button {
  width: 1.6em;
  height: 50%;
  font-size: 0.5em;
  padding: 0;
  margin: 0;
  text-align: center;
  position: absolute;
  cursor: default;
  display: block;
  overflow: hidden;
  right: 0;
}

.ui-spinner-down {
  bottom: 0;
}

.ui-spinner-input {
  border: none;
  background: none;
  color: inherit;
  padding: 0.222em 0;
  margin: 0.2em 0;
  vertical-align: middle;
  margin-left: 0.4em;
  margin-right: 2em;
}

.ui-spinner-up {
  top: 0;
}

.ui-state-active {
  border: 1px solid rgb(77, 172, 255) !important;
  background: rgba(77, 172, 255, 0.15) !important;
  color: var(--colorWhite) !important;
  border-radius: 3px;
}

.ui-state-active .ui-icon,
.ui-button:active .ui-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.ui-state-active a,
.ui-state-active a:link,
.ui-state-active a:visited {
  color: #fff;
  text-decoration: none;
}

.ui-state-active,
.ui-widget-content .ui-state-active,
.ui-widget-header .ui-state-active,
a.ui-button:active,
.ui-button:active,
.ui-button.ui-state-active:hover {
  border: 1px solid var(--color-dark-text-accent);
  background: rgba(77, 172, 255, 0.15);
  border-radius: 3px;
}

.ui-state-checked {
  border: 1px solid #dad55e;
  background: #fffa90;
}

.ui-state-default {
  border: 1px solid var(--colorTertiary);
  background: var(--colorTertiary);
  color: var(--colorWhite);
}

.ui-state-default a,
.ui-state-default a:link,
.ui-state-default a:visited,
a.ui-button,
a:link.ui-button,
a:visited.ui-button,
.ui-button {
  color: #454545;
  text-decoration: none;
}

.ui-state-disabled {
  cursor: default !important;
  pointer-events: none;
}

.ui-state-disabled .ui-icon {
  filter: Alpha(Opacity=35);
}

.ui-state-disabled,
.ui-widget-content .ui-state-disabled,
.ui-widget-header .ui-state-disabled {
  opacity: 0.35;
  filter: Alpha(Opacity=35);
  background-image: none;
}

.ui-state-error .ui-icon,
.ui-state-error-text .ui-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.ui-state-error a,
.ui-widget-content .ui-state-error a,
.ui-widget-header .ui-state-error a {
  color: #5f3f3f;
}

.ui-state-error,
.ui-widget-content .ui-state-error,
.ui-widget-header .ui-state-error {
  border: 1px solid #f1a899;
  background: #fddfdf;
  color: #5f3f3f;
}

.ui-state-error-text,
.ui-widget-content .ui-state-error-text,
.ui-widget-header .ui-state-error-text {
  color: #5f3f3f;
}

.ui-state-highlight {
  border: 1px solid rgb(107, 107, 107) !important;
  background: rgba(107, 107, 107, 0.15) !important;
  color: var(--colorWhite) !important;
  border-radius: 3px;
}

.ui-state-highlight .ui-icon,
.ui-button .ui-state-highlight.ui-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.ui-state-highlight a,
.ui-widget-content .ui-state-highlight a,
.ui-widget-header .ui-state-highlight a {
  color: #777620;
}

.ui-state-hover .ui-icon,
.ui-state-focus .ui-icon,
.ui-button:hover .ui-icon,
.ui-button:focus .ui-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.ui-state-hover a,
.ui-state-hover a:hover,
.ui-state-hover a:link,
.ui-state-hover a:visited,
.ui-state-focus a,
.ui-state-focus a:hover,
.ui-state-focus a:link,
.ui-state-focus a:visited,
a.ui-button:hover,
a.ui-button:focus {
  color: #2b2b2b;
  text-decoration: none;
}

.ui-state-hover,
.ui-widget-content .ui-state-hover,
.ui-widget-header .ui-state-hover,
.ui-state-focus,
.ui-widget-content .ui-state-focus,
.ui-widget-header .ui-state-focus,
.ui-button:hover,
.ui-button:focus {
  border: 1px solid #ccc;
  background: rgba(237, 237, 237, 0.6);
  font-weight: normal;
  color: #2b2b2b;
}

.ui-tabs {
  position: relative;
  padding: 0.2em;
}

.ui-tabs .ui-tabs-nav {
  margin: 0;
  padding: 0.2em 0.2em 0;
}

.ui-tabs .ui-tabs-nav .ui-tabs-anchor {
  float: left;
  padding: 0.5em 1em;
  text-decoration: none;
}

.ui-tabs .ui-tabs-nav li {
  list-style: none;
  float: left;
  position: relative;
  top: 0;
  margin: 1px 0.2em 0 0;
  border-bottom-width: 0;
  padding: 0;
  white-space: nowrap;
}

.ui-tabs .ui-tabs-nav li.ui-tabs-active {
  margin-bottom: -1px;
  padding-bottom: 1px;
}

.ui-tabs .ui-tabs-nav li.ui-tabs-active .ui-tabs-anchor,
.ui-tabs .ui-tabs-nav li.ui-state-disabled .ui-tabs-anchor,
.ui-tabs .ui-tabs-nav li.ui-tabs-loading .ui-tabs-anchor {
  cursor: text;
}

.ui-tabs .ui-tabs-panel {
  display: block;
  border-width: 0;
  padding: 1em 1.4em;
  background: none;
}

.ui-tabs-collapsible .ui-tabs-nav li.ui-tabs-active .ui-tabs-anchor {
  cursor: pointer;
}

.ui-timepicker-div .ui-widget-header {
  margin-bottom: 8px;
}

.ui-timepicker-div .ui_tpicker_time .ui_tpicker_time_input {
  background: none;
  color: inherit;
  border: none;
  outline: none;
  border-bottom: 0px !important;
  width: 95%;
  height: 15px;
  text-align: center;
}

.ui-timepicker-div .ui_tpicker_time .ui_tpicker_time_input:focus {
  border-bottom: 1px solid #aaa !important;
  -webkit-box-shadow: 0 1px 0 0 #aaa !important;
  box-shadow: 0 1px 0 0 #aaa !important;
}

.ui-timepicker-div .ui_tpicker_unit_hide {
  display: none;
}

.ui-timepicker-div dl {
  margin-top: 0px;
  text-align: left;
}

.ui-timepicker-div dl dd {
  margin: 0 5px 10px 30%;
}

.ui-timepicker-div dl dt {
  float: left;
  clear: left;
  padding: 0 0 0 5px;
}

.ui-timepicker-div td {
  font-size: 90%;
}

.ui-timepicker-div.ui-timepicker-oneLine {
  padding-right: 2px;
}

.ui-timepicker-div.ui-timepicker-oneLine .ui_tpicker_time,
.ui-timepicker-div.ui-timepicker-oneLine dt {
  display: none;
}

.ui-timepicker-div.ui-timepicker-oneLine .ui_tpicker_time_label {
  display: block;
  padding-top: 2px;
}

.ui-timepicker-div.ui-timepicker-oneLine .ui_tpicker_unit_hide,
.ui-timepicker-div.ui-timepicker-oneLine .ui_tpicker_unit_hide:before {
  display: none;
}

.ui-timepicker-div.ui-timepicker-oneLine dl {
  text-align: right;
}

.ui-timepicker-div.ui-timepicker-oneLine dl dd,
.ui-timepicker-div.ui-timepicker-oneLine dl dd>div {
  display: inline-block;
  margin: 0;
}

.ui-timepicker-div.ui-timepicker-oneLine dl dd.ui_tpicker_millisec:before,
.ui-timepicker-div.ui-timepicker-oneLine dl dd.ui_tpicker_microsec:before {
  content: '.';
  display: inline-block;
}

.ui-timepicker-div.ui-timepicker-oneLine dl dd.ui_tpicker_minute:before,
.ui-timepicker-div.ui-timepicker-oneLine dl dd.ui_tpicker_second:before {
  content: ':';
  display: inline-block;
}

.ui-timepicker-rtl {
  direction: rtl;
}

.ui-timepicker-rtl dl {
  text-align: right;
  padding: 0 5px 0 0;
}

.ui-timepicker-rtl dl dd {
  margin: 0 40% 10px 10px;
}

.ui-timepicker-rtl dl dt {
  float: right;
  clear: right;
}

.ui-tooltip {
  padding: 8px;
  position: absolute;
  z-index: 9999;
  max-width: 300px;
}

.ui-tpicker-grid-label {
  background: none;
  border: none;
  margin: 0;
  padding: 0;
}

.ui-visual-focus {
  box-shadow: 0 0 3px 1px rgb(94, 158, 214);
}

.ui-widget {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 1em;
}

.ui-widget .ui-widget {
  font-size: 1em;
}

.ui-widget input,
.ui-widget select,
.ui-widget textarea,
.ui-widget button {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 1em;
}

.ui-widget-content {
  background: var(--color-dark-background);
  border: 1px solid var(--colorTertiary);
  font-family: 'Open Sans', sans-serif;
  color: var(--colorWhite);
  z-index: 25;
}

.ui-widget-content a {
  color: #333;
}

.ui-widget-header {
  font-family: 'Open Sans', sans-serif;
  color: var(--colorWhite);
  font-weight: bold;
}

.ui-widget-header .ui-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.ui-widget-header a {
  color: #333;
}

.ui-widget-icon-block {
  left: 50%;
  margin-left: -8px;
  display: block;
}

.ui-widget-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #aaa;
  opacity: 0.003;
  filter: Alpha(Opacity=.3);
}

.ui-widget-shadow {
  -webkit-box-shadow: 0 0 5px #666;
  box-shadow: 0 0 5px #666;
}

body .ui-tooltip {
  border-width: 2px;
}

input.ui-button.ui-button-icon-only {
  text-indent: 0;
}

input.ui-button.ui-icon-notext .ui-icon {
  width: auto;
  height: auto;
  text-indent: 0;
  white-space: normal;
  padding: 0.4em 1em;
}

input.ui-button::-moz-focus-inner,
button.ui-button::-moz-focus-inner {
  border: 0;
  padding: 0;
}

.ui-icon-circle-triangle-e {
  background-position: -33px -17px;
  filter: brightness(1.4) sepia(1) hue-rotate(-46deg) saturate(7.5);
}

.ui-icon-circle-triangle-w {
  background-position: -97px -17px;
  filter: brightness(1.4) sepia(1) hue-rotate(-46deg) saturate(7.5);
}


/* ========== Materialize Tabs Dark Theme Override ========== */

.tabs {
  background-color: var(--color-dark-background);
}

.tabs .tab a {
  color: rgba(255, 255, 255, 0.7);
}

.tabs .tab a:hover,
.tabs .tab a.active {
  color: var(--colorWhite);
  background-color: transparent;
}

.tabs .tab a:focus,
.tabs .tab a:focus.active {
  background-color: rgba(255, 255, 255, 0.1);
}

.tabs .indicator {
  background-color: var(--color-primary);
}

.tabs .tab.disabled a,
.tabs .tab.disabled a:hover {
  color: rgba(255, 255, 255, 0.4);
}


/* ========== Tooltips ========== */

.material-tooltip {
  display: none !important;
  background-color: #323232;
}

[data-tooltip] {
  position: relative;
  z-index: 2;
  cursor: pointer;
}

[data-tooltip]:before {
  z-index: 9999;
  position: absolute;
  display: block;
  width: 120px;
  margin-left: -60px;

  overflow: visible;

  background-color: var(--color-dark-background);
  text-align: center;
  padding: 5px;
  border-width: 5px;
  border-color: var(--color-dark-border);
  border-style: solid;
  color: #ffffff;
  content: attr(data-tooltip);
}

[data-tooltip]:before,
[data-tooltip]:after {
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
}

[data-tooltip]:hover:before,
[data-tooltip]:hover:after {
  visibility: visible;
  opacity: 1;
}

[data-tooltip][data-position='bottom']:before {
  bottom: -100%;
  left: 50%;
}

[data-tooltip][data-position='left']:before {
  right: 100%;
  left: auto;
}

[data-tooltip][data-position='right']:before {
  left: 100%;
  right: auto;
}

[data-tooltip][data-position='top']:before {
  bottom: 125%;
  top: auto;
  left: 50%;
}


/* ========== Navigation and Menus ========== */

#constellation-menu ul li {
  text-align: center;
  padding: 2px !important;
}

#country-menu ul li {
  text-align: center;
  padding: 2px !important;
}

#custom-sensor-menu-settings-btn:active {
  scale: 0.8;
}

#editor-LS-menu label {
  top: -25px;
  font-size: 1em;
}

#editor-menu {
  background: var(--color-dark-background);
  color: white;
  overflow: auto;
}

#external-menu ul li {
  text-align: center;
  padding: 2px !important;
}

#info-overlay-menu {
  position: fixed;
  top: var(--top-menu-height);
  left: 3rem;
  bottom: 0;
  width: 230px;
  overflow: hidden;
  height: auto;
  border: none;
  z-index: 2;
  pointer-events: none;
  background: rgba(0, 0, 0, 0.9);
}

#info-overlay-menu.ui-hidden {
  top: 0;
  left: 0;
}

#info-overlay-content {
  position: absolute;
  background: transparent;
  color: white;
  width: 230px;
  padding-left: 20px;
  top: 1rem;
  height: 100%;
  overflow: hidden;
  z-index: 10;
  pointer-events: auto;
}

#iss-stream-menu {
  display: none;
  position: absolute;
  width: 270px;
  height: 620px;
  z-index: 10;
  margin-left: -15px;
}

#iss-stream-menu iframe {
  width: 285px;
  margin-bottom: -6px;
}

#launch-menu {
  display: none;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  width: 1160px;
  max-height: 100%;
  border-radius: 5px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  z-index: 10;
  left: 0;
  top: 60px;
  bottom: 60px;
  overflow: auto;
  color: white;
}

#layers-hover-menu {
  display: none;
  padding: 10px;
  color: white;
  background: var(--color-dark-background);
  top: var(--top-menu-height);
  z-index: 100;
  position: fixed;
  overflow: auto;
  width: 100%;
  border-width: 0px 0px 5px 0px;
  border-style: solid;
  border-color: var(--color-dark-border);
}

#menu-launches,
#menu-record,
#menu-color-scheme,
#social,
#fastCompSettings {
  display: none;
}

#nav-footer-toggle {
  display: block;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  height: 20px;
  width: 40px;
  margin: 0px auto;
  margin-top: -20px;
  background: var(--color-dark-border);
  cursor: pointer;
  text-align: center;
  font-size: 12px;
  font-weight: bold;
}

#nav-top-center {
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-family: 'Roboto Mono', monospace;
  margin-left: 10px;
  flex-grow: 1;
}

#nav-top-right {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}

#nav-top-right li {
  line-height: normal;
  height: 100%;
}

#nav-wrapper {
  background: var(--color-dark-background);
  z-index: 3;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  height: var(--nav-bar-height);
}

#sensor-info-menu a {
  color: white !important;
}

#sensor-timeline-menu,
#satellite-timeline-menu {
  display: none;
  position: absolute;
  width: 800px;
  left: 0;
  margin: 0;
  border-top: 3px solid var(--color-dark-border);
  border-left: 0;
  border-right: 0;
  border-bottom: 0;
  z-index: 10;
}

#sensor-timeline-menu-content,
#satellite-timeline-menu-content {
  padding: 0px !important;
}

#time-machine-menu li {
  display: flex;
}

.bmenu-filter-item {
  padding: 2px;
  text-align: center;
  cursor: pointer;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  align-items: center;
}

.bmenu-filter-item .bmenu-filter-item-inner img {
  width: 25px;
  height: auto;
  margin: 0 auto;
  display: block;
  padding-bottom: 3px;
}

.bmenu-filter-title {
  position: relative;
  display: block;
  font-size: 11px;
  text-align: center;
  padding-left: 3px;
}

.bmenu-item .bmenu-item-inner img {
  width: var(--bottom-icon-img-size);
  height: auto;
  margin: 0 auto;
  display: block;
}

.bmenu-item .status-icon {
  width: 15px;
  height: 15px;
  top: -20px;
  background-size: cover;
  position: relative;
  z-index: 5;
  left: 15px;
  display: block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.bmenu-item-disabled .status-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

.bmenu-item-disabled img,
.bmenu-item-disabled img * {
  filter: grayscale(1) !important;
}

/* Pro-locked icons - blue tint only while the user is NOT logged in. The tint
   is driven purely off the body-level .user-logged-in class so freshly-rendered
   gated items inherit the right look with no per-element JS sync.
   .login-gate-bypassed is the Konami-code bypass, which clears the tint too
   (keep in sync with plugin-drawer.css and launchpad.css). */
body:not(.user-logged-in):not(.login-gate-bypassed) .bmenu-item-pro img {
  filter: hue-rotate(227deg) brightness(1.2) !important;
}

body:not(.user-logged-in):not(.login-gate-bypassed) .bmenu-item-pro:hover img {
  filter: hue-rotate(227deg) brightness(1.8) !important;
}

.bmenu-item-error .status-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

.bmenu-item-error img {
  filter: invert(52%) sepia(130%) saturate(7323%) hue-rotate(353deg) brightness(100%) contrast(86%);
}

.bmenu-item-help .status-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

.bmenu-item-help img {
  filter: hue-rotate(227deg) brightness(1.2);
}

.bmenu-item-help:hover .status-icon {
  filter: brightness(1.8);
}

.bmenu-item-help:hover img {
  filter: hue-rotate(227deg) brightness(1.8);
}

.bmenu-item-inner {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
}

.bmenu-item-selected .status-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

.bmenu-item-selected img {
  transition: filter var(--kt-duration-normal, 200ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
  filter: hue-rotate(275deg) brightness(1.2);
}

.bmenu-item-selected:hover .status-icon {
  transition: filter var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
  filter: brightness(1.8);
}

.bmenu-item-selected:hover img {
  transition: filter var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
  filter: hue-rotate(275deg) brightness(1.8);
}

.bmenu-item:hover,
.bmenu-filter-item:hover {
  background: rgba(255, 255, 255, 0.15);
  border-radius: var(--kt-radius-sm, 4px);
}

.bmenu-title {
  position: relative;
  display: block;
  font-size: 11px;
  text-align: center;
  text-overflow: ellipsis;
  overflow-x: hidden;
  word-wrap: break-word;
}

.menu-item {
  cursor: pointer;
  z-index: 11;
}

.menu-item:first-child {
  margin-left: 2px;
}

.menu-item:hover .menu-title {
  color: var(--color-dark-background);
}

.menu-radar {
  right: 50px;
}

.menu-selectable:hover {
  background: var(--kt-bg-hover, rgba(255, 255, 255, 0.08));
  cursor: pointer;
}

.side-menu>ul>li {
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  text-align: center;
}

.side-menu>ul>li:first-child {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.menu-title {
  height: 30px;
}

.plot-analysis-menu-maximized {
  width: 100% !important;
  height: 100% !important;
}

.plot-analysis-menu-normal {
  width: 650px;
  z-index: 2;
}

#right-btn-menu {
  z-index: 11;
}

.right-btn-menu {
  display: none;
  background: var(--kt-bg-elevated, #2a2a2e);
  color: white;
  position: absolute;
  min-width: 165px;
  width: auto;
  border-radius: var(--kt-radius-md, 6px);
  border: 1px solid var(--kt-border-default, rgba(255, 255, 255, 0.12));
  box-shadow: var(--kt-shadow-lg, 0 4px 12px rgba(0, 0, 0, 0.4));
  z-index: 12;
  padding: 4px 0;
  overflow: hidden;
}

.right-btn-menu ul {
  width: 100%;
  margin: 0;
  padding: 0;
}

.right-btn-menu ul li {
  padding: 6px 12px;
  min-height: 28px;
  cursor: pointer;
  align-items: center;
  margin: 0 4px;
  border-radius: var(--kt-radius-sm, 4px);
  transition: background-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
  text-align: left;
}

/*
 * The input manager shows/hides individual menu items by toggling the inline
 * \`display\` (block to show, none to hide). Apply the flex layout only to items
 * that are NOT inline-hidden, so a \`display: flex\` here can never override an
 * inline \`display: none\` and leave a hidden item visible.
 */
.right-btn-menu ul li:not([style*="display: none"]) {
  display: flex !important;
}

.right-btn-menu ul li:hover {
  background-color: var(--kt-bg-hover, rgba(255, 255, 255, 0.08));
}

.right-btn-menu ul li:active {
  background-color: var(--kt-bg-active, rgba(255, 255, 255, 0.12));
}

.right-btn-menu ul li:hover a {
  color: var(--colorWhite) !important;
  background-color: transparent;
}

.rmb-menu-item a {
  color: white !important;
  text-decoration: none;
  width: 100%;
}

.rmb-menu-item:hover {
  background-color: var(--kt-bg-hover, rgba(255, 255, 255, 0.08)) !important;
}

.side-menu {
  position: absolute;
  inset: 0;
  overflow: auto;
  z-index: 10;
  padding: 0rem 1rem;
  padding-bottom: 0.25rem;
}

.side-menu .input-field {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}

.side-menu-parent {
  display: none;
  position: absolute;
  width: 100%;
  top: var(--top-menu-height);
  bottom: 0px;
  left: 0px;
  overflow: hidden;
  transition: transform var(--kt-duration-slow, 300ms) var(--kt-easing-enter, cubic-bezier(0, 0, 0.2, 1));
  transform: translateX(-120%);
  background: var(--color-dark-background);
  z-index: 5;
  border-right: 1px solid var(--kt-border-default, rgba(255, 255, 255, 0.12));
  box-shadow: var(--kt-shadow-lg, 0 4px 12px rgba(0, 0, 0, 0.4));
  color: white;
  padding: 0px;
}

/* Side menu title bar layout */
.side-menu-title-bar {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  padding: 0.5rem 0rem;
  border-bottom: 1px solid var(--kt-border-default, rgba(255, 255, 255, 0.12));
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
  position: sticky;
  top: 0;
  z-index: 5;
  background: var(--color-dark-background);
  margin-bottom: 1rem;
  margin-left: -1rem;
  margin-right: -1rem;
}

.side-menu-title-left,
.side-menu-title-right {
  flex: 1;
  display: flex;
  align-items: center;
}

.side-menu-title-right {
  justify-content: flex-end;
  gap: 0.5rem;
  margin-right: 1rem;
}

.side-menu-title-text {
  flex: 0 0 auto;
  margin-left: 1rem;
  text-align: center;
  width: 300px;
}



.icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 6px;
  cursor: pointer;
  border-radius: var(--kt-radius-sm, 4px);
  transition: background-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
}

.icon-btn:hover {
  background-color: var(--kt-bg-hover, rgba(255, 255, 255, 0.08));
}

.icon-btn:active {
  background-color: var(--kt-bg-active, rgba(255, 255, 255, 0.12));
  transform: scale(0.95);
}

.icon-btn[disabled] {
  opacity: 0.3;
  cursor: default;
  pointer-events: none;
}

.icon-btn-img {
  width: 20px;
  height: 20px;
  vertical-align: middle;
  filter: brightness(0) invert(1);
}

.side-menu-row-header {
  background: var(--color-dark-border);
  margin: 0px -1px;
  padding: 5px;
}

/* Universal data table row hover in side menus */
.side-menu table tbody tr {
  transition: background-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
}

.side-menu table tbody tr:hover {
  background-color: var(--kt-bg-hover, rgba(255, 255, 255, 0.08));
}

/* Secondary menu panels sit behind their primary side menu (z-index < 5).
   min-width: auto allows secondary panels to respect their inline width instead of
   being forced to the responsive .side-menu-parent min-width (400px).
   left: 0px (without !important) is the default; inline styles from openSecondaryMenu()
   override this to position the panel adjacent to the primary menu. */
[id\$="-secondary"].side-menu-parent {
  z-index: 4 !important;
  left: 0px;
  min-width: auto;
  box-shadow: var(--kt-shadow-md, 0 2px 8px rgba(0, 0, 0, 0.3));
}

.side-menu-settings {
  position: relative;
  height: 100%;
  border-right: 1px solid var(--kt-border-default, rgba(255, 255, 255, 0.12));
  box-shadow: var(--kt-shadow-md, 0 2px 8px rgba(0, 0, 0, 0.3));
  background: var(--color-dark-background);
  color: white;
  width: 100%;
  top: 0px;
  bottom: 0px;
  overflow: auto;
  z-index: 3;
  padding: 0px 10px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 10px;
}

/* Override Materialize teal with the app's theme color for all checkboxes and radios */
[type="checkbox"]:checked+span:not(.lever)::before {
  border-right-color: var(--color-primary) !important;
  border-bottom-color: var(--color-primary) !important;
}

[type="checkbox"].filled-in:checked+span:not(.lever)::after {
  border-color: var(--color-primary) !important;
  background-color: var(--color-primary) !important;
}

[type="radio"]:checked+span::after,
[type="radio"].with-gap:checked+span::after {
  background-color: var(--color-primary) !important;
  border-color: var(--color-primary) !important;
}

[type="radio"].with-gap:checked+span::before {
  border-color: var(--color-primary) !important;
}

.secondary-title-bar {
  padding: 0.5rem 0;
  margin-bottom: 0;
}

.submenu {
  display: none;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 5px;
  margin: 0;
  overflow: hidden;
  position: absolute;
}

.top-menu-icons img {
  width: 30px;
  height: 30px;
  margin: 3px;
}

.top-menu-icons-search-on {
  transition: 300ms var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
}

nav {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  color: #fff;
  background-color: var(--color-dark-background);
  height: 50px;
  line-height: 50px;
}

nav,
nav .nav-wrapper i,
nav a.sidenav-trigger,
nav a.sidenav-trigger i {
  height: var(--nav-bar-height);
  line-height: var(--nav-bar-height);
  box-shadow: none;
  -webkit-box-shadow: none;
}

#layers-hover-menu li,
#layers-hover-menu-popup li {
  display: flex;
  align-items: center;
}

#layers-hover-menu-popup {
  display: none;
  color: white;
  background: var(--color-dark-background);
  z-index: 100;
  overflow: auto;
  width: 100%;
  padding: 1em;
}

#map-menu {
  display: none;
  position: absolute;
  width: 800px;
  left: 0;
  margin: 0;
  border-top: 3px solid var(--color-primary);
  border-left: 0;
  border-right: 0;
  border-bottom: 0;

  background: rgba(255, 255, 255, 0.85);
  color: white;

  z-index: 99999999;
  padding: 0;
}

.bmenu-item {
  padding: 5px;
  text-align: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  max-width: var(--bottom-icon-width);
  transition: background-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
}

.bmenu-item .bmenu-item-inner:active *,
.bmenu-filter-item .bmenu-filter-item-inner:active * {
  scale: 0.9;
}

.top-menu-icons {
  padding: 0px;
  height: 100%;
  display: flex;
  align-items: center;
  transition: 300ms var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
}


/* ========== Controls and Buttons ========== */

#colorbox-header button {
  width: 24px;
  height: 24px;
  cursor: pointer;
  border: 0px;
  background: none;
  color: white;
}

.colorPickButton {
  border-radius: 5px;
  width: 20px;
  height: 20px;
  margin: 0px 3px;
  cursor: pointer;
  display: inline-block;
  border: thin solid #eee;
}

.colorPickButton:hover {
  transform: scale(1.1);
}

.ghost-button {
  display: block;
  border: 2px white;
  background: var(--colorWhite);
  padding: 10px;
  width: 100%;
  margin: 20px auto;
  -webkit-transition: all 0.1s ease-in-out;
  -moz-transition: all 0.1s ease-in-out;
  -ms-transition: all 0.1s ease-in-out;
  -o-transition: all 0.1s ease-in-out;
  transition: all 0.1s ease-in-out;
}

.ghost-button:hover {
  background: #c33;
  color: var(--colorWhite);
}


/* ========== Search Components ========== */

#search {
  height: 25px;
  margin: 3px;
  display: block;
  border-radius: 0;
  background: var(--color-dark-background);
  font-size: 16px;
  color: #f5f5f5;
  outline: none;
  box-shadow: none;
  -webkit-box-shadow: none;
  border-bottom: none !important;
}

#search-holder {
  display: flex;
  height: 100%;
  transition: 300ms var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
  align-items: center;
  margin-left: 20px;
}

#search-holder input:-webkit-autofill {
  box-shadow: 0 0 0px 1000px var(--color-dark-border) inset;
  background-color: var(--color-dark-background) !important;
  -webkit-text-fill-color: white !important;
  color: white !important;
}

.search-hilight {
  font-weight: bold;
  color: var(--color-dark-text-accent);
}

.search-result {
  padding: 6px 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  transition: background-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
}

.search-result:hover {
  background: var(--kt-bg-hover, rgba(255, 255, 255, 0.08));
  cursor: pointer;
}

.search-result-limit {
  padding: 4px 10px;
  font-size: 0.8em;
  color: var(--color-dark-text-accent);
  text-align: center;
  border-bottom: 1px solid var(--color-dark-border);
}

.search-result-decayed {
  opacity: 0.5;
  cursor: default;
}

.search-result-decayed:hover {
  background: none;
  cursor: default;
}

.search-result-decayed-badge {
  font-size: 0.75em;
  color: #ff6b6b;
  margin-left: 8px;
  white-space: nowrap;
}

.search-slide-down {
  width: 160px;
  transition: width var(--kt-duration-normal, 200ms) var(--kt-easing-enter, cubic-bezier(0, 0, 0.2, 1));
}

.search-slide-down input[type='search'] {
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
  text-decoration: none;
}

.search-slide-up {
  transition: width var(--kt-duration-normal, 200ms) var(--kt-easing-exit, cubic-bezier(0.4, 0, 1, 1));
  width: 0px;
}

.search-slide-up input[type='search'] {
  transition: width var(--kt-duration-normal, 200ms) var(--kt-easing-exit, cubic-bezier(0.4, 0, 1, 1));
  width: 0px;
  padding-left: 0px;
}

.truncate-search {
  width: 280px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /*
   * Pin the name column immediately after the badge. The row uses
   * justify-content: space-between, which would otherwise center this middle
   * column in the leftover space and shift its left edge per row depending on
   * the right column's width. The auto margin absorbs the slack instead, so the
   * name always starts at the same x and the right column stays right-aligned.
   */
  margin-right: auto;
}

#search-results {
  transform: translateY(-100%);
  display: none;
  overflow-x: hidden;
  overflow-y: auto;
  position: absolute;
  width: 100%;
  height: fit-content;
  background: var(--color-dark-background) !important;
  z-index: 1;
  top: var(--top-menu-height);
  bottom: 250px;
  max-height: 20%;
  border-width: 0px 0px 5px 0px;
  padding-top: 10px;
  border-style: solid;
  border-color: var(--color-dark-border);
}


/* ========== Modals and Dialogs ========== */

#colorbox {
  border: 10px solid var(--color-dark-background);
  z-index: 10;
  box-sizing: content-box;
}

#colorbox-div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99;
  padding: 5%;
}

#colorbox-header {
  background: var(--color-dark-border);
  width: 100%;
  height: 34px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-right: 15px;
  padding-bottom: 10px;
}

#colorbox-iframe,
#colorbox-img {
  width: 100%;
  height: calc(100% - 34px);
  border: none;
}

#colorbox-container {
  background-color: 'white';
  transform: translateX(-200%);
  transition: transform 300ms var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
  display: block;
  z-index: 100;
  width: 95%;
  height: 95%;
  margin: auto;
  border-color: var(--color-dark-border);
  border-width: 10px;
  border-style: solid;
  border-radius: 5px;
}

#colorbox-title {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: x-large;
}


/* ========== Utility Classes ========== */

.Square-Box {
  cursor: pointer;
  width: 30px;
  height: 30px;
  border-width: 2px;
  border-style: solid;
  border-radius: 15px;
  box-shadow:
    0 0px 6px 0 rgba(0, 0, 0, 0.2),
    0 0px 8px 0 rgba(0, 0, 0, 0.19);
  margin-right: 20px;
}

.add-icon img {
  padding-top: 35px;
  width: 25px;
  filter: hue-rotate(275deg) brightness(1.2);
}

.box-header {
  font-size: 20px;
  margin-top: 5px;
  margin-bottom: 5px;
}

.btn-green {
  background-color: rgb(86, 240, 0) !important;
}

.btn-red {
  background-color: rgb(255, 56, 56) !important;
}

.btn-red:active {
  background-color: rgb(255, 0, 0) !important;
}

.btn-red:hover {
  background-color: rgb(255, 0, 0) !important;
}

.cboxIframe {
  width: 100%;
  height: 100%;
}

.center-text {
  text-align: center;
}

.colorPickDummy {
  background: #fff;
  border: 1px dashed #bbb;
}

.customColorHash {
  border-radius: 5px;
  height: 23px;
  width: 122px;
  margin: 1px 4px;
  padding: 0 4px;
  border: 1px solid #babbba;
  outline: none;
}

.customColorHash.error {
  border-color: #ff424c;
  color: #ff424c;
}

.dark-blue-badge {
  color: var(--color-dark-text-accent) !important;
  font-weight: bold;
}

.dark-gray-badge {
  color: var(--statusLightOff) !important;
  font-weight: bold;
}

.divider {
  padding: 2px !important;
  background-color: var(--color-dark-background);
}

.eruda-entry-btn {
  display: none !important;
}

.eruda-icon-tool {
  display: none !important;
}

.flow5out {
  margin: 0px -5px;
}

.footer-slide-down {
  bottom: -145px !important;
  height: 150px !important;
  top: auto !important;
}

.footer-slide-trans {
  transition: transform var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
}

.footer-slide-up {
  bottom: 0px !important;
  top: auto !important;
}

.ghost-input {
  text-align: right;
  font-weight: 300;
  width: 120px;
  position: absolute;
  left: 140px;
  padding: 10px;
  border: 0px;
  outline: none;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  color: var(--colorWhite);
  background: rgba(0, 0, 0, 0);
  font-family:
    Open Sans,
    Verdana,
    sans-serif;
  -webkit-transition: all 0.1s ease-in-out;
  -moz-transition: all 0.1s ease-in-out;
  -ms-transition: all 0.1s ease-in-out;
  -o-transition: all 0.1s ease-in-out;
  transition: all 0.1s ease-in-out;
}

.ghost-input:focus {
  border-bottom: 1px solid #ddd;
}

.ghost-input:hover {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 5px;
}

.help-header-sel:hover {
  cursor: pointer;
  color: var(--color-dark-text-accent);
}

.huerotate {
  -webkit-filter: hue-rotate(180deg);
  filter: hue-rotate(180deg);
}

.layers-ageLost-box {
  background: rgb(200, 200, 200);
}

.layers-ageMed-box {
  background: rgb(150, 150, 150);
}

.layers-ageNew-box {
  background: rgb(100, 100, 100);
}

.layers-ageOld-box {
  background: rgb(200, 200, 200);
}

.layers-debris-box {
  background: rgb(157, 157, 157);
}

.layers-facility-box {
  background: rgb(108, 30, 103);
}

.layers-inFOV-box {
  background: rgb(255, 200, 0);
}

.layers-inviewAlt-box {
  background: rgb(255, 200, 0);
}

.layers-missile-box {
  background: rgb(200, 198, 9);
}

.layers-missileInview-box {
  background: rgb(255, 0, 0);
}

.layers-payload-box {
  background: rgb(68, 193, 47);
}

.layers-pink-box {
  background: rgb(108, 0, 50);
  display: hidden;
}

.layers-rcsLarge-box {
  background: rgb(200, 200, 200);
}

.layers-rcsMed-box {
  background: rgb(150, 150, 150);
}

.layers-rcsSmall-box {
  background: rgb(100, 100, 100);
}

.layers-rcsUnkown-box {
  background: rgb(200, 200, 200);
}

.layers-rocketBody-box {
  background: rgb(0, 48, 255);
}

.layers-satGEO-box {
  background: rgb(200, 200, 200);
}

.layers-satHi-box {
  background: rgb(200, 200, 200);
}

.layers-satLEO-box {
  background: rgb(200, 200, 200);
}

.layers-satLow-box {
  background: rgb(100, 100, 100);
}

.layers-satMed-box {
  background: rgb(150, 150, 150);
}

.layers-sensor-box {
  background: rgb(166, 5, 5);
}

.layers-sensorCanObserve-box {
  background: rgb(255, 30, 0);
}

.layers-sourceAldoria-box {
  background: rgb(15, 150, 71);
}

.layers-sourceCelestrak-box {
  background: rgb(206, 219, 14);
}

.layers-sourcePrismnet-box {
  background: rgba(168, 47, 199, 0.705);
}

.layers-sourceUssf-box {
  background: rgb(11, 39, 131);
}

.layers-sourceVimpel-box {
  background: rgb(204, 14, 14);
}

.layers-starHi-box {
  background: rgb(200, 200, 200);
}

.layers-starLow-box {
  background: rgb(100, 100, 100);
}

.layers-starMed-box {
  background: rgb(150, 150, 150);
}

.layers-velocityFast-box {
  background: rgb(200, 200, 200);
}

.layers-velocityMed-box {
  background: rgb(150, 150, 150);
}

.layers-velocitySlow-box {
  background: rgb(100, 100, 100);
}

.link:hover {
  background: rgba(0, 0, 0, 0.2);
}

.map-item {
  position: absolute;
  z-index: 11;
}

.map-look {
  width: 12px;
  height: 12px;
  border-radius: 20%;
  cursor: pointer;
}

.no-text-select {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.plot-analysis-chart {
  width: 100%;
  height: 90%;
  padding-bottom: 80px;
  padding-top: 10px;
  margin: 0;
}

.pointable {
  cursor: pointer;
}

.remove-icon img {
  width: 25px;
  filter: invert(52%) sepia(130%) saturate(7323%) hue-rotate(353deg) brightness(100%) contrast(86%);
}

.sensor-info-key {
  font-size: 12px;
  float: left;
}

.sensor-info-key,
.sensor-info-value {
  display: inline-block;
  height: 18px;
}

.sensor-info-row {
  text-align: center;
  margin: 10px;
  height: 18px;
}

.sensor-info-value {
  float: right;
  font-size: 12px;
}

.shake {
  animation: shake 1s;
  animation-iteration-count: infinite;
}

.start-hidden {
  display: none;
}

.status-box {
  background: rgba(0, 0, 0, 0);
  color: white;
  font-family: 'Open Sans', Times, serif;
  font-size: 28px;
  position: absolute;
  height: 100px !important;
  bottom: 50px;
  z-index: 10002;
  width: 100%;
  text-align: center;
}

.text-select {
  -webkit-touch-callout: text;
  -webkit-user-select: text;
  -khtml-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}

.timeline-Header {
  display: none;
}

.title-text {
  text-align: center;
  margin-bottom: 5px;
  font-size: 18px;
  vertical-align: middle;
}

.ui_tpicker_hour,
.ui_tpicker_minute,
.ui_tpicker_second,
.ui_tpicker_proprate {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: row;
  flex-wrap: nowrap;
}

.ui_tpicker_time {
  height: 31px;
  display: flex;
  justify-content: space-around;
}

.ui_tpicker_time_input {
  font-family: 'Roboto Mono', monospace !important;
  height: 15px !important;
  border-bottom: 0px !important;
  text-align: center !important;
  font-size: 20px !important;
  width: 150px !important;
}

.vcr-btn {
  cursor: pointer;
}

.vcr-container {
  display: flex;
}

.vertcenter {
  line-height: 36px;
}

.dropdown-content {
  max-height: 40vh !important;
}

.dropdown-content::-webkit-scrollbar-thumb {
  background-color: var(--color-dark-text-accent) !important;
}

.dropdown-content::-webkit-scrollbar-track {
  background-color: transparent !important;
}


/* ========== Other Styles ========== */

#about-box {
  background: var(--colorBlack);
  right: 10px;
  width: 500px;
  height: 470px;
}

#about-content {
  font-size: 12px;
}

#bottom-icons {
  width: 100%;
  float: right;
  display: grid;
  grid-template-columns: minmax(var(--bottom-icon-width), max-content) repeat(auto-fill, var(--bottom-icon-width));
  /* fill parent so scrollbar spans full height */
  height: 100%;
  min-height: calc(1.5 * var(--bottom-icon-width));
  /* pack items at top - prevents stretching */
  align-content: start;
  justify-content: center;
  row-gap: 5px;
  background: var(--color-dark-background);
  padding-top: 10px;
  padding-bottom: 10px;
  z-index: 11;
  overflow-y: scroll;
  max-height: var(--bottom-menu-height);
}

#bottom-icons-container {
  display: flex;
  flex-direction: row;

  width: 100% !important;
  height: var(--bottom-menu-height);
  overflow: hidden;
  text-align: left;
}

/* Hide entire bottom menu when drawer mode is active (desktop) */
body.drawer-mode:not(.is-mobile-mode) footer#nav-footer {
  display: none !important;
}

#bottom-icons-filter {
  width: var(--bottom-filter-width);
  height: var(--bottom-menu-height);
  float: left;
  display: flex;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
  background: var(--color-dark-background);
  z-index: 11;
  position: absolute;
  flex-direction: column;
  align-content: center;
  align-items: flex-start;
  justify-content: flex-start;
  overflow-y: scroll;
}

#bottom-icons-utility {
  width: var(--bottom-utility-width);
  height: var(--bottom-menu-height);
  position: absolute;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px;
  background: var(--color-dark-background);
  z-index: 11;
  overflow-y: auto;
}

.utility-section-header {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: rgba(255, 255, 255, 0.5);
  padding: 4px 0 2px;
  width: 100%;
  flex-shrink: 0;
}

.utility-section-icons {
  display: grid;
  grid-template-columns: repeat(auto-fill, 25px);
  grid-template-rows: repeat(auto-fill, 25px);
  gap: 5px;
  width: 100%;
}

.utility-section-divider {
  border: none;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  margin: 6px 0;
  width: 100%;
  flex-shrink: 0;
}

.utility-icon {
  width: 25px;
  height: 25px;
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.2s;
}

.utility-icon:hover {
  opacity: 1;
}

.utility-icon.bmenu-item-selected {
  opacity: 1;
}

.utility-icon.bmenu-item-disabled {
  opacity: 0.2;
  cursor: default;
}

#calendar-time-prop-rate {
  width: 4em;
  margin-left: 1em;
}

#camera-status-box {
  z-index: 10003;
  bottom: 100px;
}

#canvas-holder {
  z-index: -2;
  padding: 0;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}

#cboxLoadedContent {
  overflow: hidden !important;
  background: var(--colorWhite);
}

#classification-container {
  text-align: center;
  background: var(--classificationColor);
}

#colorPick {
  -webkit-backdrop-filter: blur(15px);
  backdrop-filter: blur(15px);
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.5);
  padding: 15px;
  font-family: 'Open Sans', sans-serif;
  width: fit-content;
  background: var(--color-dark-background);
  border: 5px solid var(--color-dark-border);

  display: grid !important;
  grid-template-columns: repeat(6, 1fr);
  grid-row-gap: 15px;
}

#colorPick * {
  -webkit-transition: all linear 0.2s;
  -moz-transition: all linear 0.2s;
  -ms-transition: all linear 0.2s;
  -o-transition: all linear 0.2s;
  transition: all linear 0.2s;
}

#colorPick span {
  font-size: 9pt;
  text-transform: uppercase;
  font-weight: bold;
  color: #bbb;
  margin-bottom: 5px;
  display: block;
  clear: both;
}

#copyright-notice {
  font-family: var(--font-family);
  position: absolute;
  left: 0;
  bottom: 12px;
  width: 100%;
  text-align: center;
  font-size: 10px;
  color: white;
  pointer-events: none;
  background: none;
  z-index: 1000;
  text-shadow:
    1px 1px 0px rgba(0, 0, 0, 1),
    1px 1px 0px #000;
}

#datetime {
  font-size: 12px;
  text-align: center;
}

#datetime-input {
  position: absolute;
  bottom: 10px;
  display: none;
  /* Invisible edit-time anchor that overlaps #datetime-text once opened; must never eat its clicks */
  pointer-events: none;
}

#datetime-input-tb {
  color: white;
  font-family: 'Open Sans', sans-serif;

  height: 0px !important;
  margin: 0 0 55px 0 !important;
}

#datetime-input-tb:focus,
input:focus {
  outline: none;
}

#datetime-text {
  font-family: 'Roboto Mono', monospace;
  font-size: 20px;
  cursor: pointer;
  border-width: 0px;
}

#datetime-title {
  position: absolute;
  left: 20px;
  bottom: 20px;
  width: 220px;
  height: 30px;
  background: transparent;
  overflow: hidden;
  text-align: center;
  font-weight: bold;
  font-size: 12px;
}

#down {
  margin: 0px auto;
}

#editor-LS {
  display: block !important;
  background: steelblue;
  height: 2em;
}

#editorForm div {
  margin-top: 2em;
}

#editorForm label {
  top: 20px;
  font-size: 1em;
}

#es-error,
#ms-error {
  margin-top: 10px;
  padding-bottom: 10px;
  cursor: 'pointer';
}

#footer-handle {
  width: 100%;
  height: 5px;
  top: 0px;

  z-index: 2;
  background-color: var(--color-dark-border) !important;
}

#footer-toggle-wrapper {
  width: 100%;
  z-index: 1;
  position: relative;
}

#help-close {
  position: absolute;
  right: 15px;
  top: 5px;
  font-size: 2em;
}

#help-close:hover {
  cursor: pointer;
  color: var(--color-dark-text-accent);
}

#help-header {
  font-size: 1.5em;
}

#help-inner-container {
  margin: auto;
  width: 100%;
}

#help-outer-container {
  display: none;
  background-color: rgba(0, 0, 0, 0.75);
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 99;
}

#help-screen {
  display: flex;
  max-width: 80%;
  max-height: 80%;
  flex-shrink: 1;
  position: relative;
  inset: 10%;
  z-index: 99;
  border: 5px solid var(--color-dark-border);
  text-align: center;
  padding: 10px;
  overflow: auto;
  background: var(--color-dark-background);
}

#help-text {
  display: block;
  line-height: 20px;
  text-align: left;
}

/* Rich (structured) help dialog content */
#help-text .help-rich {
  max-width: 840px;
  margin: 0 auto;
  line-height: 1.55;
}

#help-text .help-section {
  margin: 0 0 20px;
  text-align: left;
}

#help-text .help-section:last-child {
  margin-bottom: 0;
}

#help-text .help-section-heading {
  margin: 0 0 8px;
  padding-bottom: 4px;
  font-size: 1.15em;
  font-weight: 500;
  color: var(--color-dark-text-accent);
  border-bottom: 1px solid var(--color-dark-border);
}

#help-text .help-section-content ol,
#help-text .help-section-content ul {
  margin: 8px 0 0;
  padding-left: 28px;
}

#help-text .help-section-content ol li,
#help-text .help-section-content ul li {
  margin-bottom: 4px;
  list-style-position: outside;
}

#help-text .help-section-content ol li {
  list-style-type: decimal;
}

#help-text .help-section-content ul li {
  list-style-type: disc;
}

#help-text .help-figure {
  margin: 12px auto 0;
  text-align: center;
}

#help-text .help-figure img {
  max-width: 100%;
  max-height: 45vh;
  border: 1px solid var(--color-dark-border);
  border-radius: 4px;
}

#help-text .help-figure figcaption {
  margin-top: 4px;
  font-size: 0.85em;
  font-style: italic;
  opacity: 0.75;
}

#help-text .help-tips {
  padding: 10px 14px;
  background: rgba(255, 255, 255, 0.05);
  border-left: 3px solid var(--color-primary);
  border-radius: 0 4px 4px 0;
}

#help-text .help-tips .help-section-heading {
  border-bottom: none;
  padding-bottom: 0;
}

#help-text .help-tips-list {
  margin: 0;
  padding-left: 20px;
}

#help-text .help-tips-list li {
  margin-bottom: 4px;
  list-style-type: disc;
  list-style-position: outside;
}

#help-text .help-shortcut-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px 0;
}

#help-text .help-shortcut-keys {
  flex-shrink: 0;
  min-width: 130px;
}

#help-text kbd {
  padding: 1px 7px;
  font-family: 'Roboto Mono', monospace;
  font-size: 0.85em;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid var(--color-dark-border);
  border-bottom-width: 2px;
  border-radius: 4px;
}

#help-text .help-kbd-plus {
  margin: 0 4px;
  opacity: 0.7;
}

#jday {
  font-family: 'Roboto Mono', monospace;
  font-size: 20px;
  padding: 0px 10px;
  display: none;
}

#keeptrack-canvas {
  background: var(--colorBlack);

  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  touch-action: auto;
}

#keeptrack-root {
  margin: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 0;
  overflow: hidden;
  touch-action: none;
  -webkit-overflow-scrolling: none;

  overscroll-behavior: none;
}

#load-cover {
  background: rgba(0, 0, 0, 0.8);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

#loader {
  background: var(--colorBlack);
  cursor: default;
  color: white;
  position: absolute;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  width: 250px;
  height: 50px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  text-align: center;
}

#logo-primary {
  position: absolute;
  top: calc(var(--top-menu-height) + 10px);
  left: 10px;
  height: auto;
  width: 4vw;
  z-index: 0;
  max-width: 150px;
  min-width: 70px;
}

#logo-primary img {
  width: 100%;
  height: 100%;
}

#logo-secondary {
  position: absolute;
  top: calc(var(--top-menu-height) + 10px);
  left: calc(20px + max(4vw, 70px));
  height: auto;
  width: 4vw;
  z-index: 0;
  max-width: 150px;
  min-width: 70px;
}

#logo-secondary img {
  width: 100%;
  height: 100%;
}

#lookangles-content td {
  padding: 5px;
  font-size: 13px;
}

#looks {
  margin: 0 auto;
}

#map-sat {
  display: block;
  position: absolute;
  z-index: 15;
  width: 25px;
  height: 25px;
}

#map-sensor {
  display: none;
  position: absolute;
  z-index: 15;
  width: 25px;
  height: 25px;
}

#launch-calendar-table tbody tr td {
  padding: 5px 5px;
}

#sat-hoverbox {
  display: none;
  background: var(--color-dark-background) !important;
  cursor: default;
  color: white;
  position: absolute;
  text-align: center;
  padding: 10px;
  border-radius: var(--kt-radius-md, 6px);
  border: 1px solid var(--kt-border-default, rgba(255, 255, 255, 0.12));
  box-shadow: var(--kt-shadow-lg, 0 4px 12px rgba(0, 0, 0, 0.4));
  pointer-events: none;
  z-index: 0;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  row-gap: 10px;
}

#sensor-selected-container {
  display: none;
  width: 0px;
  cursor: pointer;
  padding: 0px;
  transition: none;
  -webkit-transition: none;
}

#sensor-selected-container:hover,
#datetime-text:hover {
  background: rgba(255, 255, 255, 0.1);
}

#toast-container {
  min-width: 100%;
  top: 75px;
}

#version-box {
  background: transparent;
  right: 10px;
  width: 125px;
}

#version-text {
  font-family: var(--font-family);
  position: absolute;
  left: 1rem;
  top: 1rem;
  width: 100%;
  text-align: left;
  font-size: 14px;
  color: white;
  pointer-events: none;
  background: none;
  z-index: 1000;
  text-shadow:
    0 0px 2px rgba(0, 0, 0, 1),
    0 0px 2px #000;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: var(--kt-radius-full, 9999px);
  border: 2px solid transparent;
  background-clip: padding-box;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.55);
  border: 2px solid transparent;
  background-clip: padding-box;
}

::-webkit-scrollbar-thumb:active {
  background: rgba(255, 255, 255, 0.7);
  border: 2px solid transparent;
  background-clip: padding-box;
}

::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: var(--kt-radius-full, 9999px);
}

::-webkit-scrollbar-corner {
  background: transparent;
}

@keyframes shake {
  0% {
    filter: brightness(1.5);
  }

  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }

  100% {
    filter: '';
  }
}

/* non-desktop */
@media (max-width: 1300px) {
  .side-menu {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .side-menu::-webkit-scrollbar {
    display: none;
  }
}

a {
  text-decoration: none;
  color: var(--color-dark-text-accent) !important;
}


/* ========== Micro-Interactions & Focus ========== */

/* Press feedback for all interactive elements */
.drawer-item:active,
.drawer-utility-icon:active,
.bmenu-item .bmenu-item-inner:active,
.search-result:active:not(.search-result-decayed) {
  transform: scale(0.97);
}

/* Keyboard selected search result */
.search-result--selected {
  background: var(--kt-bg-active, rgba(255, 255, 255, 0.12));
  outline: 1px solid var(--kt-border-strong, #616161);
}

/* Search result type badge */
.search-type-badge {
  display: inline-block;
  padding: 1px 6px;
  border-radius: var(--kt-radius-sm, 4px);
  font-size: var(--kt-font-xs, 11px);
  font-weight: 600;
  letter-spacing: 0.5px;
  background: var(--kt-bg-surface, #424242);
  color: var(--kt-text-secondary, rgba(255, 255, 255, 0.7));
  margin-right: 8px;
  /*
   * Fixed width sized to the longest label ("MISSILE"/"SENSOR") so every badge
   * is identical and the name column lines up across rows regardless of type.
   */
  width: 64px;
  box-sizing: border-box;
  text-align: center;
  flex-shrink: 0;
}

/*
 * Right-hand column of a search result (sccNum / intl. designator for sats,
 * country for sensors and launch sites). Keep it on one line and right-aligned;
 * longer values (e.g. "United States") get an ellipsis instead of wrapping, and
 * the main name column shrinks to make room.
 */
.search-result-scc {
  flex-shrink: 0;
  max-width: 45%;
  margin-left: 8px;
  text-align: right;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.9em;
  color: var(--kt-text-secondary, rgba(255, 255, 255, 0.7));
}

/* Focus-visible for keyboard navigation */
:focus-visible {
  outline: 2px solid var(--kt-text-accent, #dd382f);
  outline-offset: 2px;
}

:focus:not(:focus-visible) {
  outline: none;
}

/* Custom focus for drawer items */
.drawer-item:focus-visible {
  outline: none;
  background: var(--kt-bg-hover, rgba(255, 255, 255, 0.08));
  box-shadow: inset 3px 0 0 var(--kt-text-accent, #dd382f);
}

/* Custom focus for utility icons */
.drawer-utility-icon:focus-visible {
  outline: none;
  background: var(--kt-bg-hover, rgba(255, 255, 255, 0.08));
  box-shadow: 0 0 0 2px var(--kt-text-accent, #dd382f);
  border-radius: var(--kt-radius-sm, 4px);
}

a,
.link {
  cursor: pointer;
}

fieldset {
  display: block;
  -webkit-margin-start: 0px;
  -webkit-margin-end: 0px;
  -webkit-padding-before: 0em;
  -webkit-padding-start: 0em;
  -webkit-padding-end: 0em;
  -webkit-padding-after: 0em;
  border: 0px;
  border-image-source: initial;
  border-image-slice: initial;
  border-image-width: initial;
  border-image-outset: initial;
  border-image-repeat: initial;
  min-width: -webkit-min-content;
  padding: 25px 30px;
}

footer {
  padding-top: 5px !important;
  position: absolute !important;
  top: auto !important;
  height: auto !important;
  margin-top: -100px;
  bottom: 0px;
  width: 100%;
}

input:-webkit-autofill {
  -webkit-text-fill-color: white !important;
  font-size: 16px;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  box-shadow: 0 0 0 30px var(--color-dark-background) inset !important;
  -webkit-box-shadow: 0 0 0 30px var(--color-dark-background) inset !important;
}

input[type='checkbox'].css-checkbox {
  position: absolute;
  z-index: -1000;
  left: -1000px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  height: 1px;
  width: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
}

input[type='checkbox'].css-checkbox+label.css-label {
  padding-left: 25px;
  height: 20px;
  display: inline-block;
  line-height: 20px;
  background-repeat: no-repeat;
  background-position: 0px 0px;
  font-size: 16px;
  vertical-align: middle;
  cursor: pointer;
}

input[type='checkbox'].css-checkbox:checked+label.css-label {
  background-position: 0px -20px;
}

label.css-label {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

ul li {
  list-style: none;
  padding: 5px;
}

#keeptrack-header {
  position: absolute;
  top: 0px;
  width: 100%;
  z-index: 105;
}


/* ========== Tooltip Popup ========== */

.kt-tooltip-popup {
  display: none;
  position: absolute;
  z-index: 999999;
  max-width: 220px;
  padding: var(--kt-space-2, 8px) var(--kt-space-3, 12px);
  background: var(--kt-bg-elevated, #303030);
  color: var(--kt-text-primary, #f5f5f5);
  font-size: var(--kt-font-sm, 13px);
  line-height: 1.4;
  text-align: center;
  border-radius: var(--kt-radius-md, 6px);
  box-shadow: var(--kt-shadow-lg, 0 8px 24px rgba(0, 0, 0, 0.5));
  border: 1px solid var(--kt-border-subtle, rgba(255, 255, 255, 0.05));
  pointer-events: none;
  opacity: 0;
  transform: translateY(4px);
  transition:
    opacity var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1)),
    transform var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
}

.kt-tooltip-popup.kt-tooltip-measuring {
  display: block;
  visibility: hidden;
  opacity: 0;
}

.kt-tooltip-popup.kt-tooltip-visible {
  display: block;
  opacity: 1;
  transform: translateY(0);
}`, "",{"version":3,"sources":["webpack://./public/css/style.common.css"],"names":[],"mappings":"AAEA,0FAA0F;;;AAG1F,4DAA4D;;AAE5D;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;EAC5B,6BAA6B;EAC7B,wBAAwB;EACxB,sBAAsB;;EAEtB,6GAA6G;;EAE7G,gCAAgC;;EAEhC,yBAAyB;;EAEzB,yEAAyE;EACzE,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;AAChC;;;AAGA,+CAA+C;;AAE/C;EACE,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,0DAA0D;AAC5D;;AAEA;;EAEE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;;AAGA,+CAA+C;;AAE/C;EACE,YAAY;EACZ,2BAA2B;EAC3B,SAAS;EACT,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,gCAAgC;EAChC,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yDAA2D;AAC7D;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;;;EAKE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;;EAEE,sBAAsB;EACtB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;EAIE,8BAA8B;AAChC;;AAEA;;;;EAIE,+BAA+B;AACjC;;AAEA;;;;EAIE,2BAA2B;AAC7B;;AAEA;;;;EAIE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,4BAA4B;EAC5B,WAAW;EACX,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,2BAA2B;EAC3B,wCAAwC;EACxC,kCAAkC;EAClC,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,+CAA+C;EAC/C,gDAAgD;EAChD,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,MAAM;AACR;;AAEA;EACE,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,OAAO;EACP,MAAM;AACR;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;;;;EAIE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,OAAO;EACP,SAAS;AACX;;AAEA;EACE,UAAU;EACV,OAAO;AACT;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,UAAU;EACV,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,kBAAkB;EAClB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,4BAA4B;EAC5B,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,yDAA2D;AAC7D;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;EAEE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,YAAY;EACZ,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,yDAAuG;AACzG;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;;;EAGE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mDAAyzE;EACzzE,YAAY;EACZ,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,MAAM;EACN,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,SAAS;EACT,OAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,WAAW;EACX,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,UAAU;EACV,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,UAAU;EACV,MAAM;EACN,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;EAC9C,sCAAsC;EACtC,WAAW;;EAEX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;;EAET,2BAA2B;;EAE3B,eAAe;AACjB;;AAEA;EACE,yBAAyB;;EAEzB,mBAAmB;;EAEnB,WAAW;;EAEX,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,iDAAiD;AACnD;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,MAAM;EACN,YAAY;AACd;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,WAAW;AACb;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,8CAA8C;EAC9C,+CAA+C;EAC/C,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;;EAEE,yDAA2D;AAC7D;;AAEA;;;EAGE,WAAW;EACX,qBAAqB;AACvB;;AAEA;;;;;;EAME,+CAA+C;EAC/C,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;;;;;;;EAOE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,aAAa;EACb,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,yDAA2D;AAC7D;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,+CAA+C;EAC/C,gDAAgD;EAChD,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;;EAEE,yDAA2D;AAC7D;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;;EAIE,yDAA2D;AAC7D;;AAEA;;;;;;;;;;EAUE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;;;;;EAQE,sBAAsB;EACtB,oCAAoC;EACpC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,qBAAqB;EACrB,sBAAsB;EACtB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,6CAA6C;EAC7C,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,qBAAqB;EACrB,SAAS;AACX;;AAEA;;EAEE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;;EAEE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,sCAAsC;EACtC,oCAAoC;EACpC,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,yDAA2D;AAC7D;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,iEAAiE;AACnE;;AAEA;EACE,gCAAgC;EAChC,iEAAiE;AACnE;;;AAGA,+DAA+D;;AAE/D;EACE,8CAA8C;AAChD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;EAEE,+BAA+B;AACjC;;;AAGA,mCAAmC;;AAEnC;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,kBAAkB;;EAElB,iBAAiB;;EAEjB,8CAA8C;EAC9C,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,sCAAsC;EACtC,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,SAAS;AACX;;;AAGA,+CAA+C;;AAE/C;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,UAAU;EACV,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,MAAM;EACN,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,WAAW;EACX,OAAO;EACP,SAAS;EACT,YAAY;EACZ,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,aAAa;EACb,YAAY;EACZ,wCAAwC;EACxC,2BAA2B;EAC3B,YAAY;EACZ,eAAe;EACf,cAAc;EACd,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,6BAA6B;EAC7B,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,qCAAqC;EACrC,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,SAAS;EACT,8CAA8C;EAC9C,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,cAAc;EACd,yDAA24C;AAC74C;;AAEA;EACE,yDAAmkC;AACrkC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;;;6DAI6D;AAC7D;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0DAAuiC;AACziC;;AAEA;EACE,iGAAiG;AACnG;;AAEA;EACE,0DAAm2B;AACr2B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,0DAAmwC;AACrwC;;AAEA;EACE,0GAA0G;EAC1G,0CAA0C;AAC5C;;AAEA;EACE,wGAAwG;EACxG,uBAAuB;AACzB;;AAEA;EACE,wGAAwG;EACxG,0CAA0C;AAC5C;;AAEA;;EAEE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yDAAyD;EACzD,eAAe;AACjB;;AAEA;EACE,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,uCAAuC;EACvC,qEAAqE;EACrE,8DAA8D;EAC9D,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,kHAAkH;EAClH,gBAAgB;AAClB;;AAEA;;;;;EAKE;AACF;EACE,wBAAwB;AAC1B;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,2BAA2B;EAC3B,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,uGAAuG;EACvG,4BAA4B;EAC5B,wCAAwC;EACxC,UAAU;EACV,2EAA2E;EAC3E,8DAA8D;EAC9D,YAAY;EACZ,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,4EAA4E;EAC5E,yCAAyC;EACzC,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,OAAO;EACP,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;;;AAIA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,uCAAuC;EACvC,kHAAkH;AACpH;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,gEAAgE;EAChE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,YAAY;AACd;;AAEA,iDAAiD;AACjD;EACE,kHAAkH;AACpH;;AAEA;EACE,+DAA+D;AACjE;;AAEA;;;;sEAIsE;AACtE;EACE,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,2EAA2E;EAC3E,6DAA6D;EAC7D,wCAAwC;EACxC,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,WAAW;EACX,cAAc;EACd,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,SAAS;AACX;;AAEA,uFAAuF;AACvF;EACE,mDAAmD;EACnD,oDAAoD;AACtD;;AAEA;EACE,6CAA6C;EAC7C,iDAAiD;AACnD;;AAEA;;EAEE,iDAAiD;EACjD,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,0CAA0C;EAC1C,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,8CAA8C;EAC9C,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;;;EAIE,6BAA6B;EAC7B,kCAAkC;EAClC,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,wCAAwC;EACxC,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,SAAS;EACT,0CAA0C;EAC1C,cAAc;EACd,eAAe;EACf,gBAAgB;;EAEhB,qCAAqC;EACrC,YAAY;;EAEZ,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,mCAAmC;EACnC,kHAAkH;AACpH;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,wEAAwE;AAC1E;;;AAGA,+CAA+C;;AAE/C;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;;AAGA,4CAA4C;;AAE5C;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,wCAAwC;EACxC,eAAe;EACf,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,wEAAwE;EACxE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yDAAyD;EACzD,yDAAyD;EACzD,yCAAyC;EACzC,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,kHAAkH;AACpH;;AAEA;EACE,yDAAyD;EACzD,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,qGAAqG;AACvG;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oGAAoG;EACpG,UAAU;AACZ;;AAEA;EACE,oGAAoG;EACpG,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB;;;;;;IAME;EACF,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mDAAmD;EACnD,UAAU;EACV,2BAA2B;EAC3B,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;AACxC;;;AAGA,6CAA6C;;AAE7C;EACE,+CAA+C;EAC/C,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,WAAW;EACX,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,kFAAkF;EAClF,cAAc;EACd,YAAY;EACZ,UAAU;EACV,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;;AAGA,0CAA0C;;AAE1C;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB;;mCAEiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,2GAA2G;AAC7G;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,2BAA2B;EAC3B,sBAAsB;EACtB,wBAAwB;EACxB,4BAA4B;EAC5B;;;cAGY;EACZ,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iGAAiG;AACnG;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;EACZ,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;;;;EAIE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,gDAAgD;EAChD,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,wCAAwC;AAC1C;;;AAGA,uCAAuC;;AAEvC;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gHAAgH;EAChH,+CAA+C;EAC/C,YAAY;EACZ,gDAAgD;EAChD,4CAA4C;EAC5C,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;EACZ,wCAAwC;EACxC,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;EACX,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;;EAEnB,sBAAsB;EACtB,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,iEAAiE;AACjE;EACE,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,wCAAwC;EACxC,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,iCAAiC;EACjC,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,wCAAwC;EACxC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,+BAA+B;EAC/B,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,2CAA2C;EAC3C,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,8CAA8C;EAC9C,aAAa;EACb,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,0CAA0C;EAC1C,aAAa;EACb,oCAAoC;EACpC,kBAAkB;EAClB,wCAAwC;EACxC,0CAA0C;;EAE1C,wBAAwB;EACxB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb;;oBAEkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mGAAmG;EACnG,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,oCAAoC;;EAEpC,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,QAAQ;;EAER,UAAU;EACV,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,oCAAoC;EACpC,iDAAiD;AACnD;;AAEA;;EAEE,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,iBAAiB;EACjB,oCAAoC;EACpC,0CAA0C;EAC1C,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,6BAA6B;;EAE7B,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;;EAEhC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,YAAY;EACZ,YAAY;EACZ,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,UAAU;EACV,YAAY;EACZ,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,iCAAiC;EACjC,YAAY;EACZ,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mDAAmD;EACnD,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,uCAAuC;EACvC,qEAAqE;EACrE,8DAA8D;EAC9D,oBAAoB;EACpB,UAAU;EACV,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,UAAU;EACV,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb;;kBAEgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,4CAA4C;EAC5C,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;;IAEE,kCAAkC;EACpC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;;IAGE,kCAAkC;EACpC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,gBAAgB;AAChB;EACE;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;;AAGA,qDAAqD;;AAErD,gDAAgD;AAChD;;;;EAIE,sBAAsB;AACxB;;AAEA,oCAAoC;AACpC;EACE,0DAA0D;EAC1D,mDAAmD;AACrD;;AAEA,6BAA6B;AAC7B;EACE,qBAAqB;EACrB,gBAAgB;EAChB,uCAAuC;EACvC,kCAAkC;EAClC,gBAAgB;EAChB,qBAAqB;EACrB,yCAAyC;EACzC,yDAAyD;EACzD,iBAAiB;EACjB;;;IAGE;EACF,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;;;EAKE;AACF;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,yDAAyD;AAC3D;;AAEA,0CAA0C;AAC1C;EACE,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,yDAAyD;EACzD,wDAAwD;AAC1D;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,yDAAyD;EACzD,oDAAoD;EACpD,uCAAuC;AACzC;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,wBAAwB;EACxB,0BAA0B;EAC1B,WAAW;EACX,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC,eAAe;AACjB;;AAEA;;;;EAIE,oEAAoE;EACpE,4EAA4E;AAC9E;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,4BAA4B;EAC5B,4BAA4B;EAC5B,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;;AAGA,wCAAwC;;AAExC;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uDAAuD;EACvD,0CAA0C;EAC1C,sCAAsC;EACtC,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,8DAA8D;EAC9D,oEAAoE;EACpE,oBAAoB;EACpB,UAAU;EACV,0BAA0B;EAC1B;;mGAEiG;AACnG;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,UAAU;EACV,wBAAwB;AAC1B","sourcesContent":["@import url('design-tokens.css');\n\n/* Common CSS Rules - Extracted from style.css, style.celestrak.css, and style.embed.css */\n\n\n/* ========== CSS Custom Properties (Variables) ========== */\n\n:root {\n  --bottom-menu-top: 0px;\n  --bottom-icon-height: 75px;\n  --bottom-icon-width: 115px;\n  --bottom-icon-img-size: 40px;\n  --bottom-filter-width: 265px;\n  --bottom-utility-width: 300px;\n  --search-box-bottom: 0px;\n  --nav-bar-height: 50px;\n\n  --top-menu-height: calc(var(--nav-bar-height) + var(--classification-bar-height) + var(--time-slider-height));\n\n  --classification-bar-height: 0px;\n\n  --time-slider-height: 0px;\n\n  /* Breakpoints (for JS access - CSS @media can't use custom properties) */\n  --bp-mobile: 694px;\n  /* mobile: max-width 694px */\n  --bp-tablet: 1300px;\n  /* tablet: 695px–1300px */\n  /* desktop: min-width 1301px */\n}\n\n\n/* ========== HTML and Body Styles ========== */\n\nbody {\n  overflow: hidden;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-tap-highlight-color: var(--color-dark-text-accent);\n}\n\ninput,\ntextarea {\n  -webkit-user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  user-select: text;\n}\n\n\n/* ========== jQuery UI Components ========== */\n\n#ui-datepicker-div {\n  border: none;\n  top: var(--top-menu-height);\n  left: 0px;\n  width: 100%;\n  border-radius: 0px;\n}\n\n.ui-accordion .ui-accordion-content {\n  padding: 1em 2.2em;\n  border-top: 0;\n  overflow: auto;\n}\n\n.ui-accordion .ui-accordion-header {\n  display: block;\n  cursor: pointer;\n  position: relative;\n  margin: 2px 0 0 0;\n  padding: 0.5em 0.5em 0.5em 0.7em;\n  font-size: 100%;\n}\n\n.ui-autocomplete {\n  position: absolute;\n  top: 0;\n  left: 0;\n  cursor: default;\n}\n\n.ui-button {\n  border: 1px solid var(--colorTertiary);\n  background: var(--colorTertiary);\n  padding: 0.4em 1em;\n  display: inline-block;\n  position: relative;\n  line-height: normal;\n  margin-right: 0.1em;\n  cursor: pointer;\n  vertical-align: middle;\n  text-align: center;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  overflow: visible;\n}\n\n.ui-button .ui-icon {\n  background-image: url('images/ui-icons_777777_256x240.png');\n}\n\n.ui-button span {\n  filter: brightness(5);\n}\n\n.ui-button,\n.ui-button:link,\n.ui-button:visited,\n.ui-button:hover,\n.ui-button:active {\n  text-decoration: none;\n}\n\n.ui-button-icon-only {\n  width: 2em;\n  box-sizing: border-box;\n  text-indent: -9999px;\n  white-space: nowrap;\n}\n\n.ui-button-icon-only .ui-icon {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin-top: -8px;\n  margin-left: -8px;\n}\n\n.ui-button.ui-icon-notext .ui-icon {\n  padding: 0;\n  width: 2.1em;\n  height: 2.1em;\n  text-indent: -9999px;\n  white-space: nowrap;\n}\n\n.ui-checkboxradio-disabled {\n  pointer-events: none;\n}\n\n.ui-checkboxradio-label .ui-icon-background {\n  box-shadow: inset 1px 1px 1px #ccc;\n  border-radius: 0.12em;\n  border: none;\n}\n\n.ui-checkboxradio-radio-label .ui-icon-background {\n  width: 16px;\n  height: 16px;\n  border-radius: 1em;\n  overflow: visible;\n  border: none;\n}\n\n.ui-checkboxradio-radio-label.ui-checkboxradio-checked .ui-icon,\n.ui-checkboxradio-radio-label.ui-checkboxradio-checked:hover .ui-icon {\n  background-image: none;\n  width: 8px;\n  height: 8px;\n  border-width: 4px;\n  border-style: solid;\n}\n\n.ui-controlgroup {\n  vertical-align: middle;\n  display: inline-block;\n}\n\n.ui-controlgroup .ui-controlgroup-label {\n  padding: 0.4em 1em;\n}\n\n.ui-controlgroup .ui-controlgroup-label span {\n  font-size: 80%;\n}\n\n.ui-controlgroup-horizontal .ui-controlgroup-label+.ui-controlgroup-item {\n  border-left: none;\n}\n\n.ui-controlgroup-horizontal .ui-controlgroup-label.ui-widget-content {\n  border-right: none;\n}\n\n.ui-controlgroup-vertical .ui-controlgroup-item {\n  box-sizing: border-box;\n}\n\n.ui-controlgroup-vertical .ui-controlgroup-label+.ui-controlgroup-item {\n  border-top: none;\n}\n\n.ui-controlgroup-vertical .ui-controlgroup-label.ui-widget-content {\n  border-bottom: none;\n}\n\n.ui-controlgroup-vertical .ui-spinner .ui-spinner-up {\n  border-top-style: solid;\n}\n\n.ui-controlgroup-vertical .ui-spinner-input {\n  width: 75%;\n  width: calc(100% - 2.4em);\n}\n\n.ui-controlgroup-vertical>.ui-controlgroup-item {\n  display: block;\n  float: none;\n  width: 100%;\n  margin-top: 0;\n  margin-bottom: 0;\n  text-align: left;\n}\n\n.ui-controlgroup>.ui-controlgroup-item {\n  float: left;\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.ui-controlgroup>.ui-controlgroup-item:focus,\n.ui-controlgroup>.ui-controlgroup-item.ui-visual-focus {\n  z-index: 9999;\n}\n\n.ui-corner-all,\n.ui-corner-bottom,\n.ui-corner-left,\n.ui-corner-bl {\n  border-bottom-left-radius: 3px;\n}\n\n.ui-corner-all,\n.ui-corner-bottom,\n.ui-corner-right,\n.ui-corner-br {\n  border-bottom-right-radius: 3px;\n}\n\n.ui-corner-all,\n.ui-corner-top,\n.ui-corner-left,\n.ui-corner-tl {\n  border-top-left-radius: 3px;\n}\n\n.ui-corner-all,\n.ui-corner-top,\n.ui-corner-right,\n.ui-corner-tr {\n  border-top-right-radius: 3px;\n}\n\n.ui-datepicker {\n  width: 17em;\n  padding: 0.2em 0.2em 0;\n  display: none;\n}\n\n.ui-datepicker .ui-datepicker-buttonpane {\n  background-image: none;\n  margin: 0.7em 0 0 0;\n  padding: 0 0.2em;\n  border-left: 0;\n  border-right: 0;\n  border-bottom: 0;\n}\n\n.ui-datepicker .ui-datepicker-buttonpane button {\n  float: right;\n  margin: 0.5em 0.2em 0.4em;\n  cursor: pointer;\n  width: auto;\n  overflow: visible;\n  padding: 1em;\n}\n\n.ui-datepicker .ui-datepicker-buttonpane button.ui-datepicker-current {\n  float: left;\n}\n\n.ui-datepicker .ui-datepicker-buttonpane button.ui-datepicker-pause {\n  float: none;\n}\n\n.ui-datepicker .ui-datepicker-header {\n  position: relative;\n  padding: 0.2em 0;\n}\n\n.ui-datepicker .ui-datepicker-next {\n  right: 2px;\n}\n\n.ui-datepicker .ui-datepicker-next-hover {\n  right: 1px;\n}\n\n.ui-datepicker .ui-datepicker-prev {\n  left: 2px;\n}\n\n.ui-datepicker .ui-datepicker-prev span,\n.ui-datepicker .ui-datepicker-next span {\n  display: block;\n  position: absolute;\n  left: 50%;\n  margin-left: -8px;\n  top: 50%;\n  margin-top: -8px;\n}\n\n.ui-datepicker .ui-datepicker-prev,\n.ui-datepicker .ui-datepicker-next {\n  position: absolute;\n  top: 2px;\n  width: 1.8em;\n  height: 1.8em;\n}\n\n.ui-datepicker .ui-datepicker-prev-hover {\n  left: 1px;\n}\n\n.ui-datepicker .ui-datepicker-prev-hover,\n.ui-datepicker .ui-datepicker-next-hover {\n  top: 1px;\n}\n\n.ui-datepicker .ui-datepicker-title {\n  margin: 0 2.3em;\n  line-height: 1.8em;\n  text-align: center;\n}\n\n.ui-datepicker .ui-datepicker-title select {\n  font-size: 1em;\n  margin: 1px 0;\n}\n\n.ui-datepicker .ui-icon {\n  display: block;\n  text-indent: -99999px;\n  overflow: hidden;\n  background-repeat: no-repeat;\n  left: 0.5em;\n  top: 0.3em;\n}\n\n.ui-datepicker select.ui-datepicker-month,\n.ui-datepicker select.ui-datepicker-year {\n  width: 45%;\n}\n\n.ui-datepicker table {\n  width: 100%;\n  font-size: 0.9em;\n  border-collapse: collapse;\n  margin: 0 0 0.4em;\n}\n\n.ui-datepicker td {\n  border: 1px solid rgba(0, 0, 0, 0);\n  padding: 1px;\n}\n\n.ui-datepicker td a {\n  padding: 15px 0.2em;\n}\n\n.ui-datepicker td span,\n.ui-datepicker td a {\n  display: block;\n  padding: 0.2em;\n  text-align: right;\n  text-decoration: none;\n}\n\n.ui-datepicker th {\n  padding: 0.7em 0.3em;\n  text-align: center;\n  font-weight: normal;\n  border: 0;\n}\n\n.ui-datepicker-calendar {\n  margin-bottom: 0px;\n}\n\n.ui-datepicker-calendar tbody tr {\n  border: 0px !important;\n}\n\n.ui-datepicker-calendar tbody tr td a {\n  display: flex;\n  font-weight: bold;\n  color: var(--color-primary);\n  background: var(--color-dark-background);\n  border: 1px solid rgba(0, 0, 0, 0);\n  height: 45px;\n  width: 45px;\n  justify-content: flex-start;\n  align-items: center;\n  flex-direction: column;\n}\n\n.ui-datepicker-calendar tbody tr td a:hover {\n  border: 1px solid rgb(230, 230, 230) !important;\n  background: rgba(230, 230, 230, 0.15) !important;\n  color: var(--colorWhite) !important;\n  border-radius: 3px;\n}\n\n.ui-datepicker-calendar thead tr {\n  border: 0px !important;\n}\n\n.ui-datepicker-jday {\n  text-align: end;\n  width: 100%;\n  font-size: smaller;\n  font-weight: normal;\n  color: var(--colorWhite);\n}\n\n.ui-datepicker-multi .ui-datepicker-buttonpane {\n  clear: left;\n}\n\n.ui-datepicker-multi .ui-datepicker-group {\n  float: left;\n}\n\n.ui-datepicker-multi .ui-datepicker-group table {\n  width: 95%;\n  margin: 0 auto 0.4em;\n}\n\n.ui-datepicker-multi .ui-datepicker-group-last .ui-datepicker-header,\n.ui-datepicker-multi .ui-datepicker-group-middle .ui-datepicker-header {\n  border-left-width: 0;\n}\n\n.ui-datepicker-multi-2 .ui-datepicker-group {\n  width: 50%;\n}\n\n.ui-datepicker-multi-3 .ui-datepicker-group {\n  width: 33.3%;\n}\n\n.ui-datepicker-multi-4 .ui-datepicker-group {\n  width: 25%;\n}\n\n.ui-datepicker-row-break {\n  clear: both;\n  width: 100%;\n  font-size: 0;\n}\n\n.ui-datepicker-rtl {\n  direction: rtl;\n}\n\n.ui-datepicker-rtl .ui-datepicker-buttonpane {\n  clear: right;\n}\n\n.ui-datepicker-rtl .ui-datepicker-buttonpane button {\n  float: left;\n}\n\n.ui-datepicker-rtl .ui-datepicker-buttonpane button.ui-datepicker-current,\n.ui-datepicker-rtl .ui-datepicker-group {\n  float: right;\n}\n\n.ui-datepicker-rtl .ui-datepicker-group-last .ui-datepicker-header,\n.ui-datepicker-rtl .ui-datepicker-group-middle .ui-datepicker-header {\n  border-right-width: 0;\n  border-left-width: 1px;\n}\n\n.ui-datepicker-rtl .ui-datepicker-next {\n  left: 2px;\n  right: auto;\n}\n\n.ui-datepicker-rtl .ui-datepicker-next:hover {\n  left: 1px;\n  right: auto;\n}\n\n.ui-datepicker-rtl .ui-datepicker-prev {\n  right: 2px;\n  left: auto;\n}\n\n.ui-datepicker-rtl .ui-datepicker-prev:hover {\n  right: 1px;\n  left: auto;\n}\n\n.ui-datepicker.ui-datepicker-multi {\n  width: auto;\n}\n\n.ui-dialog {\n  position: absolute;\n  top: 0;\n  left: 0;\n  padding: 0.2em;\n  outline: 0;\n}\n\n.ui-dialog .ui-dialog-buttonpane {\n  text-align: left;\n  border-width: 1px 0 0 0;\n  background-image: none;\n  margin-top: 0.5em;\n  padding: 0.3em 1em 0.5em 0.4em;\n}\n\n.ui-dialog .ui-dialog-buttonpane .ui-dialog-buttonset {\n  float: right;\n}\n\n.ui-dialog .ui-dialog-buttonpane button {\n  margin: 0.5em 0.4em 0.5em 0;\n  cursor: pointer;\n}\n\n.ui-dialog .ui-dialog-content {\n  position: relative;\n  border: 0;\n  padding: 0.5em 1em;\n  background: none;\n  overflow: auto;\n}\n\n.ui-dialog .ui-dialog-title {\n  float: left;\n  margin: 0.1em 0;\n  white-space: nowrap;\n  width: 90%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ui-dialog .ui-dialog-titlebar {\n  padding: 0.4em 1em;\n  position: relative;\n}\n\n.ui-dialog .ui-dialog-titlebar-close {\n  position: absolute;\n  right: 0.3em;\n  top: 50%;\n  width: 20px;\n  margin: -10px 0 0 0;\n  padding: 1px;\n  height: 20px;\n}\n\n.ui-dialog .ui-resizable-e {\n  width: 2px;\n  right: 0;\n}\n\n.ui-dialog .ui-resizable-n {\n  height: 2px;\n  top: 0;\n}\n\n.ui-dialog .ui-resizable-ne {\n  right: 0;\n  top: 0;\n}\n\n.ui-dialog .ui-resizable-nw {\n  left: 0;\n  top: 0;\n}\n\n.ui-dialog .ui-resizable-s {\n  height: 2px;\n  bottom: 0;\n}\n\n.ui-dialog .ui-resizable-se {\n  right: 0;\n  bottom: 0;\n}\n\n.ui-dialog .ui-resizable-se,\n.ui-dialog .ui-resizable-sw,\n.ui-dialog .ui-resizable-ne,\n.ui-dialog .ui-resizable-nw {\n  width: 7px;\n  height: 7px;\n}\n\n.ui-dialog .ui-resizable-sw {\n  left: 0;\n  bottom: 0;\n}\n\n.ui-dialog .ui-resizable-w {\n  width: 2px;\n  left: 0;\n}\n\n.ui-draggable .ui-dialog-titlebar {\n  cursor: move;\n}\n\n.ui-draggable-handle {\n  -ms-touch-action: none;\n  touch-action: none;\n}\n\n.ui-front {\n  z-index: 100;\n}\n\n.ui-helper-clearfix:after {\n  clear: both;\n}\n\n.ui-helper-clearfix:before,\n.ui-helper-clearfix:after {\n  content: '';\n  display: table;\n  border-collapse: collapse;\n}\n\n.ui-helper-hidden {\n  display: none;\n}\n\n.ui-helper-hidden-accessible {\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.ui-helper-reset {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  outline: 0;\n  line-height: 1.3;\n  text-decoration: none;\n  font-size: 100%;\n  list-style: none;\n}\n\n.ui-helper-zfix {\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  position: absolute;\n  opacity: 0;\n  filter: Alpha(Opacity=0);\n}\n\n.ui-icon {\n  display: inline-block;\n  vertical-align: middle;\n  margin-top: -0.25em;\n  position: relative;\n  text-indent: -99999px;\n  overflow: hidden;\n  background-repeat: no-repeat;\n  width: 16px;\n  height: 16px;\n}\n\n.ui-icon,\n.ui-widget-content .ui-icon {\n  background-image: url('images/ui-icons_444444_256x240.png');\n}\n\n.ui-icon-alert {\n  background-position: 0 -144px;\n}\n\n.ui-icon-arrow-1-e {\n  background-position: -32px -32px;\n}\n\n.ui-icon-arrow-1-n {\n  background-position: 0 -32px;\n}\n\n.ui-icon-arrow-1-ne {\n  background-position: -16px -32px;\n}\n\n.ui-icon-arrow-1-nw {\n  background-position: -112px -32px;\n}\n\n.ui-icon-arrow-1-s {\n  background-position: -65px -32px;\n}\n\n.ui-icon-arrow-1-se {\n  background-position: -48px -32px;\n}\n\n.ui-icon-arrow-1-sw {\n  background-position: -80px -32px;\n}\n\n.ui-icon-arrow-1-w {\n  background-position: -96px -32px;\n}\n\n.ui-icon-arrow-2-e-w {\n  background-position: -160px -32px;\n}\n\n.ui-icon-arrow-2-n-s {\n  background-position: -128px -32px;\n}\n\n.ui-icon-arrow-2-ne-sw {\n  background-position: -144px -32px;\n}\n\n.ui-icon-arrow-2-se-nw {\n  background-position: -176px -32px;\n}\n\n.ui-icon-arrow-4 {\n  background-position: 0 -80px;\n}\n\n.ui-icon-arrow-4-diag {\n  background-position: -16px -80px;\n}\n\n.ui-icon-arrowrefresh-1-e {\n  background-position: -160px -64px;\n}\n\n.ui-icon-arrowrefresh-1-n {\n  background-position: -144px -64px;\n}\n\n.ui-icon-arrowrefresh-1-s {\n  background-position: -176px -64px;\n}\n\n.ui-icon-arrowrefresh-1-w {\n  background-position: -128px -64px;\n}\n\n.ui-icon-arrowreturn-1-e {\n  background-position: -96px -64px;\n}\n\n.ui-icon-arrowreturn-1-n {\n  background-position: -80px -64px;\n}\n\n.ui-icon-arrowreturn-1-s {\n  background-position: -112px -64px;\n}\n\n.ui-icon-arrowreturn-1-w {\n  background-position: -64px -64px;\n}\n\n.ui-icon-arrowreturnthick-1-e {\n  background-position: -32px -64px;\n}\n\n.ui-icon-arrowreturnthick-1-n {\n  background-position: -16px -64px;\n}\n\n.ui-icon-arrowreturnthick-1-s {\n  background-position: -48px -64px;\n}\n\n.ui-icon-arrowreturnthick-1-w {\n  background-position: 0 -64px;\n}\n\n.ui-icon-arrowstop-1-e {\n  background-position: -208px -32px;\n}\n\n.ui-icon-arrowstop-1-n {\n  background-position: -192px -32px;\n}\n\n.ui-icon-arrowstop-1-s {\n  background-position: -224px -32px;\n}\n\n.ui-icon-arrowstop-1-w {\n  background-position: -240px -32px;\n}\n\n.ui-icon-arrowthick-1-e {\n  background-position: -32px -48px;\n}\n\n.ui-icon-arrowthick-1-n {\n  background-position: 1px -48px;\n}\n\n.ui-icon-arrowthick-1-ne {\n  background-position: -16px -48px;\n}\n\n.ui-icon-arrowthick-1-nw {\n  background-position: -112px -48px;\n}\n\n.ui-icon-arrowthick-1-s {\n  background-position: -64px -48px;\n}\n\n.ui-icon-arrowthick-1-se {\n  background-position: -48px -48px;\n}\n\n.ui-icon-arrowthick-1-sw {\n  background-position: -80px -48px;\n}\n\n.ui-icon-arrowthick-1-w {\n  background-position: -96px -48px;\n}\n\n.ui-icon-arrowthick-2-e-w {\n  background-position: -160px -48px;\n}\n\n.ui-icon-arrowthick-2-n-s {\n  background-position: -128px -48px;\n}\n\n.ui-icon-arrowthick-2-ne-sw {\n  background-position: -144px -48px;\n}\n\n.ui-icon-arrowthick-2-se-nw {\n  background-position: -176px -48px;\n}\n\n.ui-icon-arrowthickstop-1-e {\n  background-position: -208px -48px;\n}\n\n.ui-icon-arrowthickstop-1-n {\n  background-position: -192px -48px;\n}\n\n.ui-icon-arrowthickstop-1-s {\n  background-position: -224px -48px;\n}\n\n.ui-icon-arrowthickstop-1-w {\n  background-position: -240px -48px;\n}\n\n.ui-icon-background,\n.ui-state-active .ui-icon-background {\n  border: #003eff;\n  background-color: #fff;\n}\n\n.ui-icon-battery-0 {\n  background-position: -48px -176px;\n}\n\n.ui-icon-battery-1 {\n  background-position: -64px -176px;\n}\n\n.ui-icon-battery-2 {\n  background-position: -80px -176px;\n}\n\n.ui-icon-battery-3 {\n  background-position: -96px -176px;\n}\n\n.ui-icon-blank {\n  background-position: 16px 16px;\n}\n\n.ui-icon-bookmark {\n  background-position: -224px -96px;\n}\n\n.ui-icon-bullet {\n  background-position: -80px -144px;\n}\n\n.ui-icon-calculator {\n  background-position: -112px -112px;\n}\n\n.ui-icon-calendar {\n  background-position: -32px -112px;\n}\n\n.ui-icon-cancel {\n  background-position: 0 -128px;\n}\n\n.ui-icon-caret-1-e {\n  background-position: -32px 0;\n}\n\n.ui-icon-caret-1-n {\n  background-position: 0 0;\n}\n\n.ui-icon-caret-1-ne {\n  background-position: -16px 0;\n}\n\n.ui-icon-caret-1-nw {\n  background-position: -112px 0;\n}\n\n.ui-icon-caret-1-s {\n  background-position: -65px 0;\n}\n\n.ui-icon-caret-1-se {\n  background-position: -48px 0;\n}\n\n.ui-icon-caret-1-sw {\n  background-position: -80px 0;\n}\n\n.ui-icon-caret-1-w {\n  background-position: -96px 0;\n}\n\n.ui-icon-caret-2-e-w {\n  background-position: -144px 0;\n}\n\n.ui-icon-caret-2-n-s {\n  background-position: -128px 0;\n}\n\n.ui-icon-cart {\n  background-position: -48px -112px;\n}\n\n.ui-icon-check {\n  background-position: -64px -144px;\n}\n\n.ui-icon-circle-arrow-e {\n  background-position: -112px -192px;\n}\n\n.ui-icon-circle-arrow-n {\n  background-position: -160px -192px;\n}\n\n.ui-icon-circle-arrow-s {\n  background-position: -128px -192px;\n}\n\n.ui-icon-circle-arrow-w {\n  background-position: -144px -192px;\n}\n\n.ui-icon-circle-check {\n  background-position: -208px -192px;\n}\n\n.ui-icon-circle-close {\n  background-position: -32px -192px;\n}\n\n.ui-icon-circle-minus {\n  background-position: -16px -192px;\n}\n\n.ui-icon-circle-plus {\n  background-position: 0 -192px;\n}\n\n.ui-icon-circle-triangle-n {\n  background-position: -96px -192px;\n}\n\n.ui-icon-circle-triangle-s {\n  background-position: -64px -192px;\n}\n\n.ui-icon-circle-zoomin {\n  background-position: -176px -192px;\n}\n\n.ui-icon-circle-zoomout {\n  background-position: -192px -192px;\n}\n\n.ui-icon-circlesmall-close {\n  background-position: -32px -208px;\n}\n\n.ui-icon-circlesmall-minus {\n  background-position: -16px -208px;\n}\n\n.ui-icon-circlesmall-plus {\n  background-position: 0 -208px;\n}\n\n.ui-icon-clipboard {\n  background-position: -160px -128px;\n}\n\n.ui-icon-clock {\n  background-position: -80px -112px;\n}\n\n.ui-icon-close {\n  background-position: -80px -128px;\n}\n\n.ui-icon-closethick {\n  background-position: -96px -128px;\n}\n\n.ui-icon-comment {\n  background-position: -128px -96px;\n}\n\n.ui-icon-contact {\n  background-position: -192px -128px;\n}\n\n.ui-icon-copy {\n  background-position: -176px -128px;\n}\n\n.ui-icon-disk {\n  background-position: -96px -112px;\n}\n\n.ui-icon-document {\n  background-position: -32px -96px;\n}\n\n.ui-icon-document-b {\n  background-position: -48px -96px;\n}\n\n.ui-icon-eject {\n  background-position: -112px -160px;\n}\n\n.ui-icon-extlink {\n  background-position: -32px -80px;\n}\n\n.ui-icon-flag {\n  background-position: -16px -112px;\n}\n\n.ui-icon-folder-collapsed {\n  background-position: 0 -96px;\n}\n\n.ui-icon-folder-open {\n  background-position: -16px -96px;\n}\n\n.ui-icon-gear {\n  background-position: -192px -112px;\n}\n\n.ui-icon-grip-diagonal-se {\n  background-position: -80px -224px;\n}\n\n.ui-icon-grip-dotted-horizontal {\n  background-position: -16px -224px;\n}\n\n.ui-icon-grip-dotted-vertical {\n  background-position: 0 -224px;\n}\n\n.ui-icon-grip-solid-horizontal {\n  background-position: -48px -224px;\n}\n\n.ui-icon-grip-solid-vertical {\n  background-position: -32px -224px;\n}\n\n.ui-icon-gripsmall-diagonal-se {\n  background-position: -64px -224px;\n}\n\n.ui-icon-heart {\n  background-position: -208px -112px;\n}\n\n.ui-icon-help {\n  background-position: -48px -144px;\n}\n\n.ui-icon-home {\n  background-position: 0 -112px;\n}\n\n.ui-icon-image {\n  background-position: -208px -128px;\n}\n\n.ui-icon-info {\n  background-position: -16px -144px;\n}\n\n.ui-icon-key {\n  background-position: -112px -128px;\n}\n\n.ui-icon-lightbulb {\n  background-position: -128px -128px;\n}\n\n.ui-icon-link {\n  background-position: -240px -112px;\n}\n\n.ui-icon-locked {\n  background-position: -192px -96px;\n}\n\n.ui-icon-mail-closed {\n  background-position: -80px -96px;\n}\n\n.ui-icon-mail-open {\n  background-position: -96px -96px;\n}\n\n.ui-icon-minus {\n  background-position: -48px -128px;\n}\n\n.ui-icon-minusthick {\n  background-position: -64px -128px;\n}\n\n.ui-icon-newwin {\n  background-position: -48px -80px;\n}\n\n.ui-icon-note {\n  background-position: -64px -96px;\n}\n\n.ui-icon-notice {\n  background-position: -32px -144px;\n}\n\n.ui-icon-pause {\n  background-position: -16px -160px;\n}\n\n.ui-icon-pencil {\n  background-position: -64px -112px;\n}\n\n.ui-icon-person {\n  background-position: -144px -96px;\n}\n\n.ui-icon-pin-s {\n  background-position: -144px -144px;\n}\n\n.ui-icon-pin-w {\n  background-position: -128px -144px;\n}\n\n.ui-icon-play {\n  background-position: 0 -160px;\n}\n\n.ui-icon-plus {\n  background-position: -16px -128px;\n}\n\n.ui-icon-plusthick {\n  background-position: -32px -128px;\n}\n\n.ui-icon-power {\n  background-position: 0 -176px;\n}\n\n.ui-icon-print {\n  background-position: -160px -96px;\n}\n\n.ui-icon-radio-off {\n  background-position: -112px -144px;\n}\n\n.ui-icon-radio-on {\n  background-position: -96px -144px;\n}\n\n.ui-icon-refresh {\n  background-position: -64px -80px;\n}\n\n.ui-icon-scissors {\n  background-position: -144px -128px;\n}\n\n.ui-icon-script {\n  background-position: -240px -128px;\n}\n\n.ui-icon-search {\n  background-position: -160px -112px;\n}\n\n.ui-icon-seek-end {\n  background-position: -64px -160px;\n}\n\n.ui-icon-seek-first {\n  background-position: -80px -160px;\n}\n\n.ui-icon-seek-next {\n  background-position: -32px -160px;\n}\n\n.ui-icon-seek-prev {\n  background-position: -48px -160px;\n}\n\n.ui-icon-seek-start {\n  background-position: -80px -160px;\n}\n\n.ui-icon-shuffle {\n  background-position: -80px -80px;\n}\n\n.ui-icon-signal {\n  background-position: -32px -176px;\n}\n\n.ui-icon-signal-diag {\n  background-position: -16px -176px;\n}\n\n.ui-icon-squaresmall-close {\n  background-position: -80px -208px;\n}\n\n.ui-icon-squaresmall-minus {\n  background-position: -64px -208px;\n}\n\n.ui-icon-squaresmall-plus {\n  background-position: -48px -208px;\n}\n\n.ui-icon-star {\n  background-position: -224px -112px;\n}\n\n.ui-icon-stop {\n  background-position: -96px -160px;\n}\n\n.ui-icon-suitcase {\n  background-position: -112px -96px;\n}\n\n.ui-icon-tag {\n  background-position: -240px -96px;\n}\n\n.ui-icon-transfer-e-w {\n  background-position: -96px -80px;\n}\n\n.ui-icon-transferthick-e-w {\n  background-position: -112px -80px;\n}\n\n.ui-icon-trash {\n  background-position: -176px -96px;\n}\n\n.ui-icon-triangle-1-e {\n  background-position: -32px -16px;\n}\n\n.ui-icon-triangle-1-n {\n  background-position: 0 -16px;\n}\n\n.ui-icon-triangle-1-ne {\n  background-position: -16px -16px;\n}\n\n.ui-icon-triangle-1-nw {\n  background-position: -112px -16px;\n}\n\n.ui-icon-triangle-1-s {\n  background-position: -65px -16px;\n}\n\n.ui-icon-triangle-1-se {\n  background-position: -48px -16px;\n}\n\n.ui-icon-triangle-1-sw {\n  background-position: -80px -16px;\n}\n\n.ui-icon-triangle-1-w {\n  background-position: -96px -16px;\n}\n\n.ui-icon-triangle-2-e-w {\n  background-position: -144px -16px;\n}\n\n.ui-icon-triangle-2-n-s {\n  background-position: -128px -16px;\n}\n\n.ui-icon-unlocked {\n  background-position: -208px -96px;\n}\n\n.ui-icon-video {\n  background-position: -224px -128px;\n}\n\n.ui-icon-volume-off {\n  background-position: -128px -160px;\n}\n\n.ui-icon-volume-on {\n  background-position: -144px -160px;\n}\n\n.ui-icon-wrench {\n  background-position: -176px -112px;\n}\n\n.ui-icon-zoomin {\n  background-position: -128px -112px;\n}\n\n.ui-icon-zoomout {\n  background-position: -144px -112px;\n}\n\n.ui-menu {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: block;\n  outline: 0;\n}\n\n.ui-menu .ui-icon {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0.2em;\n  margin: auto 0;\n}\n\n.ui-menu .ui-menu {\n  position: absolute;\n}\n\n.ui-menu .ui-menu-divider {\n  margin: 5px 0;\n  height: 0;\n  font-size: 0;\n  line-height: 0;\n  border-width: 1px 0 0 0;\n}\n\n.ui-menu .ui-menu-icon {\n  left: auto;\n  right: 0;\n}\n\n.ui-menu .ui-menu-item {\n  margin: 0;\n  cursor: pointer;\n  list-style-image: url('data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7');\n}\n\n.ui-menu .ui-menu-item-wrapper {\n  position: relative;\n  padding: 3px 1em 3px 0.4em;\n}\n\n.ui-menu .ui-state-focus,\n.ui-menu .ui-state-active {\n  margin: -1px;\n}\n\n.ui-menu-icons {\n  position: relative;\n}\n\n.ui-menu-icons .ui-menu-item-wrapper {\n  padding-left: 2em;\n}\n\n.ui-priority-primary,\n.ui-widget-content .ui-priority-primary,\n.ui-widget-header .ui-priority-primary {\n  font-weight: bold;\n}\n\n.ui-priority-secondary {\n  font-weight: bold !important;\n  opacity: 1 !important;\n}\n\n.ui-priority-secondary,\n.ui-widget-content .ui-priority-secondary,\n.ui-widget-header .ui-priority-secondary {\n  opacity: 0.7;\n  filter: Alpha(Opacity=70);\n  font-weight: normal;\n}\n\n.ui-progressbar {\n  height: 2em;\n  text-align: left;\n  overflow: hidden;\n}\n\n.ui-progressbar .ui-progressbar-overlay {\n  background: url('data:image/gif;base64,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');\n  height: 100%;\n  filter: alpha(opacity=25);\n  opacity: 0.25;\n}\n\n.ui-progressbar .ui-progressbar-value {\n  margin: -1px;\n  height: 100%;\n}\n\n.ui-progressbar-indeterminate .ui-progressbar-value {\n  background-image: none;\n}\n\n.ui-resizable {\n  position: relative;\n}\n\n.ui-resizable-disabled .ui-resizable-handle,\n.ui-resizable-autohide .ui-resizable-handle {\n  display: none;\n}\n\n.ui-resizable-e {\n  cursor: e-resize;\n  width: 7px;\n  right: -5px;\n  top: 0;\n  height: 100%;\n}\n\n.ui-resizable-handle {\n  position: absolute;\n  font-size: 0.1px;\n  display: block;\n  -ms-touch-action: none;\n  touch-action: none;\n}\n\n.ui-resizable-n {\n  cursor: n-resize;\n  height: 7px;\n  width: 100%;\n  top: -5px;\n  left: 0;\n}\n\n.ui-resizable-ne {\n  cursor: ne-resize;\n  width: 9px;\n  height: 9px;\n  right: -5px;\n  top: -5px;\n}\n\n.ui-resizable-nw {\n  cursor: nw-resize;\n  width: 9px;\n  height: 9px;\n  left: -5px;\n  top: -5px;\n}\n\n.ui-resizable-s {\n  cursor: s-resize;\n  height: 7px;\n  width: 100%;\n  bottom: -5px;\n  left: 0;\n}\n\n.ui-resizable-se {\n  cursor: se-resize;\n  width: 12px;\n  height: 12px;\n  right: 1px;\n  bottom: 1px;\n}\n\n.ui-resizable-sw {\n  cursor: sw-resize;\n  width: 9px;\n  height: 9px;\n  left: -5px;\n  bottom: -5px;\n}\n\n.ui-resizable-w {\n  cursor: w-resize;\n  width: 7px;\n  left: -5px;\n  top: 0;\n  height: 100%;\n}\n\n.ui-selectable {\n  -ms-touch-action: none;\n  touch-action: none;\n}\n\n.ui-selectable-helper {\n  position: absolute;\n  z-index: 100;\n  border: 1px dotted black;\n}\n\n.ui-selectmenu-button.ui-button {\n  text-align: left;\n  white-space: nowrap;\n  width: 14em;\n}\n\n.ui-selectmenu-icon.ui-icon {\n  float: right;\n  margin-top: 0;\n}\n\n.ui-selectmenu-menu {\n  padding: 0;\n  margin: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: none;\n}\n\n.ui-selectmenu-menu .ui-menu {\n  overflow: auto;\n  overflow-x: hidden;\n  padding-bottom: 1px;\n}\n\n.ui-selectmenu-menu .ui-menu .ui-selectmenu-optgroup {\n  font-size: 1em;\n  font-weight: bold;\n  line-height: 1.5;\n  padding: 2px 0.4em;\n  margin: 0.5em 0 0 0;\n  height: auto;\n  border: 0;\n}\n\n.ui-selectmenu-open {\n  display: block;\n}\n\n.ui-selectmenu-text {\n  display: block;\n  margin-right: 20px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ui-slider {\n  position: relative;\n  text-align: left;\n  width: 160px;\n  margin-bottom: 10px;\n}\n\n.ui-slider .ui-slider-handle {\n  background-color: var(--color-dark-background);\n  border: 2px solid var(--color-primary);\n  width: 16px;\n\n  height: 16px;\n  border-radius: 50%;\n  position: absolute;\n  top: -5px;\n\n  transform: translateX(-50%);\n\n  cursor: pointer;\n}\n\n.ui-slider .ui-slider-range {\n  background-color: #1a2433;\n\n  border-radius: 10px;\n\n  height: 8px;\n\n  position: absolute;\n  z-index: 1;\n  font-size: 0.7em;\n  display: block;\n  border: 0;\n  background-position: 0 0;\n}\n\n.ui-slider-handle {\n  border-radius: 10px !important;\n  background: var(--color-primary);\n  border: 2px solid white;\n}\n\n.ui-slider-horizontal {\n  height: 0px;\n  border: 2px solid var(--color-primary) !important;\n}\n\n.ui-slider-horizontal .ui-slider-handle {\n  top: -7px;\n}\n\n.ui-slider-horizontal .ui-slider-range {\n  top: 0;\n  height: 100%;\n}\n\n.ui-slider-horizontal .ui-slider-range-max {\n  right: 0;\n}\n\n.ui-slider-horizontal .ui-slider-range-min {\n  left: 0;\n}\n\n.ui-slider-vertical {\n  width: 0.8em;\n  height: 100px;\n}\n\n.ui-slider-vertical .ui-slider-handle {\n  left: -0.3em;\n  margin-left: 0;\n  margin-bottom: -0.6em;\n}\n\n.ui-slider-vertical .ui-slider-range {\n  left: 0;\n  width: 100%;\n}\n\n.ui-slider-vertical .ui-slider-range-max {\n  top: 0;\n}\n\n.ui-slider-vertical .ui-slider-range-min {\n  bottom: 0;\n}\n\n.ui-slider.ui-state-disabled .ui-slider-handle,\n.ui-slider.ui-state-disabled .ui-slider-range {\n  filter: inherit;\n}\n\n.ui-sortable-handle {\n  -ms-touch-action: none;\n  touch-action: none;\n}\n\n.ui-spinner {\n  position: relative;\n  display: inline-block;\n  overflow: hidden;\n  padding: 0;\n  vertical-align: middle;\n}\n\n.ui-spinner a.ui-spinner-button {\n  border-top-style: none;\n  border-bottom-style: none;\n  border-right-style: none;\n}\n\n.ui-spinner-button {\n  width: 1.6em;\n  height: 50%;\n  font-size: 0.5em;\n  padding: 0;\n  margin: 0;\n  text-align: center;\n  position: absolute;\n  cursor: default;\n  display: block;\n  overflow: hidden;\n  right: 0;\n}\n\n.ui-spinner-down {\n  bottom: 0;\n}\n\n.ui-spinner-input {\n  border: none;\n  background: none;\n  color: inherit;\n  padding: 0.222em 0;\n  margin: 0.2em 0;\n  vertical-align: middle;\n  margin-left: 0.4em;\n  margin-right: 2em;\n}\n\n.ui-spinner-up {\n  top: 0;\n}\n\n.ui-state-active {\n  border: 1px solid rgb(77, 172, 255) !important;\n  background: rgba(77, 172, 255, 0.15) !important;\n  color: var(--colorWhite) !important;\n  border-radius: 3px;\n}\n\n.ui-state-active .ui-icon,\n.ui-button:active .ui-icon {\n  background-image: url('images/ui-icons_ffffff_256x240.png');\n}\n\n.ui-state-active a,\n.ui-state-active a:link,\n.ui-state-active a:visited {\n  color: #fff;\n  text-decoration: none;\n}\n\n.ui-state-active,\n.ui-widget-content .ui-state-active,\n.ui-widget-header .ui-state-active,\na.ui-button:active,\n.ui-button:active,\n.ui-button.ui-state-active:hover {\n  border: 1px solid var(--color-dark-text-accent);\n  background: rgba(77, 172, 255, 0.15);\n  border-radius: 3px;\n}\n\n.ui-state-checked {\n  border: 1px solid #dad55e;\n  background: #fffa90;\n}\n\n.ui-state-default {\n  border: 1px solid var(--colorTertiary);\n  background: var(--colorTertiary);\n  color: var(--colorWhite);\n}\n\n.ui-state-default a,\n.ui-state-default a:link,\n.ui-state-default a:visited,\na.ui-button,\na:link.ui-button,\na:visited.ui-button,\n.ui-button {\n  color: #454545;\n  text-decoration: none;\n}\n\n.ui-state-disabled {\n  cursor: default !important;\n  pointer-events: none;\n}\n\n.ui-state-disabled .ui-icon {\n  filter: Alpha(Opacity=35);\n}\n\n.ui-state-disabled,\n.ui-widget-content .ui-state-disabled,\n.ui-widget-header .ui-state-disabled {\n  opacity: 0.35;\n  filter: Alpha(Opacity=35);\n  background-image: none;\n}\n\n.ui-state-error .ui-icon,\n.ui-state-error-text .ui-icon {\n  background-image: url('images/ui-icons_cc0000_256x240.png');\n}\n\n.ui-state-error a,\n.ui-widget-content .ui-state-error a,\n.ui-widget-header .ui-state-error a {\n  color: #5f3f3f;\n}\n\n.ui-state-error,\n.ui-widget-content .ui-state-error,\n.ui-widget-header .ui-state-error {\n  border: 1px solid #f1a899;\n  background: #fddfdf;\n  color: #5f3f3f;\n}\n\n.ui-state-error-text,\n.ui-widget-content .ui-state-error-text,\n.ui-widget-header .ui-state-error-text {\n  color: #5f3f3f;\n}\n\n.ui-state-highlight {\n  border: 1px solid rgb(107, 107, 107) !important;\n  background: rgba(107, 107, 107, 0.15) !important;\n  color: var(--colorWhite) !important;\n  border-radius: 3px;\n}\n\n.ui-state-highlight .ui-icon,\n.ui-button .ui-state-highlight.ui-icon {\n  background-image: url('images/ui-icons_777620_256x240.png');\n}\n\n.ui-state-highlight a,\n.ui-widget-content .ui-state-highlight a,\n.ui-widget-header .ui-state-highlight a {\n  color: #777620;\n}\n\n.ui-state-hover .ui-icon,\n.ui-state-focus .ui-icon,\n.ui-button:hover .ui-icon,\n.ui-button:focus .ui-icon {\n  background-image: url('images/ui-icons_555555_256x240.png');\n}\n\n.ui-state-hover a,\n.ui-state-hover a:hover,\n.ui-state-hover a:link,\n.ui-state-hover a:visited,\n.ui-state-focus a,\n.ui-state-focus a:hover,\n.ui-state-focus a:link,\n.ui-state-focus a:visited,\na.ui-button:hover,\na.ui-button:focus {\n  color: #2b2b2b;\n  text-decoration: none;\n}\n\n.ui-state-hover,\n.ui-widget-content .ui-state-hover,\n.ui-widget-header .ui-state-hover,\n.ui-state-focus,\n.ui-widget-content .ui-state-focus,\n.ui-widget-header .ui-state-focus,\n.ui-button:hover,\n.ui-button:focus {\n  border: 1px solid #ccc;\n  background: rgba(237, 237, 237, 0.6);\n  font-weight: normal;\n  color: #2b2b2b;\n}\n\n.ui-tabs {\n  position: relative;\n  padding: 0.2em;\n}\n\n.ui-tabs .ui-tabs-nav {\n  margin: 0;\n  padding: 0.2em 0.2em 0;\n}\n\n.ui-tabs .ui-tabs-nav .ui-tabs-anchor {\n  float: left;\n  padding: 0.5em 1em;\n  text-decoration: none;\n}\n\n.ui-tabs .ui-tabs-nav li {\n  list-style: none;\n  float: left;\n  position: relative;\n  top: 0;\n  margin: 1px 0.2em 0 0;\n  border-bottom-width: 0;\n  padding: 0;\n  white-space: nowrap;\n}\n\n.ui-tabs .ui-tabs-nav li.ui-tabs-active {\n  margin-bottom: -1px;\n  padding-bottom: 1px;\n}\n\n.ui-tabs .ui-tabs-nav li.ui-tabs-active .ui-tabs-anchor,\n.ui-tabs .ui-tabs-nav li.ui-state-disabled .ui-tabs-anchor,\n.ui-tabs .ui-tabs-nav li.ui-tabs-loading .ui-tabs-anchor {\n  cursor: text;\n}\n\n.ui-tabs .ui-tabs-panel {\n  display: block;\n  border-width: 0;\n  padding: 1em 1.4em;\n  background: none;\n}\n\n.ui-tabs-collapsible .ui-tabs-nav li.ui-tabs-active .ui-tabs-anchor {\n  cursor: pointer;\n}\n\n.ui-timepicker-div .ui-widget-header {\n  margin-bottom: 8px;\n}\n\n.ui-timepicker-div .ui_tpicker_time .ui_tpicker_time_input {\n  background: none;\n  color: inherit;\n  border: none;\n  outline: none;\n  border-bottom: 0px !important;\n  width: 95%;\n  height: 15px;\n  text-align: center;\n}\n\n.ui-timepicker-div .ui_tpicker_time .ui_tpicker_time_input:focus {\n  border-bottom: 1px solid #aaa !important;\n  -webkit-box-shadow: 0 1px 0 0 #aaa !important;\n  box-shadow: 0 1px 0 0 #aaa !important;\n}\n\n.ui-timepicker-div .ui_tpicker_unit_hide {\n  display: none;\n}\n\n.ui-timepicker-div dl {\n  margin-top: 0px;\n  text-align: left;\n}\n\n.ui-timepicker-div dl dd {\n  margin: 0 5px 10px 30%;\n}\n\n.ui-timepicker-div dl dt {\n  float: left;\n  clear: left;\n  padding: 0 0 0 5px;\n}\n\n.ui-timepicker-div td {\n  font-size: 90%;\n}\n\n.ui-timepicker-div.ui-timepicker-oneLine {\n  padding-right: 2px;\n}\n\n.ui-timepicker-div.ui-timepicker-oneLine .ui_tpicker_time,\n.ui-timepicker-div.ui-timepicker-oneLine dt {\n  display: none;\n}\n\n.ui-timepicker-div.ui-timepicker-oneLine .ui_tpicker_time_label {\n  display: block;\n  padding-top: 2px;\n}\n\n.ui-timepicker-div.ui-timepicker-oneLine .ui_tpicker_unit_hide,\n.ui-timepicker-div.ui-timepicker-oneLine .ui_tpicker_unit_hide:before {\n  display: none;\n}\n\n.ui-timepicker-div.ui-timepicker-oneLine dl {\n  text-align: right;\n}\n\n.ui-timepicker-div.ui-timepicker-oneLine dl dd,\n.ui-timepicker-div.ui-timepicker-oneLine dl dd>div {\n  display: inline-block;\n  margin: 0;\n}\n\n.ui-timepicker-div.ui-timepicker-oneLine dl dd.ui_tpicker_millisec:before,\n.ui-timepicker-div.ui-timepicker-oneLine dl dd.ui_tpicker_microsec:before {\n  content: '.';\n  display: inline-block;\n}\n\n.ui-timepicker-div.ui-timepicker-oneLine dl dd.ui_tpicker_minute:before,\n.ui-timepicker-div.ui-timepicker-oneLine dl dd.ui_tpicker_second:before {\n  content: ':';\n  display: inline-block;\n}\n\n.ui-timepicker-rtl {\n  direction: rtl;\n}\n\n.ui-timepicker-rtl dl {\n  text-align: right;\n  padding: 0 5px 0 0;\n}\n\n.ui-timepicker-rtl dl dd {\n  margin: 0 40% 10px 10px;\n}\n\n.ui-timepicker-rtl dl dt {\n  float: right;\n  clear: right;\n}\n\n.ui-tooltip {\n  padding: 8px;\n  position: absolute;\n  z-index: 9999;\n  max-width: 300px;\n}\n\n.ui-tpicker-grid-label {\n  background: none;\n  border: none;\n  margin: 0;\n  padding: 0;\n}\n\n.ui-visual-focus {\n  box-shadow: 0 0 3px 1px rgb(94, 158, 214);\n}\n\n.ui-widget {\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 1em;\n}\n\n.ui-widget .ui-widget {\n  font-size: 1em;\n}\n\n.ui-widget input,\n.ui-widget select,\n.ui-widget textarea,\n.ui-widget button {\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 1em;\n}\n\n.ui-widget-content {\n  background: var(--color-dark-background);\n  border: 1px solid var(--colorTertiary);\n  font-family: 'Open Sans', sans-serif;\n  color: var(--colorWhite);\n  z-index: 25;\n}\n\n.ui-widget-content a {\n  color: #333;\n}\n\n.ui-widget-header {\n  font-family: 'Open Sans', sans-serif;\n  color: var(--colorWhite);\n  font-weight: bold;\n}\n\n.ui-widget-header .ui-icon {\n  background-image: url('images/ui-icons_444444_256x240.png');\n}\n\n.ui-widget-header a {\n  color: #333;\n}\n\n.ui-widget-icon-block {\n  left: 50%;\n  margin-left: -8px;\n  display: block;\n}\n\n.ui-widget-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: #aaa;\n  opacity: 0.003;\n  filter: Alpha(Opacity=.3);\n}\n\n.ui-widget-shadow {\n  -webkit-box-shadow: 0 0 5px #666;\n  box-shadow: 0 0 5px #666;\n}\n\nbody .ui-tooltip {\n  border-width: 2px;\n}\n\ninput.ui-button.ui-button-icon-only {\n  text-indent: 0;\n}\n\ninput.ui-button.ui-icon-notext .ui-icon {\n  width: auto;\n  height: auto;\n  text-indent: 0;\n  white-space: normal;\n  padding: 0.4em 1em;\n}\n\ninput.ui-button::-moz-focus-inner,\nbutton.ui-button::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\n.ui-icon-circle-triangle-e {\n  background-position: -33px -17px;\n  filter: brightness(1.4) sepia(1) hue-rotate(-46deg) saturate(7.5);\n}\n\n.ui-icon-circle-triangle-w {\n  background-position: -97px -17px;\n  filter: brightness(1.4) sepia(1) hue-rotate(-46deg) saturate(7.5);\n}\n\n\n/* ========== Materialize Tabs Dark Theme Override ========== */\n\n.tabs {\n  background-color: var(--color-dark-background);\n}\n\n.tabs .tab a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.tabs .tab a:hover,\n.tabs .tab a.active {\n  color: var(--colorWhite);\n  background-color: transparent;\n}\n\n.tabs .tab a:focus,\n.tabs .tab a:focus.active {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.tabs .indicator {\n  background-color: var(--color-primary);\n}\n\n.tabs .tab.disabled a,\n.tabs .tab.disabled a:hover {\n  color: rgba(255, 255, 255, 0.4);\n}\n\n\n/* ========== Tooltips ========== */\n\n.material-tooltip {\n  display: none !important;\n  background-color: #323232;\n}\n\n[data-tooltip] {\n  position: relative;\n  z-index: 2;\n  cursor: pointer;\n}\n\n[data-tooltip]:before {\n  z-index: 9999;\n  position: absolute;\n  display: block;\n  width: 120px;\n  margin-left: -60px;\n\n  overflow: visible;\n\n  background-color: var(--color-dark-background);\n  text-align: center;\n  padding: 5px;\n  border-width: 5px;\n  border-color: var(--color-dark-border);\n  border-style: solid;\n  color: #ffffff;\n  content: attr(data-tooltip);\n}\n\n[data-tooltip]:before,\n[data-tooltip]:after {\n  visibility: hidden;\n  opacity: 0;\n  pointer-events: none;\n}\n\n[data-tooltip]:hover:before,\n[data-tooltip]:hover:after {\n  visibility: visible;\n  opacity: 1;\n}\n\n[data-tooltip][data-position='bottom']:before {\n  bottom: -100%;\n  left: 50%;\n}\n\n[data-tooltip][data-position='left']:before {\n  right: 100%;\n  left: auto;\n}\n\n[data-tooltip][data-position='right']:before {\n  left: 100%;\n  right: auto;\n}\n\n[data-tooltip][data-position='top']:before {\n  bottom: 125%;\n  top: auto;\n  left: 50%;\n}\n\n\n/* ========== Navigation and Menus ========== */\n\n#constellation-menu ul li {\n  text-align: center;\n  padding: 2px !important;\n}\n\n#country-menu ul li {\n  text-align: center;\n  padding: 2px !important;\n}\n\n#custom-sensor-menu-settings-btn:active {\n  scale: 0.8;\n}\n\n#editor-LS-menu label {\n  top: -25px;\n  font-size: 1em;\n}\n\n#editor-menu {\n  background: var(--color-dark-background);\n  color: white;\n  overflow: auto;\n}\n\n#external-menu ul li {\n  text-align: center;\n  padding: 2px !important;\n}\n\n#info-overlay-menu {\n  position: fixed;\n  top: var(--top-menu-height);\n  left: 3rem;\n  bottom: 0;\n  width: 230px;\n  overflow: hidden;\n  height: auto;\n  border: none;\n  z-index: 2;\n  pointer-events: none;\n  background: rgba(0, 0, 0, 0.9);\n}\n\n#info-overlay-menu.ui-hidden {\n  top: 0;\n  left: 0;\n}\n\n#info-overlay-content {\n  position: absolute;\n  background: transparent;\n  color: white;\n  width: 230px;\n  padding-left: 20px;\n  top: 1rem;\n  height: 100%;\n  overflow: hidden;\n  z-index: 10;\n  pointer-events: auto;\n}\n\n#iss-stream-menu {\n  display: none;\n  position: absolute;\n  width: 270px;\n  height: 620px;\n  z-index: 10;\n  margin-left: -15px;\n}\n\n#iss-stream-menu iframe {\n  width: 285px;\n  margin-bottom: -6px;\n}\n\n#launch-menu {\n  display: none;\n  background: rgba(0, 0, 0, 0.5);\n  position: absolute;\n  width: 1160px;\n  max-height: 100%;\n  border-radius: 5px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  z-index: 10;\n  left: 0;\n  top: 60px;\n  bottom: 60px;\n  overflow: auto;\n  color: white;\n}\n\n#layers-hover-menu {\n  display: none;\n  padding: 10px;\n  color: white;\n  background: var(--color-dark-background);\n  top: var(--top-menu-height);\n  z-index: 100;\n  position: fixed;\n  overflow: auto;\n  width: 100%;\n  border-width: 0px 0px 5px 0px;\n  border-style: solid;\n  border-color: var(--color-dark-border);\n}\n\n#menu-launches,\n#menu-record,\n#menu-color-scheme,\n#social,\n#fastCompSettings {\n  display: none;\n}\n\n#nav-footer-toggle {\n  display: block;\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n  height: 20px;\n  width: 40px;\n  margin: 0px auto;\n  margin-top: -20px;\n  background: var(--color-dark-border);\n  cursor: pointer;\n  text-align: center;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n#nav-top-center {\n  width: 100%;\n  text-align: center;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-content: center;\n  justify-content: center;\n  align-items: center;\n  font-size: 20px;\n  font-family: 'Roboto Mono', monospace;\n  margin-left: 10px;\n  flex-grow: 1;\n}\n\n#nav-top-right {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n}\n\n#nav-top-right li {\n  line-height: normal;\n  height: 100%;\n}\n\n#nav-wrapper {\n  background: var(--color-dark-background);\n  z-index: 3;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  height: var(--nav-bar-height);\n}\n\n#sensor-info-menu a {\n  color: white !important;\n}\n\n#sensor-timeline-menu,\n#satellite-timeline-menu {\n  display: none;\n  position: absolute;\n  width: 800px;\n  left: 0;\n  margin: 0;\n  border-top: 3px solid var(--color-dark-border);\n  border-left: 0;\n  border-right: 0;\n  border-bottom: 0;\n  z-index: 10;\n}\n\n#sensor-timeline-menu-content,\n#satellite-timeline-menu-content {\n  padding: 0px !important;\n}\n\n#time-machine-menu li {\n  display: flex;\n}\n\n.bmenu-filter-item {\n  padding: 2px;\n  text-align: center;\n  cursor: pointer;\n  display: flex;\n  flex-wrap: nowrap;\n  flex-direction: row;\n  align-content: center;\n  justify-content: center;\n  align-items: center;\n}\n\n.bmenu-filter-item .bmenu-filter-item-inner img {\n  width: 25px;\n  height: auto;\n  margin: 0 auto;\n  display: block;\n  padding-bottom: 3px;\n}\n\n.bmenu-filter-title {\n  position: relative;\n  display: block;\n  font-size: 11px;\n  text-align: center;\n  padding-left: 3px;\n}\n\n.bmenu-item .bmenu-item-inner img {\n  width: var(--bottom-icon-img-size);\n  height: auto;\n  margin: 0 auto;\n  display: block;\n}\n\n.bmenu-item .status-icon {\n  width: 15px;\n  height: 15px;\n  top: -20px;\n  background-size: cover;\n  position: relative;\n  z-index: 5;\n  left: 15px;\n  display: block;\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kTtIw1AUhv+mFUUqDmYQcchQnSyILxylikWwUNoKrTqY3PQFTRqSFBdHwbXg4GOx6uDirKuDqyAIPkBcXZwUXaTEc5NCixgvHO7Hf+//c+65gNCoMM0KjQOabpupeEzK5lal7leEIVJNIyQzy0ikFzPwXV/3CPD9Lsqz/O/9ufrUvMWAgEQ8xwzTJt4gntm0Dc77xCIrySrxOfGYSQ0SP3Jd8fiNc9FlgWeKZiY1TywSS8UOVjqYlUyNeIo4omo65QtZj1XOW5y1So21+uQvDOf1lTTXqYYRxxISSEKCghrKqMBGlHadFAspOo/5+Idcf5JcCrnKYORYQBUaZNcP/ge/Z2sVJie8pHAM6HpxnI8RoHsXaNYd5/vYcZonQPAZuNLb/moDmP0kvd7WIkdA/zZwcd3WlD3gcgcYfDJkU3alIJVQKADvZ/RNOWDgFuhd8+bWOsfpA5ChWS3fAAeHwGiRstd93t3TObd/77Tm9wOOiHKymlTPuAAAAAZiS0dEAM4AowCKeTVkwgAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB+cMFAw5A0OJiTcAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAB20lEQVRYw+2WvU4bURCFv7m2NpUlaiSngcLF2hLOG0BHYb9ACoqkg44+ovcjWIKCF7ALOvIGBuKlSBGaIFEjucoK30kRW4p8Z9e7xJKR4ml35tzZM2d+YGP/u0kZ5zjRuqR0BQ5RdlTYBhDlCeFB4UojBvdNeVxpAns3uj31nCl8Kgjarzi+3Lbl6Z8TaN1oRz2XQK0kuxNxfBy3ZZjn5PI+Nkd6rJ7BKx4HqKln0Bzp8asYmP35YCVCc3SzmJCsmr94vmf8+cRBTyoMtyJ+ADyn7OqUjofTrJiqo2FpomolMPWcWUAifPURR99Cld8Bd3Gi5y7lQpX9xXLMMD8vZSBOtC6/+Gk9Pv4gB0Uob4302kgCfcf7xRYNRCgpXYtCH3FUtOYz30kRbGdQcmg49coMl/umPDroFcRe5ImdILDCsLTyrRgDO0hgPl7/trnay5gVY2G7dS+jUANK0KvPKbtlga0YC9sZo+khoG5Kp2wCZoyBHWoAroK2gtM40XqZtT2bikuxwwQic/7XXMpF4br+8a0VwXZWDwv0g2BlvzXS6zwm4kTrWVNQoG/NkrUvo7Wv48w5MG7LEOFkBVfnSd5V9LZPsjkTVUfDEmbeUVp1NJY9/ibO8o1t7Ddz5991OpoAtwAAAABJRU5ErkJggg==');\n}\n\n.bmenu-item-disabled .status-icon {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kTtIw1AUhv+mFUUqDmYQcchQnSyILxylikWwUNoKrTqY3PQFTRqSFBdHwbXg4GOx6uDirKuDqyAIPkBcXZwUXaTEc5NCixgvHO7Hf+//c+65gNCoMM0KjQOabpupeEzK5lal7leEIVJNIyQzy0ikFzPwXV/3CPD9Lsqz/O/9ufrUvMWAgEQ8xwzTJt4gntm0Dc77xCIrySrxOfGYSQ0SP3Jd8fiNc9FlgWeKZiY1TywSS8UOVjqYlUyNeIo4omo65QtZj1XOW5y1So21+uQvDOf1lTTXqYYRxxISSEKCghrKqMBGlHadFAspOo/5+Idcf5JcCrnKYORYQBUaZNcP/ge/Z2sVJie8pHAM6HpxnI8RoHsXaNYd5/vYcZonQPAZuNLb/moDmP0kvd7WIkdA/zZwcd3WlD3gcgcYfDJkU3alIJVQKADvZ/RNOWDgFuhd8+bWOsfpA5ChWS3fAAeHwGiRstd93t3TObd/77Tm9wOOiHKymlTPuAAAAAZiS0dEAM4AowCKeTVkwgAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB+cMFAw4OOuZUVIAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAA5UlEQVRYw+2VLRKDMBCF3zYShcMhepMimKlhisBhcggOwSEwuIoyNcxUlJsg4nAoJJOKUtefTScdKvLpvOzLvp0N4HA4HCtDpoLhknvteCgISDT09n4J9Ro47/2mDOJ6+pmB6njaYdYVgPDFEQVBUmZpZ93AUvzKOiwo4prYcNu+vJzHrKvhknvWDLTjoXjT9meEi8aOAQKSL6Y7sWbgMe0mcDWbtfcAMwLqzSPgaZgR4GweAU/DMrD3mxKAMqivFo0dA0FcTxAk2eUFSe5KZg+hzNIOgqIPnVAmW/AvPiOHw+FYnRsr7lD5IAODJgAAAABJRU5ErkJggg==');\n}\n\n.bmenu-item-disabled img,\n.bmenu-item-disabled img * {\n  filter: grayscale(1) !important;\n}\n\n/* Pro-locked icons - blue tint only while the user is NOT logged in. The tint\n   is driven purely off the body-level .user-logged-in class so freshly-rendered\n   gated items inherit the right look with no per-element JS sync.\n   .login-gate-bypassed is the Konami-code bypass, which clears the tint too\n   (keep in sync with plugin-drawer.css and launchpad.css). */\nbody:not(.user-logged-in):not(.login-gate-bypassed) .bmenu-item-pro img {\n  filter: hue-rotate(227deg) brightness(1.2) !important;\n}\n\nbody:not(.user-logged-in):not(.login-gate-bypassed) .bmenu-item-pro:hover img {\n  filter: hue-rotate(227deg) brightness(1.8) !important;\n}\n\n.bmenu-item-error .status-icon {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kTtIw1AUhv+mFUUqDmYQcchQnSyILxylikWwUNoKrTqY3PQFTRqSFBdHwbXg4GOx6uDirKuDqyAIPkBcXZwUXaTEc5NCixgvHO7Hf+//c+65gNCoMM0KjQOabpupeEzK5lal7leEIVJNIyQzy0ikFzPwXV/3CPD9Lsqz/O/9ufrUvMWAgEQ8xwzTJt4gntm0Dc77xCIrySrxOfGYSQ0SP3Jd8fiNc9FlgWeKZiY1TywSS8UOVjqYlUyNeIo4omo65QtZj1XOW5y1So21+uQvDOf1lTTXqYYRxxISSEKCghrKqMBGlHadFAspOo/5+Idcf5JcCrnKYORYQBUaZNcP/ge/Z2sVJie8pHAM6HpxnI8RoHsXaNYd5/vYcZonQPAZuNLb/moDmP0kvd7WIkdA/zZwcd3WlD3gcgcYfDJkU3alIJVQKADvZ/RNOWDgFuhd8+bWOsfpA5ChWS3fAAeHwGiRstd93t3TObd/77Tm9wOOiHKymlTPuAAAAAZiS0dEAM4AowCKeTVkwgAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB+cMFAw5JOaDPFwAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAA0UlEQVRYw+3WSw7DIAwEUKbppVi1R+vR0lWORbdVgj9jsKpKeImwo3kiJKWsWvXjwnmh1bqX1h45T8Mbx/H8XrpdNm3bKy1uZzZ6+1IUOun7AlkKwkxI+6cqCOllgdkKyixofVMUlPS6wCwFYwas/iEFI70tMKrg6IVnTkjBkd4nEFVw9sA7j1JwpvcLsArEXjCqLgUiPSfgTUaeF7BnS1Ug0/MCVsLA24LI/dJVCKSPCUhJgzdmSOCiEEwfFzgnzvyPtBRarfvIjHvmt37VX9QHmaFdkiJXncIAAAAASUVORK5CYII=');\n}\n\n.bmenu-item-error img {\n  filter: invert(52%) sepia(130%) saturate(7323%) hue-rotate(353deg) brightness(100%) contrast(86%);\n}\n\n.bmenu-item-help .status-icon {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kTtIw1AUhv+mFUUqDmYQcchQnSyILxylikWwUNoKrTqY3PQFTRqSFBdHwbXg4GOx6uDirKuDqyAIPkBcXZwUXaTEc5NCixgvHO7Hf+//c+65gNCoMM0KjQOabpupeEzK5lal7leEIVJNIyQzy0ikFzPwXV/3CPD9Lsqz/O/9ufrUvMWAgEQ8xwzTJt4gntm0Dc77xCIrySrxOfGYSQ0SP3Jd8fiNc9FlgWeKZiY1TywSS8UOVjqYlUyNeIo4omo65QtZj1XOW5y1So21+uQvDOf1lTTXqYYRxxISSEKCghrKqMBGlHadFAspOo/5+Idcf5JcCrnKYORYQBUaZNcP/ge/Z2sVJie8pHAM6HpxnI8RoHsXaNYd5/vYcZonQPAZuNLb/moDmP0kvd7WIkdA/zZwcd3WlD3gcgcYfDJkU3alIJVQKADvZ/RNOWDgFuhd8+bWOsfpA5ChWS3fAAeHwGiRstd93t3TObd/77Tm9wOOiHKymlTPuAAAAAZiS0dEAM4AowCKeTVkwgAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB+cMFAw5HM6BhMIAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAPklEQVRYw2NgGAUjHTCiC/x5YfWflhaySBxDsZNpoENg1AGjDhh1wKgDRh0w6oBRB4w6YNQBow4YdcAoGAUAZVMEMGAOxt0AAAAASUVORK5CYII=');\n}\n\n.bmenu-item-help img {\n  filter: hue-rotate(227deg) brightness(1.2);\n}\n\n.bmenu-item-help:hover .status-icon {\n  filter: brightness(1.8);\n}\n\n.bmenu-item-help:hover img {\n  filter: hue-rotate(227deg) brightness(1.8);\n}\n\n.bmenu-item-inner {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 5px;\n}\n\n.bmenu-item-selected .status-icon {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kTtIw1AUhv+mFUUqDmYQcchQnSyILxylikWwUNoKrTqY3PQFTRqSFBdHwbXg4GOx6uDirKuDqyAIPkBcXZwUXaTEc5NCixgvHO7Hf+//c+65gNCoMM0KjQOabpupeEzK5lal7leEIVJNIyQzy0ikFzPwXV/3CPD9Lsqz/O/9ufrUvMWAgEQ8xwzTJt4gntm0Dc77xCIrySrxOfGYSQ0SP3Jd8fiNc9FlgWeKZiY1TywSS8UOVjqYlUyNeIo4omo65QtZj1XOW5y1So21+uQvDOf1lTTXqYYRxxISSEKCghrKqMBGlHadFAspOo/5+Idcf5JcCrnKYORYQBUaZNcP/ge/Z2sVJie8pHAM6HpxnI8RoHsXaNYd5/vYcZonQPAZuNLb/moDmP0kvd7WIkdA/zZwcd3WlD3gcgcYfDJkU3alIJVQKADvZ/RNOWDgFuhd8+bWOsfpA5ChWS3fAAeHwGiRstd93t3TObd/77Tm9wOOiHKymlTPuAAAAAZiS0dEAM4AowCKeTVkwgAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB+cMFAw5C01SAQUAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAABd0lEQVRYw+2WsWoCQRCGv1m5K0R8gAhpbHyXgJhCOLDLAwi+wT2I2AUEC0W4d0ljEzC9IhYe7qS5NHHPPfWOCHHqZf5/vllmBh7x30Muedzf06ql9BRegLYqTwAifAErgeQYsJjVWZdqoL+nZQ7EKryhGE9GK8rEhsRFjHgNRFu61vIONC6kuzOGwbTJ8tyjs9VEG4ZWmV8hDtCwyjzaMLyKQLSla5W5F7mfsTXCax4Jyeu5HPi4snJnOzSk4/oTzurMgbhEcYBGltNPoL+nJSmfN6N3tEIDnn9TOBGppfRKFwdQTC2l521BNmQqCVduV6XtCidv208gG6+VEHDkNvxxnBjIFks1m8+R20VgVWHBKz8BSCrc/YnXwDFggWArULfHgIXXwKzOWpRJ6frKpPAusCExsCtRf5flLHYPzOqsjWFQSisEawyDvOsodw5MmywNjG4yIVgDo3NX0X2fZD8kNKQjMC5EQ7ACYw3p+MTv4ix/xCO+AfaWiX0YOWcHAAAAAElFTkSuQmCC');\n}\n\n.bmenu-item-selected img {\n  transition: filter var(--kt-duration-normal, 200ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n  filter: hue-rotate(275deg) brightness(1.2);\n}\n\n.bmenu-item-selected:hover .status-icon {\n  transition: filter var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n  filter: brightness(1.8);\n}\n\n.bmenu-item-selected:hover img {\n  transition: filter var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n  filter: hue-rotate(275deg) brightness(1.8);\n}\n\n.bmenu-item:hover,\n.bmenu-filter-item:hover {\n  background: rgba(255, 255, 255, 0.15);\n  border-radius: var(--kt-radius-sm, 4px);\n}\n\n.bmenu-title {\n  position: relative;\n  display: block;\n  font-size: 11px;\n  text-align: center;\n  text-overflow: ellipsis;\n  overflow-x: hidden;\n  word-wrap: break-word;\n}\n\n.menu-item {\n  cursor: pointer;\n  z-index: 11;\n}\n\n.menu-item:first-child {\n  margin-left: 2px;\n}\n\n.menu-item:hover .menu-title {\n  color: var(--color-dark-background);\n}\n\n.menu-radar {\n  right: 50px;\n}\n\n.menu-selectable:hover {\n  background: var(--kt-bg-hover, rgba(255, 255, 255, 0.08));\n  cursor: pointer;\n}\n\n.side-menu>ul>li {\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n  text-align: center;\n}\n\n.side-menu>ul>li:first-child {\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.menu-title {\n  height: 30px;\n}\n\n.plot-analysis-menu-maximized {\n  width: 100% !important;\n  height: 100% !important;\n}\n\n.plot-analysis-menu-normal {\n  width: 650px;\n  z-index: 2;\n}\n\n#right-btn-menu {\n  z-index: 11;\n}\n\n.right-btn-menu {\n  display: none;\n  background: var(--kt-bg-elevated, #2a2a2e);\n  color: white;\n  position: absolute;\n  min-width: 165px;\n  width: auto;\n  border-radius: var(--kt-radius-md, 6px);\n  border: 1px solid var(--kt-border-default, rgba(255, 255, 255, 0.12));\n  box-shadow: var(--kt-shadow-lg, 0 4px 12px rgba(0, 0, 0, 0.4));\n  z-index: 12;\n  padding: 4px 0;\n  overflow: hidden;\n}\n\n.right-btn-menu ul {\n  width: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n.right-btn-menu ul li {\n  padding: 6px 12px;\n  min-height: 28px;\n  cursor: pointer;\n  align-items: center;\n  margin: 0 4px;\n  border-radius: var(--kt-radius-sm, 4px);\n  transition: background-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n  text-align: left;\n}\n\n/*\n * The input manager shows/hides individual menu items by toggling the inline\n * `display` (block to show, none to hide). Apply the flex layout only to items\n * that are NOT inline-hidden, so a `display: flex` here can never override an\n * inline `display: none` and leave a hidden item visible.\n */\n.right-btn-menu ul li:not([style*=\"display: none\"]) {\n  display: flex !important;\n}\n\n.right-btn-menu ul li:hover {\n  background-color: var(--kt-bg-hover, rgba(255, 255, 255, 0.08));\n}\n\n.right-btn-menu ul li:active {\n  background-color: var(--kt-bg-active, rgba(255, 255, 255, 0.12));\n}\n\n.right-btn-menu ul li:hover a {\n  color: var(--colorWhite) !important;\n  background-color: transparent;\n}\n\n.rmb-menu-item a {\n  color: white !important;\n  text-decoration: none;\n  width: 100%;\n}\n\n.rmb-menu-item:hover {\n  background-color: var(--kt-bg-hover, rgba(255, 255, 255, 0.08)) !important;\n}\n\n.side-menu {\n  position: absolute;\n  inset: 0;\n  overflow: auto;\n  z-index: 10;\n  padding: 0rem 1rem;\n  padding-bottom: 0.25rem;\n}\n\n.side-menu .input-field {\n  margin-top: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.side-menu-parent {\n  display: none;\n  position: absolute;\n  width: 100%;\n  top: var(--top-menu-height);\n  bottom: 0px;\n  left: 0px;\n  overflow: hidden;\n  transition: transform var(--kt-duration-slow, 300ms) var(--kt-easing-enter, cubic-bezier(0, 0, 0.2, 1));\n  transform: translateX(-120%);\n  background: var(--color-dark-background);\n  z-index: 5;\n  border-right: 1px solid var(--kt-border-default, rgba(255, 255, 255, 0.12));\n  box-shadow: var(--kt-shadow-lg, 0 4px 12px rgba(0, 0, 0, 0.4));\n  color: white;\n  padding: 0px;\n}\n\n/* Side menu title bar layout */\n.side-menu-title-bar {\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  padding: 0.5rem 0rem;\n  border-bottom: 1px solid var(--kt-border-default, rgba(255, 255, 255, 0.12));\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);\n  position: sticky;\n  top: 0;\n  z-index: 5;\n  background: var(--color-dark-background);\n  margin-bottom: 1rem;\n  margin-left: -1rem;\n  margin-right: -1rem;\n}\n\n.side-menu-title-left,\n.side-menu-title-right {\n  flex: 1;\n  display: flex;\n  align-items: center;\n}\n\n.side-menu-title-right {\n  justify-content: flex-end;\n  gap: 0.5rem;\n  margin-right: 1rem;\n}\n\n.side-menu-title-text {\n  flex: 0 0 auto;\n  margin-left: 1rem;\n  text-align: center;\n  width: 300px;\n}\n\n\n\n.icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 6px;\n  cursor: pointer;\n  border-radius: var(--kt-radius-sm, 4px);\n  transition: background-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n}\n\n.icon-btn:hover {\n  background-color: var(--kt-bg-hover, rgba(255, 255, 255, 0.08));\n}\n\n.icon-btn:active {\n  background-color: var(--kt-bg-active, rgba(255, 255, 255, 0.12));\n  transform: scale(0.95);\n}\n\n.icon-btn[disabled] {\n  opacity: 0.3;\n  cursor: default;\n  pointer-events: none;\n}\n\n.icon-btn-img {\n  width: 20px;\n  height: 20px;\n  vertical-align: middle;\n  filter: brightness(0) invert(1);\n}\n\n.side-menu-row-header {\n  background: var(--color-dark-border);\n  margin: 0px -1px;\n  padding: 5px;\n}\n\n/* Universal data table row hover in side menus */\n.side-menu table tbody tr {\n  transition: background-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n}\n\n.side-menu table tbody tr:hover {\n  background-color: var(--kt-bg-hover, rgba(255, 255, 255, 0.08));\n}\n\n/* Secondary menu panels sit behind their primary side menu (z-index < 5).\n   min-width: auto allows secondary panels to respect their inline width instead of\n   being forced to the responsive .side-menu-parent min-width (400px).\n   left: 0px (without !important) is the default; inline styles from openSecondaryMenu()\n   override this to position the panel adjacent to the primary menu. */\n[id$=\"-secondary\"].side-menu-parent {\n  z-index: 4 !important;\n  left: 0px;\n  min-width: auto;\n  box-shadow: var(--kt-shadow-md, 0 2px 8px rgba(0, 0, 0, 0.3));\n}\n\n.side-menu-settings {\n  position: relative;\n  height: 100%;\n  border-right: 1px solid var(--kt-border-default, rgba(255, 255, 255, 0.12));\n  box-shadow: var(--kt-shadow-md, 0 2px 8px rgba(0, 0, 0, 0.3));\n  background: var(--color-dark-background);\n  color: white;\n  width: 100%;\n  top: 0px;\n  bottom: 0px;\n  overflow: auto;\n  z-index: 3;\n  padding: 0px 10px;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  gap: 10px;\n}\n\n/* Override Materialize teal with the app's theme color for all checkboxes and radios */\n[type=\"checkbox\"]:checked+span:not(.lever)::before {\n  border-right-color: var(--color-primary) !important;\n  border-bottom-color: var(--color-primary) !important;\n}\n\n[type=\"checkbox\"].filled-in:checked+span:not(.lever)::after {\n  border-color: var(--color-primary) !important;\n  background-color: var(--color-primary) !important;\n}\n\n[type=\"radio\"]:checked+span::after,\n[type=\"radio\"].with-gap:checked+span::after {\n  background-color: var(--color-primary) !important;\n  border-color: var(--color-primary) !important;\n}\n\n[type=\"radio\"].with-gap:checked+span::before {\n  border-color: var(--color-primary) !important;\n}\n\n.secondary-title-bar {\n  padding: 0.5rem 0;\n  margin-bottom: 0;\n}\n\n.submenu {\n  display: none;\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 5px;\n  margin: 0;\n  overflow: hidden;\n  position: absolute;\n}\n\n.top-menu-icons img {\n  width: 30px;\n  height: 30px;\n  margin: 3px;\n}\n\n.top-menu-icons-search-on {\n  transition: 300ms var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n}\n\nnav {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  color: #fff;\n  background-color: var(--color-dark-background);\n  height: 50px;\n  line-height: 50px;\n}\n\nnav,\nnav .nav-wrapper i,\nnav a.sidenav-trigger,\nnav a.sidenav-trigger i {\n  height: var(--nav-bar-height);\n  line-height: var(--nav-bar-height);\n  box-shadow: none;\n  -webkit-box-shadow: none;\n}\n\n#layers-hover-menu li,\n#layers-hover-menu-popup li {\n  display: flex;\n  align-items: center;\n}\n\n#layers-hover-menu-popup {\n  display: none;\n  color: white;\n  background: var(--color-dark-background);\n  z-index: 100;\n  overflow: auto;\n  width: 100%;\n  padding: 1em;\n}\n\n#map-menu {\n  display: none;\n  position: absolute;\n  width: 800px;\n  left: 0;\n  margin: 0;\n  border-top: 3px solid var(--color-primary);\n  border-left: 0;\n  border-right: 0;\n  border-bottom: 0;\n\n  background: rgba(255, 255, 255, 0.85);\n  color: white;\n\n  z-index: 99999999;\n  padding: 0;\n}\n\n.bmenu-item {\n  padding: 5px;\n  text-align: center;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  height: 100%;\n  max-width: var(--bottom-icon-width);\n  transition: background-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n}\n\n.bmenu-item .bmenu-item-inner:active *,\n.bmenu-filter-item .bmenu-filter-item-inner:active * {\n  scale: 0.9;\n}\n\n.top-menu-icons {\n  padding: 0px;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  transition: 300ms var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n}\n\n\n/* ========== Controls and Buttons ========== */\n\n#colorbox-header button {\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n  border: 0px;\n  background: none;\n  color: white;\n}\n\n.colorPickButton {\n  border-radius: 5px;\n  width: 20px;\n  height: 20px;\n  margin: 0px 3px;\n  cursor: pointer;\n  display: inline-block;\n  border: thin solid #eee;\n}\n\n.colorPickButton:hover {\n  transform: scale(1.1);\n}\n\n.ghost-button {\n  display: block;\n  border: 2px white;\n  background: var(--colorWhite);\n  padding: 10px;\n  width: 100%;\n  margin: 20px auto;\n  -webkit-transition: all 0.1s ease-in-out;\n  -moz-transition: all 0.1s ease-in-out;\n  -ms-transition: all 0.1s ease-in-out;\n  -o-transition: all 0.1s ease-in-out;\n  transition: all 0.1s ease-in-out;\n}\n\n.ghost-button:hover {\n  background: #c33;\n  color: var(--colorWhite);\n}\n\n\n/* ========== Search Components ========== */\n\n#search {\n  height: 25px;\n  margin: 3px;\n  display: block;\n  border-radius: 0;\n  background: var(--color-dark-background);\n  font-size: 16px;\n  color: #f5f5f5;\n  outline: none;\n  box-shadow: none;\n  -webkit-box-shadow: none;\n  border-bottom: none !important;\n}\n\n#search-holder {\n  display: flex;\n  height: 100%;\n  transition: 300ms var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n  align-items: center;\n  margin-left: 20px;\n}\n\n#search-holder input:-webkit-autofill {\n  box-shadow: 0 0 0px 1000px var(--color-dark-border) inset;\n  background-color: var(--color-dark-background) !important;\n  -webkit-text-fill-color: white !important;\n  color: white !important;\n}\n\n.search-hilight {\n  font-weight: bold;\n  color: var(--color-dark-text-accent);\n}\n\n.search-result {\n  padding: 6px 10px;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n  transition: background-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n}\n\n.search-result:hover {\n  background: var(--kt-bg-hover, rgba(255, 255, 255, 0.08));\n  cursor: pointer;\n}\n\n.search-result-limit {\n  padding: 4px 10px;\n  font-size: 0.8em;\n  color: var(--color-dark-text-accent);\n  text-align: center;\n  border-bottom: 1px solid var(--color-dark-border);\n}\n\n.search-result-decayed {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.search-result-decayed:hover {\n  background: none;\n  cursor: default;\n}\n\n.search-result-decayed-badge {\n  font-size: 0.75em;\n  color: #ff6b6b;\n  margin-left: 8px;\n  white-space: nowrap;\n}\n\n.search-slide-down {\n  width: 160px;\n  transition: width var(--kt-duration-normal, 200ms) var(--kt-easing-enter, cubic-bezier(0, 0, 0.2, 1));\n}\n\n.search-slide-down input[type='search'] {\n  width: 100%;\n  padding-left: 10px;\n  padding-right: 10px;\n  text-decoration: none;\n}\n\n.search-slide-up {\n  transition: width var(--kt-duration-normal, 200ms) var(--kt-easing-exit, cubic-bezier(0.4, 0, 1, 1));\n  width: 0px;\n}\n\n.search-slide-up input[type='search'] {\n  transition: width var(--kt-duration-normal, 200ms) var(--kt-easing-exit, cubic-bezier(0.4, 0, 1, 1));\n  width: 0px;\n  padding-left: 0px;\n}\n\n.truncate-search {\n  width: 280px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  /*\n   * Pin the name column immediately after the badge. The row uses\n   * justify-content: space-between, which would otherwise center this middle\n   * column in the leftover space and shift its left edge per row depending on\n   * the right column's width. The auto margin absorbs the slack instead, so the\n   * name always starts at the same x and the right column stays right-aligned.\n   */\n  margin-right: auto;\n}\n\n#search-results {\n  transform: translateY(-100%);\n  display: none;\n  overflow-x: hidden;\n  overflow-y: auto;\n  position: absolute;\n  width: 100%;\n  height: fit-content;\n  background: var(--color-dark-background) !important;\n  z-index: 1;\n  top: var(--top-menu-height);\n  bottom: 250px;\n  max-height: 20%;\n  border-width: 0px 0px 5px 0px;\n  padding-top: 10px;\n  border-style: solid;\n  border-color: var(--color-dark-border);\n}\n\n\n/* ========== Modals and Dialogs ========== */\n\n#colorbox {\n  border: 10px solid var(--color-dark-background);\n  z-index: 10;\n  box-sizing: content-box;\n}\n\n#colorbox-div {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 99;\n  padding: 5%;\n}\n\n#colorbox-header {\n  background: var(--color-dark-border);\n  width: 100%;\n  height: 34px;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  padding-right: 15px;\n  padding-bottom: 10px;\n}\n\n#colorbox-iframe,\n#colorbox-img {\n  width: 100%;\n  height: calc(100% - 34px);\n  border: none;\n}\n\n#colorbox-container {\n  background-color: 'white';\n  transform: translateX(-200%);\n  transition: transform 300ms var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n  display: block;\n  z-index: 100;\n  width: 95%;\n  height: 95%;\n  margin: auto;\n  border-color: var(--color-dark-border);\n  border-width: 10px;\n  border-style: solid;\n  border-radius: 5px;\n}\n\n#colorbox-title {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: x-large;\n}\n\n\n/* ========== Utility Classes ========== */\n\n.Square-Box {\n  cursor: pointer;\n  width: 30px;\n  height: 30px;\n  border-width: 2px;\n  border-style: solid;\n  border-radius: 15px;\n  box-shadow:\n    0 0px 6px 0 rgba(0, 0, 0, 0.2),\n    0 0px 8px 0 rgba(0, 0, 0, 0.19);\n  margin-right: 20px;\n}\n\n.add-icon img {\n  padding-top: 35px;\n  width: 25px;\n  filter: hue-rotate(275deg) brightness(1.2);\n}\n\n.box-header {\n  font-size: 20px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n\n.btn-green {\n  background-color: rgb(86, 240, 0) !important;\n}\n\n.btn-red {\n  background-color: rgb(255, 56, 56) !important;\n}\n\n.btn-red:active {\n  background-color: rgb(255, 0, 0) !important;\n}\n\n.btn-red:hover {\n  background-color: rgb(255, 0, 0) !important;\n}\n\n.cboxIframe {\n  width: 100%;\n  height: 100%;\n}\n\n.center-text {\n  text-align: center;\n}\n\n.colorPickDummy {\n  background: #fff;\n  border: 1px dashed #bbb;\n}\n\n.customColorHash {\n  border-radius: 5px;\n  height: 23px;\n  width: 122px;\n  margin: 1px 4px;\n  padding: 0 4px;\n  border: 1px solid #babbba;\n  outline: none;\n}\n\n.customColorHash.error {\n  border-color: #ff424c;\n  color: #ff424c;\n}\n\n.dark-blue-badge {\n  color: var(--color-dark-text-accent) !important;\n  font-weight: bold;\n}\n\n.dark-gray-badge {\n  color: var(--statusLightOff) !important;\n  font-weight: bold;\n}\n\n.divider {\n  padding: 2px !important;\n  background-color: var(--color-dark-background);\n}\n\n.eruda-entry-btn {\n  display: none !important;\n}\n\n.eruda-icon-tool {\n  display: none !important;\n}\n\n.flow5out {\n  margin: 0px -5px;\n}\n\n.footer-slide-down {\n  bottom: -145px !important;\n  height: 150px !important;\n  top: auto !important;\n}\n\n.footer-slide-trans {\n  transition: transform var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n}\n\n.footer-slide-up {\n  bottom: 0px !important;\n  top: auto !important;\n}\n\n.ghost-input {\n  text-align: right;\n  font-weight: 300;\n  width: 120px;\n  position: absolute;\n  left: 140px;\n  padding: 10px;\n  border: 0px;\n  outline: none;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  color: var(--colorWhite);\n  background: rgba(0, 0, 0, 0);\n  font-family:\n    Open Sans,\n    Verdana,\n    sans-serif;\n  -webkit-transition: all 0.1s ease-in-out;\n  -moz-transition: all 0.1s ease-in-out;\n  -ms-transition: all 0.1s ease-in-out;\n  -o-transition: all 0.1s ease-in-out;\n  transition: all 0.1s ease-in-out;\n}\n\n.ghost-input:focus {\n  border-bottom: 1px solid #ddd;\n}\n\n.ghost-input:hover {\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 5px;\n}\n\n.help-header-sel:hover {\n  cursor: pointer;\n  color: var(--color-dark-text-accent);\n}\n\n.huerotate {\n  -webkit-filter: hue-rotate(180deg);\n  filter: hue-rotate(180deg);\n}\n\n.layers-ageLost-box {\n  background: rgb(200, 200, 200);\n}\n\n.layers-ageMed-box {\n  background: rgb(150, 150, 150);\n}\n\n.layers-ageNew-box {\n  background: rgb(100, 100, 100);\n}\n\n.layers-ageOld-box {\n  background: rgb(200, 200, 200);\n}\n\n.layers-debris-box {\n  background: rgb(157, 157, 157);\n}\n\n.layers-facility-box {\n  background: rgb(108, 30, 103);\n}\n\n.layers-inFOV-box {\n  background: rgb(255, 200, 0);\n}\n\n.layers-inviewAlt-box {\n  background: rgb(255, 200, 0);\n}\n\n.layers-missile-box {\n  background: rgb(200, 198, 9);\n}\n\n.layers-missileInview-box {\n  background: rgb(255, 0, 0);\n}\n\n.layers-payload-box {\n  background: rgb(68, 193, 47);\n}\n\n.layers-pink-box {\n  background: rgb(108, 0, 50);\n  display: hidden;\n}\n\n.layers-rcsLarge-box {\n  background: rgb(200, 200, 200);\n}\n\n.layers-rcsMed-box {\n  background: rgb(150, 150, 150);\n}\n\n.layers-rcsSmall-box {\n  background: rgb(100, 100, 100);\n}\n\n.layers-rcsUnkown-box {\n  background: rgb(200, 200, 200);\n}\n\n.layers-rocketBody-box {\n  background: rgb(0, 48, 255);\n}\n\n.layers-satGEO-box {\n  background: rgb(200, 200, 200);\n}\n\n.layers-satHi-box {\n  background: rgb(200, 200, 200);\n}\n\n.layers-satLEO-box {\n  background: rgb(200, 200, 200);\n}\n\n.layers-satLow-box {\n  background: rgb(100, 100, 100);\n}\n\n.layers-satMed-box {\n  background: rgb(150, 150, 150);\n}\n\n.layers-sensor-box {\n  background: rgb(166, 5, 5);\n}\n\n.layers-sensorCanObserve-box {\n  background: rgb(255, 30, 0);\n}\n\n.layers-sourceAldoria-box {\n  background: rgb(15, 150, 71);\n}\n\n.layers-sourceCelestrak-box {\n  background: rgb(206, 219, 14);\n}\n\n.layers-sourcePrismnet-box {\n  background: rgba(168, 47, 199, 0.705);\n}\n\n.layers-sourceUssf-box {\n  background: rgb(11, 39, 131);\n}\n\n.layers-sourceVimpel-box {\n  background: rgb(204, 14, 14);\n}\n\n.layers-starHi-box {\n  background: rgb(200, 200, 200);\n}\n\n.layers-starLow-box {\n  background: rgb(100, 100, 100);\n}\n\n.layers-starMed-box {\n  background: rgb(150, 150, 150);\n}\n\n.layers-velocityFast-box {\n  background: rgb(200, 200, 200);\n}\n\n.layers-velocityMed-box {\n  background: rgb(150, 150, 150);\n}\n\n.layers-velocitySlow-box {\n  background: rgb(100, 100, 100);\n}\n\n.link:hover {\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.map-item {\n  position: absolute;\n  z-index: 11;\n}\n\n.map-look {\n  width: 12px;\n  height: 12px;\n  border-radius: 20%;\n  cursor: pointer;\n}\n\n.no-text-select {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.plot-analysis-chart {\n  width: 100%;\n  height: 90%;\n  padding-bottom: 80px;\n  padding-top: 10px;\n  margin: 0;\n}\n\n.pointable {\n  cursor: pointer;\n}\n\n.remove-icon img {\n  width: 25px;\n  filter: invert(52%) sepia(130%) saturate(7323%) hue-rotate(353deg) brightness(100%) contrast(86%);\n}\n\n.sensor-info-key {\n  font-size: 12px;\n  float: left;\n}\n\n.sensor-info-key,\n.sensor-info-value {\n  display: inline-block;\n  height: 18px;\n}\n\n.sensor-info-row {\n  text-align: center;\n  margin: 10px;\n  height: 18px;\n}\n\n.sensor-info-value {\n  float: right;\n  font-size: 12px;\n}\n\n.shake {\n  animation: shake 1s;\n  animation-iteration-count: infinite;\n}\n\n.start-hidden {\n  display: none;\n}\n\n.status-box {\n  background: rgba(0, 0, 0, 0);\n  color: white;\n  font-family: 'Open Sans', Times, serif;\n  font-size: 28px;\n  position: absolute;\n  height: 100px !important;\n  bottom: 50px;\n  z-index: 10002;\n  width: 100%;\n  text-align: center;\n}\n\n.text-select {\n  -webkit-touch-callout: text;\n  -webkit-user-select: text;\n  -khtml-user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  user-select: text;\n}\n\n.timeline-Header {\n  display: none;\n}\n\n.title-text {\n  text-align: center;\n  margin-bottom: 5px;\n  font-size: 18px;\n  vertical-align: middle;\n}\n\n.ui_tpicker_hour,\n.ui_tpicker_minute,\n.ui_tpicker_second,\n.ui_tpicker_proprate {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  flex-direction: row;\n  flex-wrap: nowrap;\n}\n\n.ui_tpicker_time {\n  height: 31px;\n  display: flex;\n  justify-content: space-around;\n}\n\n.ui_tpicker_time_input {\n  font-family: 'Roboto Mono', monospace !important;\n  height: 15px !important;\n  border-bottom: 0px !important;\n  text-align: center !important;\n  font-size: 20px !important;\n  width: 150px !important;\n}\n\n.vcr-btn {\n  cursor: pointer;\n}\n\n.vcr-container {\n  display: flex;\n}\n\n.vertcenter {\n  line-height: 36px;\n}\n\n.dropdown-content {\n  max-height: 40vh !important;\n}\n\n.dropdown-content::-webkit-scrollbar-thumb {\n  background-color: var(--color-dark-text-accent) !important;\n}\n\n.dropdown-content::-webkit-scrollbar-track {\n  background-color: transparent !important;\n}\n\n\n/* ========== Other Styles ========== */\n\n#about-box {\n  background: var(--colorBlack);\n  right: 10px;\n  width: 500px;\n  height: 470px;\n}\n\n#about-content {\n  font-size: 12px;\n}\n\n#bottom-icons {\n  width: 100%;\n  float: right;\n  display: grid;\n  grid-template-columns: minmax(var(--bottom-icon-width), max-content) repeat(auto-fill, var(--bottom-icon-width));\n  /* fill parent so scrollbar spans full height */\n  height: 100%;\n  min-height: calc(1.5 * var(--bottom-icon-width));\n  /* pack items at top - prevents stretching */\n  align-content: start;\n  justify-content: center;\n  row-gap: 5px;\n  background: var(--color-dark-background);\n  padding-top: 10px;\n  padding-bottom: 10px;\n  z-index: 11;\n  overflow-y: scroll;\n  max-height: var(--bottom-menu-height);\n}\n\n#bottom-icons-container {\n  display: flex;\n  flex-direction: row;\n\n  width: 100% !important;\n  height: var(--bottom-menu-height);\n  overflow: hidden;\n  text-align: left;\n}\n\n/* Hide entire bottom menu when drawer mode is active (desktop) */\nbody.drawer-mode:not(.is-mobile-mode) footer#nav-footer {\n  display: none !important;\n}\n\n#bottom-icons-filter {\n  width: var(--bottom-filter-width);\n  height: var(--bottom-menu-height);\n  float: left;\n  display: flex;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  padding-left: 10px;\n  background: var(--color-dark-background);\n  z-index: 11;\n  position: absolute;\n  flex-direction: column;\n  align-content: center;\n  align-items: flex-start;\n  justify-content: flex-start;\n  overflow-y: scroll;\n}\n\n#bottom-icons-utility {\n  width: var(--bottom-utility-width);\n  height: var(--bottom-menu-height);\n  position: absolute;\n  right: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 10px;\n  background: var(--color-dark-background);\n  z-index: 11;\n  overflow-y: auto;\n}\n\n.utility-section-header {\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: rgba(255, 255, 255, 0.5);\n  padding: 4px 0 2px;\n  width: 100%;\n  flex-shrink: 0;\n}\n\n.utility-section-icons {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, 25px);\n  grid-template-rows: repeat(auto-fill, 25px);\n  gap: 5px;\n  width: 100%;\n}\n\n.utility-section-divider {\n  border: none;\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n  margin: 6px 0;\n  width: 100%;\n  flex-shrink: 0;\n}\n\n.utility-icon {\n  width: 25px;\n  height: 25px;\n  cursor: pointer;\n  opacity: 0.6;\n  transition: opacity 0.2s;\n}\n\n.utility-icon:hover {\n  opacity: 1;\n}\n\n.utility-icon.bmenu-item-selected {\n  opacity: 1;\n}\n\n.utility-icon.bmenu-item-disabled {\n  opacity: 0.2;\n  cursor: default;\n}\n\n#calendar-time-prop-rate {\n  width: 4em;\n  margin-left: 1em;\n}\n\n#camera-status-box {\n  z-index: 10003;\n  bottom: 100px;\n}\n\n#canvas-holder {\n  z-index: -2;\n  padding: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: hidden;\n}\n\n#cboxLoadedContent {\n  overflow: hidden !important;\n  background: var(--colorWhite);\n}\n\n#classification-container {\n  text-align: center;\n  background: var(--classificationColor);\n}\n\n#colorPick {\n  -webkit-backdrop-filter: blur(15px);\n  backdrop-filter: blur(15px);\n  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.5);\n  padding: 15px;\n  font-family: 'Open Sans', sans-serif;\n  width: fit-content;\n  background: var(--color-dark-background);\n  border: 5px solid var(--color-dark-border);\n\n  display: grid !important;\n  grid-template-columns: repeat(6, 1fr);\n  grid-row-gap: 15px;\n}\n\n#colorPick * {\n  -webkit-transition: all linear 0.2s;\n  -moz-transition: all linear 0.2s;\n  -ms-transition: all linear 0.2s;\n  -o-transition: all linear 0.2s;\n  transition: all linear 0.2s;\n}\n\n#colorPick span {\n  font-size: 9pt;\n  text-transform: uppercase;\n  font-weight: bold;\n  color: #bbb;\n  margin-bottom: 5px;\n  display: block;\n  clear: both;\n}\n\n#copyright-notice {\n  font-family: var(--font-family);\n  position: absolute;\n  left: 0;\n  bottom: 12px;\n  width: 100%;\n  text-align: center;\n  font-size: 10px;\n  color: white;\n  pointer-events: none;\n  background: none;\n  z-index: 1000;\n  text-shadow:\n    1px 1px 0px rgba(0, 0, 0, 1),\n    1px 1px 0px #000;\n}\n\n#datetime {\n  font-size: 12px;\n  text-align: center;\n}\n\n#datetime-input {\n  position: absolute;\n  bottom: 10px;\n  display: none;\n  /* Invisible edit-time anchor that overlaps #datetime-text once opened; must never eat its clicks */\n  pointer-events: none;\n}\n\n#datetime-input-tb {\n  color: white;\n  font-family: 'Open Sans', sans-serif;\n\n  height: 0px !important;\n  margin: 0 0 55px 0 !important;\n}\n\n#datetime-input-tb:focus,\ninput:focus {\n  outline: none;\n}\n\n#datetime-text {\n  font-family: 'Roboto Mono', monospace;\n  font-size: 20px;\n  cursor: pointer;\n  border-width: 0px;\n}\n\n#datetime-title {\n  position: absolute;\n  left: 20px;\n  bottom: 20px;\n  width: 220px;\n  height: 30px;\n  background: transparent;\n  overflow: hidden;\n  text-align: center;\n  font-weight: bold;\n  font-size: 12px;\n}\n\n#down {\n  margin: 0px auto;\n}\n\n#editor-LS {\n  display: block !important;\n  background: steelblue;\n  height: 2em;\n}\n\n#editorForm div {\n  margin-top: 2em;\n}\n\n#editorForm label {\n  top: 20px;\n  font-size: 1em;\n}\n\n#es-error,\n#ms-error {\n  margin-top: 10px;\n  padding-bottom: 10px;\n  cursor: 'pointer';\n}\n\n#footer-handle {\n  width: 100%;\n  height: 5px;\n  top: 0px;\n\n  z-index: 2;\n  background-color: var(--color-dark-border) !important;\n}\n\n#footer-toggle-wrapper {\n  width: 100%;\n  z-index: 1;\n  position: relative;\n}\n\n#help-close {\n  position: absolute;\n  right: 15px;\n  top: 5px;\n  font-size: 2em;\n}\n\n#help-close:hover {\n  cursor: pointer;\n  color: var(--color-dark-text-accent);\n}\n\n#help-header {\n  font-size: 1.5em;\n}\n\n#help-inner-container {\n  margin: auto;\n  width: 100%;\n}\n\n#help-outer-container {\n  display: none;\n  background-color: rgba(0, 0, 0, 0.75);\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  z-index: 99;\n}\n\n#help-screen {\n  display: flex;\n  max-width: 80%;\n  max-height: 80%;\n  flex-shrink: 1;\n  position: relative;\n  inset: 10%;\n  z-index: 99;\n  border: 5px solid var(--color-dark-border);\n  text-align: center;\n  padding: 10px;\n  overflow: auto;\n  background: var(--color-dark-background);\n}\n\n#help-text {\n  display: block;\n  line-height: 20px;\n  text-align: left;\n}\n\n/* Rich (structured) help dialog content */\n#help-text .help-rich {\n  max-width: 840px;\n  margin: 0 auto;\n  line-height: 1.55;\n}\n\n#help-text .help-section {\n  margin: 0 0 20px;\n  text-align: left;\n}\n\n#help-text .help-section:last-child {\n  margin-bottom: 0;\n}\n\n#help-text .help-section-heading {\n  margin: 0 0 8px;\n  padding-bottom: 4px;\n  font-size: 1.15em;\n  font-weight: 500;\n  color: var(--color-dark-text-accent);\n  border-bottom: 1px solid var(--color-dark-border);\n}\n\n#help-text .help-section-content ol,\n#help-text .help-section-content ul {\n  margin: 8px 0 0;\n  padding-left: 28px;\n}\n\n#help-text .help-section-content ol li,\n#help-text .help-section-content ul li {\n  margin-bottom: 4px;\n  list-style-position: outside;\n}\n\n#help-text .help-section-content ol li {\n  list-style-type: decimal;\n}\n\n#help-text .help-section-content ul li {\n  list-style-type: disc;\n}\n\n#help-text .help-figure {\n  margin: 12px auto 0;\n  text-align: center;\n}\n\n#help-text .help-figure img {\n  max-width: 100%;\n  max-height: 45vh;\n  border: 1px solid var(--color-dark-border);\n  border-radius: 4px;\n}\n\n#help-text .help-figure figcaption {\n  margin-top: 4px;\n  font-size: 0.85em;\n  font-style: italic;\n  opacity: 0.75;\n}\n\n#help-text .help-tips {\n  padding: 10px 14px;\n  background: rgba(255, 255, 255, 0.05);\n  border-left: 3px solid var(--color-primary);\n  border-radius: 0 4px 4px 0;\n}\n\n#help-text .help-tips .help-section-heading {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n#help-text .help-tips-list {\n  margin: 0;\n  padding-left: 20px;\n}\n\n#help-text .help-tips-list li {\n  margin-bottom: 4px;\n  list-style-type: disc;\n  list-style-position: outside;\n}\n\n#help-text .help-shortcut-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 4px 0;\n}\n\n#help-text .help-shortcut-keys {\n  flex-shrink: 0;\n  min-width: 130px;\n}\n\n#help-text kbd {\n  padding: 1px 7px;\n  font-family: 'Roboto Mono', monospace;\n  font-size: 0.85em;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid var(--color-dark-border);\n  border-bottom-width: 2px;\n  border-radius: 4px;\n}\n\n#help-text .help-kbd-plus {\n  margin: 0 4px;\n  opacity: 0.7;\n}\n\n#jday {\n  font-family: 'Roboto Mono', monospace;\n  font-size: 20px;\n  padding: 0px 10px;\n  display: none;\n}\n\n#keeptrack-canvas {\n  background: var(--colorBlack);\n\n  position: absolute;\n  z-index: -1;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  touch-action: auto;\n}\n\n#keeptrack-root {\n  margin: 0;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n  overflow: hidden;\n  touch-action: none;\n  -webkit-overflow-scrolling: none;\n\n  overscroll-behavior: none;\n}\n\n#load-cover {\n  background: rgba(0, 0, 0, 0.8);\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n#loader {\n  background: var(--colorBlack);\n  cursor: default;\n  color: white;\n  position: absolute;\n  padding: 10px;\n  border-radius: 5px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  width: 250px;\n  height: 50px;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: auto;\n  text-align: center;\n}\n\n#logo-primary {\n  position: absolute;\n  top: calc(var(--top-menu-height) + 10px);\n  left: 10px;\n  height: auto;\n  width: 4vw;\n  z-index: 0;\n  max-width: 150px;\n  min-width: 70px;\n}\n\n#logo-primary img {\n  width: 100%;\n  height: 100%;\n}\n\n#logo-secondary {\n  position: absolute;\n  top: calc(var(--top-menu-height) + 10px);\n  left: calc(20px + max(4vw, 70px));\n  height: auto;\n  width: 4vw;\n  z-index: 0;\n  max-width: 150px;\n  min-width: 70px;\n}\n\n#logo-secondary img {\n  width: 100%;\n  height: 100%;\n}\n\n#lookangles-content td {\n  padding: 5px;\n  font-size: 13px;\n}\n\n#looks {\n  margin: 0 auto;\n}\n\n#map-sat {\n  display: block;\n  position: absolute;\n  z-index: 15;\n  width: 25px;\n  height: 25px;\n}\n\n#map-sensor {\n  display: none;\n  position: absolute;\n  z-index: 15;\n  width: 25px;\n  height: 25px;\n}\n\n#launch-calendar-table tbody tr td {\n  padding: 5px 5px;\n}\n\n#sat-hoverbox {\n  display: none;\n  background: var(--color-dark-background) !important;\n  cursor: default;\n  color: white;\n  position: absolute;\n  text-align: center;\n  padding: 10px;\n  border-radius: var(--kt-radius-md, 6px);\n  border: 1px solid var(--kt-border-default, rgba(255, 255, 255, 0.12));\n  box-shadow: var(--kt-shadow-lg, 0 4px 12px rgba(0, 0, 0, 0.4));\n  pointer-events: none;\n  z-index: 0;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  align-items: center;\n  row-gap: 10px;\n}\n\n#sensor-selected-container {\n  display: none;\n  width: 0px;\n  cursor: pointer;\n  padding: 0px;\n  transition: none;\n  -webkit-transition: none;\n}\n\n#sensor-selected-container:hover,\n#datetime-text:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n#toast-container {\n  min-width: 100%;\n  top: 75px;\n}\n\n#version-box {\n  background: transparent;\n  right: 10px;\n  width: 125px;\n}\n\n#version-text {\n  font-family: var(--font-family);\n  position: absolute;\n  left: 1rem;\n  top: 1rem;\n  width: 100%;\n  text-align: left;\n  font-size: 14px;\n  color: white;\n  pointer-events: none;\n  background: none;\n  z-index: 1000;\n  text-shadow:\n    0 0px 2px rgba(0, 0, 0, 1),\n    0 0px 2px #000;\n}\n\n::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.3);\n  border-radius: var(--kt-radius-full, 9999px);\n  border: 2px solid transparent;\n  background-clip: padding-box;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.55);\n  border: 2px solid transparent;\n  background-clip: padding-box;\n}\n\n::-webkit-scrollbar-thumb:active {\n  background: rgba(255, 255, 255, 0.7);\n  border: 2px solid transparent;\n  background-clip: padding-box;\n}\n\n::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: var(--kt-radius-full, 9999px);\n}\n\n::-webkit-scrollbar-corner {\n  background: transparent;\n}\n\n@keyframes shake {\n  0% {\n    filter: brightness(1.5);\n  }\n\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0);\n  }\n\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0);\n  }\n\n  100% {\n    filter: '';\n  }\n}\n\n/* non-desktop */\n@media (max-width: 1300px) {\n  .side-menu {\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n  }\n\n  .side-menu::-webkit-scrollbar {\n    display: none;\n  }\n}\n\na {\n  text-decoration: none;\n  color: var(--color-dark-text-accent) !important;\n}\n\n\n/* ========== Micro-Interactions & Focus ========== */\n\n/* Press feedback for all interactive elements */\n.drawer-item:active,\n.drawer-utility-icon:active,\n.bmenu-item .bmenu-item-inner:active,\n.search-result:active:not(.search-result-decayed) {\n  transform: scale(0.97);\n}\n\n/* Keyboard selected search result */\n.search-result--selected {\n  background: var(--kt-bg-active, rgba(255, 255, 255, 0.12));\n  outline: 1px solid var(--kt-border-strong, #616161);\n}\n\n/* Search result type badge */\n.search-type-badge {\n  display: inline-block;\n  padding: 1px 6px;\n  border-radius: var(--kt-radius-sm, 4px);\n  font-size: var(--kt-font-xs, 11px);\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  background: var(--kt-bg-surface, #424242);\n  color: var(--kt-text-secondary, rgba(255, 255, 255, 0.7));\n  margin-right: 8px;\n  /*\n   * Fixed width sized to the longest label (\"MISSILE\"/\"SENSOR\") so every badge\n   * is identical and the name column lines up across rows regardless of type.\n   */\n  width: 64px;\n  box-sizing: border-box;\n  text-align: center;\n  flex-shrink: 0;\n}\n\n/*\n * Right-hand column of a search result (sccNum / intl. designator for sats,\n * country for sensors and launch sites). Keep it on one line and right-aligned;\n * longer values (e.g. \"United States\") get an ellipsis instead of wrapping, and\n * the main name column shrinks to make room.\n */\n.search-result-scc {\n  flex-shrink: 0;\n  max-width: 45%;\n  margin-left: 8px;\n  text-align: right;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 0.9em;\n  color: var(--kt-text-secondary, rgba(255, 255, 255, 0.7));\n}\n\n/* Focus-visible for keyboard navigation */\n:focus-visible {\n  outline: 2px solid var(--kt-text-accent, #dd382f);\n  outline-offset: 2px;\n}\n\n:focus:not(:focus-visible) {\n  outline: none;\n}\n\n/* Custom focus for drawer items */\n.drawer-item:focus-visible {\n  outline: none;\n  background: var(--kt-bg-hover, rgba(255, 255, 255, 0.08));\n  box-shadow: inset 3px 0 0 var(--kt-text-accent, #dd382f);\n}\n\n/* Custom focus for utility icons */\n.drawer-utility-icon:focus-visible {\n  outline: none;\n  background: var(--kt-bg-hover, rgba(255, 255, 255, 0.08));\n  box-shadow: 0 0 0 2px var(--kt-text-accent, #dd382f);\n  border-radius: var(--kt-radius-sm, 4px);\n}\n\na,\n.link {\n  cursor: pointer;\n}\n\nfieldset {\n  display: block;\n  -webkit-margin-start: 0px;\n  -webkit-margin-end: 0px;\n  -webkit-padding-before: 0em;\n  -webkit-padding-start: 0em;\n  -webkit-padding-end: 0em;\n  -webkit-padding-after: 0em;\n  border: 0px;\n  border-image-source: initial;\n  border-image-slice: initial;\n  border-image-width: initial;\n  border-image-outset: initial;\n  border-image-repeat: initial;\n  min-width: -webkit-min-content;\n  padding: 25px 30px;\n}\n\nfooter {\n  padding-top: 5px !important;\n  position: absolute !important;\n  top: auto !important;\n  height: auto !important;\n  margin-top: -100px;\n  bottom: 0px;\n  width: 100%;\n}\n\ninput:-webkit-autofill {\n  -webkit-text-fill-color: white !important;\n  font-size: 16px;\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n  box-shadow: 0 0 0 30px var(--color-dark-background) inset !important;\n  -webkit-box-shadow: 0 0 0 30px var(--color-dark-background) inset !important;\n}\n\ninput[type='checkbox'].css-checkbox {\n  position: absolute;\n  z-index: -1000;\n  left: -1000px;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  width: 1px;\n  margin: -1px;\n  padding: 0;\n  border: 0;\n}\n\ninput[type='checkbox'].css-checkbox+label.css-label {\n  padding-left: 25px;\n  height: 20px;\n  display: inline-block;\n  line-height: 20px;\n  background-repeat: no-repeat;\n  background-position: 0px 0px;\n  font-size: 16px;\n  vertical-align: middle;\n  cursor: pointer;\n}\n\ninput[type='checkbox'].css-checkbox:checked+label.css-label {\n  background-position: 0px -20px;\n}\n\nlabel.css-label {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\nul {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n\nul li {\n  list-style: none;\n  padding: 5px;\n}\n\n#keeptrack-header {\n  position: absolute;\n  top: 0px;\n  width: 100%;\n  z-index: 105;\n}\n\n\n/* ========== Tooltip Popup ========== */\n\n.kt-tooltip-popup {\n  display: none;\n  position: absolute;\n  z-index: 999999;\n  max-width: 220px;\n  padding: var(--kt-space-2, 8px) var(--kt-space-3, 12px);\n  background: var(--kt-bg-elevated, #303030);\n  color: var(--kt-text-primary, #f5f5f5);\n  font-size: var(--kt-font-sm, 13px);\n  line-height: 1.4;\n  text-align: center;\n  border-radius: var(--kt-radius-md, 6px);\n  box-shadow: var(--kt-shadow-lg, 0 8px 24px rgba(0, 0, 0, 0.5));\n  border: 1px solid var(--kt-border-subtle, rgba(255, 255, 255, 0.05));\n  pointer-events: none;\n  opacity: 0;\n  transform: translateY(4px);\n  transition:\n    opacity var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1)),\n    transform var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n}\n\n.kt-tooltip-popup.kt-tooltip-measuring {\n  display: block;\n  visibility: hidden;\n  opacity: 0;\n}\n\n.kt-tooltip-popup.kt-tooltip-visible {\n  display: block;\n  opacity: 1;\n  transform: translateY(0);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
